
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("bneqI", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");











var $fULE8 = parcelRequire("fULE8");


var $hph5e = parcelRequire("hph5e");


var $hOFc9 = parcelRequire("hOFc9");


var $bVevd = parcelRequire("bVevd");


var $kSwu1 = parcelRequire("kSwu1");

const $99de71eb9e3e4411$var$EDIT_PAGE_CLOSE = 'edit-page/close';
const $99de71eb9e3e4411$var$EDIT_PAGE_PUBLISH = 'edit-page/publish';
const $99de71eb9e3e4411$export$6955bcca4cd3539f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(40);
    const { viewComponent: ViewComponent, editComponent: EditComponent } = props;
    let t0;
    if ($[0] !== props) {
        t0 = (0, $hph5e.parsePageProps)(props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let allowedFeatures;
    let draftShareId;
    let mode;
    let navigationPolicy;
    let passThroughProps;
    let showFooter;
    let spaceKey;
    if ($[2] !== t0) {
        ({ mode: mode, allowedFeatures: allowedFeatures, draftShareId: draftShareId, navigationPolicy: navigationPolicy, spaceKey: spaceKey, showFooter: showFooter, ...passThroughProps } = t0);
        $[2] = t0;
        $[3] = allowedFeatures;
        $[4] = draftShareId;
        $[5] = mode;
        $[6] = navigationPolicy;
        $[7] = passThroughProps;
        $[8] = showFooter;
        $[9] = spaceKey;
    } else {
        allowedFeatures = $[3];
        draftShareId = $[4];
        mode = $[5];
        navigationPolicy = $[6];
        passThroughProps = $[7];
        showFooter = $[8];
        spaceKey = $[9];
    }
    const { onModeChange: onModeChange } = props;
    const [currentMode, setCurrentMode] = (0, $cozmU.useState)(mode);
    let t1;
    let t2;
    if ($[10] !== mode) {
        t1 = ()=>{
            setCurrentMode(mode);
        };
        t2 = [
            mode
        ];
        $[10] = mode;
        $[11] = t1;
        $[12] = t2;
    } else {
        t1 = $[11];
        t2 = $[12];
    }
    (0, $cozmU.useEffect)(t1, t2);
    const [currentSpaceKey, setCurrentSpaceKey] = (0, $cozmU.useState)(spaceKey);
    let t3;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setCurrentMode((0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE);
        };
        $[13] = t3;
    } else t3 = $[13];
    const switchToViewPage = t3;
    let t4;
    if ($[14] !== currentMode || $[15] !== navigationPolicy || $[16] !== onModeChange || $[17] !== passThroughProps.contentId) {
        t4 = {
            navigate (url, modifiers, defaultNavigate) {
                if (currentMode === (0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE && (modifiers.routeName === "EDIT_PAGE_EMBED" || url?.includes("/edit-embed/") && passThroughProps.contentId === modifiers.contentId) && passThroughProps.contentId === modifiers.contentId) {
                    setCurrentMode((0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
                    onModeChange?.((0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
                    return;
                }
                return navigationPolicy?.navigate ? navigationPolicy.navigate(url, modifiers, defaultNavigate) : defaultNavigate(url, modifiers);
            },
            shimUrl: navigationPolicy?.shimUrl,
            domainNamesToReplace: navigationPolicy?.domainNamesToReplace,
            spaceKeyFilter: navigationPolicy?.spaceKeyFilter
        };
        $[14] = currentMode;
        $[15] = navigationPolicy;
        $[16] = onModeChange;
        $[17] = passThroughProps.contentId;
        $[18] = t4;
    } else t4 = $[18];
    const pageNavigationPolicy = t4;
    const experienceTracker = (0, $hOFc9.useExperienceTracker)();
    let t5;
    let t6;
    if ($[19] !== allowedFeatures.edit || $[20] !== draftShareId || $[21] !== experienceTracker || $[22] !== spaceKey) {
        t5 = ()=>experienceTracker.subscribe((event)=>{
                const { name: name, action: action, attributes: attributes } = event;
                const isClosingPublishedEditPage = !draftShareId && name === $99de71eb9e3e4411$var$EDIT_PAGE_CLOSE;
                const isPublishingDraft = name === $99de71eb9e3e4411$var$EDIT_PAGE_PUBLISH;
                if (action === "taskSuccess" && (isClosingPublishedEditPage || isPublishingDraft)) {
                    if (allowedFeatures.edit?.includes("publish-modal")) {
                        const newSpaceKey = attributes?.newSpaceKey;
                        setCurrentSpaceKey(newSpaceKey || spaceKey);
                    }
                    switchToViewPage();
                }
            });
        t6 = [
            draftShareId,
            experienceTracker,
            switchToViewPage,
            allowedFeatures.edit,
            spaceKey
        ];
        $[19] = allowedFeatures.edit;
        $[20] = draftShareId;
        $[21] = experienceTracker;
        $[22] = spaceKey;
        $[23] = t5;
        $[24] = t6;
    } else {
        t5 = $[23];
        t6 = $[24];
    }
    (0, $cozmU.useEffect)(t5, t6);
    const { locale: locale } = (0, $kSwu1.useIntl)();
    let t7;
    if ($[25] !== EditComponent || $[26] !== ViewComponent || $[27] !== allowedFeatures.edit || $[28] !== allowedFeatures.view || $[29] !== currentMode || $[30] !== currentSpaceKey || $[31] !== draftShareId || $[32] !== locale || $[33] !== pageNavigationPolicy || $[34] !== passThroughProps || $[35] !== showFooter) {
        t7 = currentMode === (0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ViewComponent, {
            navigationPolicy: pageNavigationPolicy,
            allowedFeatures: allowedFeatures.view,
            locale: locale,
            spaceKey: currentSpaceKey,
            showFooter: showFooter,
            ...passThroughProps
        }) : currentMode === (0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(EditComponent, {
            navigationPolicy: pageNavigationPolicy,
            allowedFeatures: allowedFeatures.edit,
            draftShareId: draftShareId,
            locale: locale,
            spaceKey: currentSpaceKey,
            ...passThroughProps
        }) : null;
        $[25] = EditComponent;
        $[26] = ViewComponent;
        $[27] = allowedFeatures.edit;
        $[28] = allowedFeatures.view;
        $[29] = currentMode;
        $[30] = currentSpaceKey;
        $[31] = draftShareId;
        $[32] = locale;
        $[33] = pageNavigationPolicy;
        $[34] = passThroughProps;
        $[35] = showFooter;
        $[36] = t7;
    } else t7 = $[36];
    let t8;
    if ($[37] !== experienceTracker || $[38] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fULE8.ExperienceTrackerContext).Provider, {
            value: experienceTracker
        }, t7);
        $[37] = experienceTracker;
        $[38] = t7;
        $[39] = t8;
    } else t8 = $[39];
    return t8;
} : (props)=>{
    const { viewComponent: ViewComponent, editComponent: EditComponent } = props;
    const { mode: mode, allowedFeatures: allowedFeatures, draftShareId: draftShareId, navigationPolicy: navigationPolicy, spaceKey: spaceKey, showFooter: showFooter, ...passThroughProps } = (0, $hph5e.parsePageProps)(props);
    const { onModeChange: onModeChange } = props;
    const [currentMode, setCurrentMode] = (0, $cozmU.useState)(mode);
    (0, $cozmU.useEffect)(()=>{
        setCurrentMode(mode);
    }, [
        mode
    ]);
    const [currentSpaceKey, setCurrentSpaceKey] = (0, $cozmU.useState)(spaceKey);
    const switchToViewPage = (0, $cozmU.useCallback)(()=>{
        setCurrentMode((0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE);
    }, [
        setCurrentMode
    ]);
    const pageNavigationPolicy = (0, $cozmU.useMemo)(()=>({
            navigate (url, modifiers, defaultNavigate) {
                /**
       * Below is for switching from View to Edit and we assume parent product doesn't have this situation in their navigationPolicy.
       */ if (currentMode === (0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE && (modifiers.routeName === 'EDIT_PAGE_EMBED' || url?.includes('/edit-embed/') && passThroughProps.contentId === modifiers.contentId) && passThroughProps.contentId === modifiers.contentId) {
                    setCurrentMode((0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
                    onModeChange?.((0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
                    return;
                }
                return navigationPolicy?.navigate ? navigationPolicy.navigate(url, modifiers, defaultNavigate) : defaultNavigate(url, modifiers);
            },
            shimUrl: navigationPolicy?.shimUrl,
            domainNamesToReplace: navigationPolicy?.domainNamesToReplace,
            spaceKeyFilter: navigationPolicy?.spaceKeyFilter
        }), [
        currentMode,
        passThroughProps.contentId,
        navigationPolicy,
        onModeChange
    ]);
    const experienceTracker = (0, $hOFc9.useExperienceTracker)();
    (0, $cozmU.useEffect)(()=>experienceTracker.subscribe((event)=>{
            const { name: name, action: action, attributes: attributes } = event;
            /**
     * Using experienceTracker, we can switch from Edit to View page.
     * 1. When the user clicks the Publish button and task success, it can switch to the View page.
     *    a. If the `publish-modal` is added to the allowedFeatures, the Publish Modal may be used to
     *          change the spaceKey during publish.
     *          In that case, a new spaceKey will be added to the success event and tracked here.
     * 2. If the page is not unpublished draft, when the user clicks Close button and task success, it can switch to the View page.
     */ const isClosingPublishedEditPage = !draftShareId && name === $99de71eb9e3e4411$var$EDIT_PAGE_CLOSE;
            const isPublishingDraft = name === $99de71eb9e3e4411$var$EDIT_PAGE_PUBLISH;
            if (action === 'taskSuccess' && (isClosingPublishedEditPage || isPublishingDraft)) {
                if (allowedFeatures.edit?.includes('publish-modal')) {
                    const newSpaceKey = attributes?.newSpaceKey;
                    setCurrentSpaceKey(newSpaceKey || spaceKey);
                }
                switchToViewPage();
            }
        }), [
        draftShareId,
        experienceTracker,
        switchToViewPage,
        allowedFeatures.edit,
        spaceKey
    ]);
    const { locale: locale } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fULE8.ExperienceTrackerContext).Provider, {
        value: experienceTracker
    }, currentMode === (0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ViewComponent, {
        navigationPolicy: pageNavigationPolicy,
        allowedFeatures: allowedFeatures.view,
        locale: locale,
        spaceKey: currentSpaceKey,
        showFooter: showFooter,
        ...passThroughProps
    }) : currentMode === (0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(EditComponent, {
        navigationPolicy: pageNavigationPolicy,
        allowedFeatures: allowedFeatures.edit,
        draftShareId: draftShareId,
        locale: locale,
        spaceKey: currentSpaceKey,
        ...passThroughProps
    }) : null);
};



var $eRLgK = parcelRequire("eRLgK");


var $cuq2s = parcelRequire("cuq2s");


var $eBMyn = parcelRequire("eBMyn");

const $a83ee9f63a3123bb$export$6955bcca4cd3539f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(6);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eRLgK.PageNotFoundEmptyState), null);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: t0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $99de71eb9e3e4411$export$6955bcca4cd3539f), props));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== props.locale || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cuq2s.I18nProvider), {
            locale: props.locale,
            fetchTranslations: (0, $eBMyn.default)
        }, t1);
        $[3] = props.locale;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cuq2s.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $eBMyn.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eRLgK.PageNotFoundEmptyState), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $99de71eb9e3e4411$export$6955bcca4cd3539f), props)));
module.exports["Page"] = $a83ee9f63a3123bb$export$6955bcca4cd3539f;

});

parcelRegister("fULE8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $1ab2dc8fa18785f7$export$a7b0697657ed8bd0 = (0, $cozmU.createContext)({
    abort () {},
    fail () {},
    start () {},
    succeed () {},
    stopOnError () {},
    subscribe () {
        return ()=>{};
    },
    updateAttributes () {}
});
module.exports["ExperienceTrackerContext"] = $1ab2dc8fa18785f7$export$a7b0697657ed8bd0;

});

parcelRegister("hph5e", function(module, exports) {



var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $f4me1 = parcelRequire("f4me1");

function $33761f973d53d162$var$_extends() {
    $33761f973d53d162$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $33761f973d53d162$var$_extends.apply(this, arguments);
} // Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $33761f973d53d162$export$3add0d5dce533e2e = /*#__PURE__*/ $cozmU.createContext(null);
const $33761f973d53d162$export$145dfa71566a64dc = /*#__PURE__*/ $cozmU.createContext(null);
const $33761f973d53d162$var$AwaitContext = /*#__PURE__*/ $cozmU.createContext(null);
const $33761f973d53d162$export$26749e8557646306 = /*#__PURE__*/ $cozmU.createContext(null);
const $33761f973d53d162$export$c7914228fb69b0f5 = /*#__PURE__*/ $cozmU.createContext(null);
const $33761f973d53d162$export$9072aa6dd1f93057 = /*#__PURE__*/ $cozmU.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $33761f973d53d162$var$RouteErrorContext = /*#__PURE__*/ $cozmU.createContext(null);
const $33761f973d53d162$export$b66bb29c5006f12f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useHref(to, _temp) {
    const $ = (0, $bDgLe.c)(10);
    let t0;
    if ($[0] !== _temp) {
        t0 = _temp === void 0 ? {} : _temp;
        $[0] = _temp;
        $[1] = t0;
    } else t0 = $[1];
    const { relative: relative } = t0;
    !$33761f973d53d162$export$9c954a9d03d32f4a() && (0, $f4me1.UNSAFE_invariant)(false);
    const { basename: basename, navigator: navigator } = $cozmU.useContext($33761f973d53d162$export$26749e8557646306);
    let t1;
    if ($[2] !== relative) {
        t1 = {
            relative: relative
        };
        $[2] = relative;
        $[3] = t1;
    } else t1 = $[3];
    const { hash: hash, pathname: pathname, search: search } = $33761f973d53d162$export$e75d2a2d1b3c245b(to, t1);
    let t2;
    if ($[4] !== basename || $[5] !== hash || $[6] !== navigator || $[7] !== pathname || $[8] !== search) {
        let joinedPathname = pathname;
        if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $f4me1.joinPaths)([
            basename,
            pathname
        ]);
        t2 = navigator.createHref({
            pathname: joinedPathname,
            search: search,
            hash: hash
        });
        $[4] = basename;
        $[5] = hash;
        $[6] = navigator;
        $[7] = pathname;
        $[8] = search;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
} : function useHref(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$33761f973d53d162$export$9c954a9d03d32f4a() && (0, $f4me1.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $cozmU.useContext($33761f973d53d162$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $33761f973d53d162$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $f4me1.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
};
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ const $33761f973d53d162$export$9c954a9d03d32f4a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useInRouterContext() {
    return $cozmU.useContext($33761f973d53d162$export$c7914228fb69b0f5) != null;
} : function useInRouterContext() {
    return $cozmU.useContext($33761f973d53d162$export$c7914228fb69b0f5) != null;
};
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ const $33761f973d53d162$export$45d76561a5302f2b = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useLocation() {
    !$33761f973d53d162$export$9c954a9d03d32f4a() && (0, $f4me1.UNSAFE_invariant)(false);
    return $cozmU.useContext($33761f973d53d162$export$c7914228fb69b0f5).location;
} : function useLocation() {
    !$33761f973d53d162$export$9c954a9d03d32f4a() && (0, $f4me1.UNSAFE_invariant)(false);
    return $cozmU.useContext($33761f973d53d162$export$c7914228fb69b0f5).location;
};
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ const $33761f973d53d162$export$1b3f31771c5d07c = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useNavigationType() {
    return $cozmU.useContext($33761f973d53d162$export$c7914228fb69b0f5).navigationType;
} : function useNavigationType() {
    return $cozmU.useContext($33761f973d53d162$export$c7914228fb69b0f5).navigationType;
};
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ const $33761f973d53d162$export$6c330e8992e8a295 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useMatch(pattern) {
    const $ = (0, $bDgLe.c)(3);
    !$33761f973d53d162$export$9c954a9d03d32f4a() && (0, $f4me1.UNSAFE_invariant)(false);
    const { pathname: pathname } = $33761f973d53d162$export$45d76561a5302f2b();
    let t0;
    if ($[0] !== pathname || $[1] !== pattern) {
        t0 = (0, $f4me1.matchPath)(pattern, (0, $f4me1.UNSAFE_decodePath)(pathname));
        $[0] = pathname;
        $[1] = pattern;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : function useMatch(pattern) {
    !$33761f973d53d162$export$9c954a9d03d32f4a() && (0, $f4me1.UNSAFE_invariant)(false);
    let { pathname: pathname } = $33761f973d53d162$export$45d76561a5302f2b();
    return $cozmU.useMemo(()=>(0, $f4me1.matchPath)(pattern, (0, $f4me1.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
};
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $33761f973d53d162$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $33761f973d53d162$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $cozmU.useContext($33761f973d53d162$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $cozmU.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $33761f973d53d162$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $cozmU.useContext($33761f973d53d162$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $33761f973d53d162$var$useNavigateStable() : $33761f973d53d162$var$useNavigateUnstable();
}
const $33761f973d53d162$var$useNavigateUnstable = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useNavigateUnstable() {
    const $ = (0, $bDgLe.c)(10);
    !$33761f973d53d162$export$9c954a9d03d32f4a() && (0, $f4me1.UNSAFE_invariant)(false);
    const dataRouterContext = $cozmU.useContext($33761f973d53d162$export$3add0d5dce533e2e);
    const { basename: basename, future: future, navigator: navigator } = $cozmU.useContext($33761f973d53d162$export$26749e8557646306);
    const { matches: matches } = $cozmU.useContext($33761f973d53d162$export$9072aa6dd1f93057);
    const { pathname: locationPathname } = $33761f973d53d162$export$45d76561a5302f2b();
    let t0;
    if ($[0] !== future.v7_relativeSplatPath || $[1] !== matches) {
        t0 = JSON.stringify((0, $f4me1.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
        $[0] = future.v7_relativeSplatPath;
        $[1] = matches;
        $[2] = t0;
    } else t0 = $[2];
    const routePathnamesJson = t0;
    const activeRef = $cozmU.useRef(false);
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            activeRef.current = true;
        };
        $[3] = t1;
    } else t1 = $[3];
    $33761f973d53d162$var$useIsomorphicLayoutEffect(t1);
    let t2;
    if ($[4] !== basename || $[5] !== dataRouterContext || $[6] !== locationPathname || $[7] !== navigator || $[8] !== routePathnamesJson) {
        t2 = function(to, options) {
            if (options === void 0) options = {};
            if (!activeRef.current) return;
            if (typeof to === "number") {
                navigator.go(to);
                return;
            }
            const path = (0, $f4me1.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
            if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $f4me1.joinPaths)([
                basename,
                path.pathname
            ]);
            (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
        };
        $[4] = basename;
        $[5] = dataRouterContext;
        $[6] = locationPathname;
        $[7] = navigator;
        $[8] = routePathnamesJson;
        $[9] = t2;
    } else t2 = $[9];
    const navigate = t2;
    return navigate;
} : function useNavigateUnstable() {
    !$33761f973d53d162$export$9c954a9d03d32f4a() && (0, $f4me1.UNSAFE_invariant)(false);
    let dataRouterContext = $cozmU.useContext($33761f973d53d162$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $cozmU.useContext($33761f973d53d162$export$26749e8557646306);
    let { matches: matches } = $cozmU.useContext($33761f973d53d162$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $33761f973d53d162$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $f4me1.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $cozmU.useRef(false);
    $33761f973d53d162$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $cozmU.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $f4me1.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $f4me1.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
};
const $33761f973d53d162$var$OutletContext = /*#__PURE__*/ $cozmU.createContext(null); /**
                            * Returns the context (if provided) for the child route at this level of the route
                            * hierarchy.
                            * @see https://reactrouter.com/v6/hooks/use-outlet-context
                            */ 
const $33761f973d53d162$export$4138103a3ae699cc = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useOutletContext() {
    return $cozmU.useContext($33761f973d53d162$var$OutletContext);
} : function useOutletContext() {
    return $cozmU.useContext($33761f973d53d162$var$OutletContext);
};
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ const $33761f973d53d162$export$a3be3530d8e40d0b = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useOutlet(context) {
    const $ = (0, $bDgLe.c)(5);
    const outlet = $cozmU.useContext($33761f973d53d162$export$9072aa6dd1f93057).outlet;
    if (outlet) {
        let t0;
        if ($[0] !== context || $[1] !== outlet) {
            let t1;
            if ($[3] !== context) {
                t1 = {
                    value: context
                };
                $[3] = context;
                $[4] = t1;
            } else t1 = $[4];
            t0 = $cozmU.createElement($33761f973d53d162$var$OutletContext.Provider, t1, outlet);
            $[0] = context;
            $[1] = outlet;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    }
    return outlet;
} : function useOutlet(context) {
    let outlet = $cozmU.useContext($33761f973d53d162$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $cozmU.createElement($33761f973d53d162$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
};
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ const $33761f973d53d162$export$99eaa27ddbbb95ef = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useParams() {
    const $ = (0, $bDgLe.c)(2);
    const { matches: matches } = $cozmU.useContext($33761f973d53d162$export$9072aa6dd1f93057);
    const routeMatch = matches[matches.length - 1];
    let t0;
    if ($[0] !== routeMatch) {
        t0 = routeMatch ? routeMatch.params : {};
        $[0] = routeMatch;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useParams() {
    let { matches: matches } = $cozmU.useContext($33761f973d53d162$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
};
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ const $33761f973d53d162$export$e75d2a2d1b3c245b = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useResolvedPath(to, _temp2) {
    const $ = (0, $bDgLe.c)(10);
    let t0;
    if ($[0] !== _temp2) {
        t0 = _temp2 === void 0 ? {} : _temp2;
        $[0] = _temp2;
        $[1] = t0;
    } else t0 = $[1];
    const { relative: relative } = t0;
    const { future: future } = $cozmU.useContext($33761f973d53d162$export$26749e8557646306);
    const { matches: matches } = $cozmU.useContext($33761f973d53d162$export$9072aa6dd1f93057);
    const { pathname: locationPathname } = $33761f973d53d162$export$45d76561a5302f2b();
    let t1;
    if ($[2] !== future.v7_relativeSplatPath || $[3] !== matches) {
        t1 = JSON.stringify((0, $f4me1.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
        $[2] = future.v7_relativeSplatPath;
        $[3] = matches;
        $[4] = t1;
    } else t1 = $[4];
    const routePathnamesJson = t1;
    let t2;
    if ($[5] !== locationPathname || $[6] !== relative || $[7] !== routePathnamesJson || $[8] !== to) {
        t2 = (0, $f4me1.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
        $[5] = locationPathname;
        $[6] = relative;
        $[7] = routePathnamesJson;
        $[8] = to;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
} : function useResolvedPath(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $cozmU.useContext($33761f973d53d162$export$26749e8557646306);
    let { matches: matches } = $cozmU.useContext($33761f973d53d162$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $33761f973d53d162$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $f4me1.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $cozmU.useMemo(()=>(0, $f4me1.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
};
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ const $33761f973d53d162$export$5d3fca4a98652595 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useRoutes(routes, locationArg) {
    return $33761f973d53d162$export$5fcee62552a12fbf(routes, locationArg);
} : function useRoutes(routes, locationArg) {
    return $33761f973d53d162$export$5fcee62552a12fbf(routes, locationArg);
}; // Internal implementation with accept optional param for RouterProvider usage
function $33761f973d53d162$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$33761f973d53d162$export$9c954a9d03d32f4a() && (0, $f4me1.UNSAFE_invariant)(false);
    let { navigator: navigator } = $cozmU.useContext($33761f973d53d162$export$26749e8557646306);
    let { matches: parentMatches } = $cozmU.useContext($33761f973d53d162$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $33761f973d53d162$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $f4me1.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $f4me1.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $f4me1.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $33761f973d53d162$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $f4me1.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $f4me1.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future); // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $cozmU.createElement($33761f973d53d162$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $33761f973d53d162$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $f4me1.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
const $33761f973d53d162$var$DefaultErrorComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DefaultErrorComponent() {
    const $ = (0, $bDgLe.c)(14);
    const error = $33761f973d53d162$export$ed527bf60f6e05f2();
    let t0;
    if ($[0] !== error) {
        t0 = (0, $f4me1.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
        $[0] = error;
        $[1] = t0;
    } else t0 = $[1];
    const message = t0;
    const stack = error instanceof Error ? error.stack : null;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            padding: "0.5rem",
            backgroundColor: "rgba(200,200,200, 0.5)"
        };
        $[2] = t1;
    } else t1 = $[2];
    const preStyles = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            padding: "2px 4px",
            backgroundColor: "rgba(200,200,200, 0.5)"
        };
        $[3] = t2;
    } else t2 = $[3];
    const codeStyles = t2;
    let devInfo = null;
    let t3;
    if ($[5] !== message || $[6] !== stack) {
        let t4;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = $cozmU.createElement("h2", null, "Unexpected Application Error!");
            $[8] = t4;
        } else t4 = $[8];
        let t5;
        if ($[9] !== message) {
            let t6;
            if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
                t6 = {
                    style: {
                        fontStyle: "italic"
                    }
                };
                $[11] = t6;
            } else t6 = $[11];
            t5 = $cozmU.createElement("h3", t6, message);
            $[9] = message;
            $[10] = t5;
        } else t5 = $[10];
        let t6;
        if ($[12] !== stack) {
            t6 = stack ? $cozmU.createElement("pre", {
                style: preStyles
            }, stack) : null;
            $[12] = stack;
            $[13] = t6;
        } else t6 = $[13];
        t3 = $cozmU.createElement($cozmU.Fragment, null, t4, t5, t6, devInfo);
        $[5] = message;
        $[6] = stack;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : function DefaultErrorComponent() {
    let error = $33761f973d53d162$export$ed527bf60f6e05f2();
    let message = (0, $f4me1.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $cozmU.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $cozmU.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
};
const $33761f973d53d162$var$defaultErrorElement = /*#__PURE__*/ $cozmU.createElement($33761f973d53d162$var$DefaultErrorComponent, null);
class $33761f973d53d162$var$RenderErrorBoundary extends $cozmU.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
         // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $cozmU.createElement($33761f973d53d162$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $cozmU.createElement($33761f973d53d162$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function $33761f973d53d162$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $cozmU.useContext($33761f973d53d162$export$3add0d5dce533e2e); // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $cozmU.createElement($33761f973d53d162$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $33761f973d53d162$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches; // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $f4me1.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    } // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i]; // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $33761f973d53d162$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $33761f973d53d162$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $cozmU.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $cozmU.createElement($33761f973d53d162$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        }; // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $cozmU.createElement($33761f973d53d162$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $33761f973d53d162$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($33761f973d53d162$var$DataRouterHook || {});
var $33761f973d53d162$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($33761f973d53d162$var$DataRouterStateHook || {});
function $33761f973d53d162$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
const $33761f973d53d162$var$useDataRouterContext = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useDataRouterContext(hookName) {
    const ctx = $cozmU.useContext($33761f973d53d162$export$3add0d5dce533e2e);
    !ctx && (0, $f4me1.UNSAFE_invariant)(false);
    return ctx;
} : function useDataRouterContext(hookName) {
    let ctx = $cozmU.useContext($33761f973d53d162$export$3add0d5dce533e2e);
    !ctx && (0, $f4me1.UNSAFE_invariant)(false);
    return ctx;
};
const $33761f973d53d162$var$useDataRouterState = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useDataRouterState(hookName) {
    const state = $cozmU.useContext($33761f973d53d162$export$145dfa71566a64dc);
    !state && (0, $f4me1.UNSAFE_invariant)(false);
    return state;
} : function useDataRouterState(hookName) {
    let state = $cozmU.useContext($33761f973d53d162$export$145dfa71566a64dc);
    !state && (0, $f4me1.UNSAFE_invariant)(false);
    return state;
};
const $33761f973d53d162$var$useRouteContext = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useRouteContext(hookName) {
    const route = $cozmU.useContext($33761f973d53d162$export$9072aa6dd1f93057);
    !route && (0, $f4me1.UNSAFE_invariant)(false);
    return route;
} : function useRouteContext(hookName) {
    let route = $cozmU.useContext($33761f973d53d162$export$9072aa6dd1f93057);
    !route && (0, $f4me1.UNSAFE_invariant)(false);
    return route;
}; // Internal version with hookName-aware debugging
const $33761f973d53d162$var$useCurrentRouteId = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useCurrentRouteId(hookName) {
    const route = $33761f973d53d162$var$useRouteContext(hookName);
    const thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $f4me1.UNSAFE_invariant)(false);
    return thisRoute.route.id;
} : function useCurrentRouteId(hookName) {
    let route = $33761f973d53d162$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $f4me1.UNSAFE_invariant)(false);
    return thisRoute.route.id;
};
/**
 * Returns the ID for the nearest contextual route
 */ const $33761f973d53d162$export$5fc8298006ad9e58 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useRouteId() {
    return $33761f973d53d162$var$useCurrentRouteId($33761f973d53d162$var$DataRouterStateHook.UseRouteId);
} : function useRouteId() {
    return $33761f973d53d162$var$useCurrentRouteId($33761f973d53d162$var$DataRouterStateHook.UseRouteId);
};
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ const $33761f973d53d162$export$d0fd4b7106de2769 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useNavigation() {
    const state = $33761f973d53d162$var$useDataRouterState($33761f973d53d162$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
} : function useNavigation() {
    let state = $33761f973d53d162$var$useDataRouterState($33761f973d53d162$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
};
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ const $33761f973d53d162$export$600dc272ed516c15 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useRevalidator() {
    const $ = (0, $bDgLe.c)(3);
    const dataRouterContext = $33761f973d53d162$var$useDataRouterContext($33761f973d53d162$var$DataRouterHook.UseRevalidator);
    const state = $33761f973d53d162$var$useDataRouterState($33761f973d53d162$var$DataRouterStateHook.UseRevalidator);
    let t0;
    if ($[0] !== dataRouterContext.router.revalidate || $[1] !== state.revalidation) {
        t0 = {
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        };
        $[0] = dataRouterContext.router.revalidate;
        $[1] = state.revalidation;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : function useRevalidator() {
    let dataRouterContext = $33761f973d53d162$var$useDataRouterContext($33761f973d53d162$var$DataRouterHook.UseRevalidator);
    let state = $33761f973d53d162$var$useDataRouterState($33761f973d53d162$var$DataRouterStateHook.UseRevalidator);
    return $cozmU.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
};
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ const $33761f973d53d162$export$2378eb7f5ff86053 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useMatches() {
    const $ = (0, $bDgLe.c)(5);
    const { matches: matches, loaderData: loaderData } = $33761f973d53d162$var$useDataRouterState($33761f973d53d162$var$DataRouterStateHook.UseMatches);
    let t0;
    if ($[0] !== loaderData || $[1] !== matches) {
        let t1;
        if ($[3] !== loaderData) {
            t1 = (m)=>(0, $f4me1.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData);
            $[3] = loaderData;
            $[4] = t1;
        } else t1 = $[4];
        t0 = matches.map(t1);
        $[0] = loaderData;
        $[1] = matches;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : function useMatches() {
    let { matches: matches, loaderData: loaderData } = $33761f973d53d162$var$useDataRouterState($33761f973d53d162$var$DataRouterStateHook.UseMatches);
    return $cozmU.useMemo(()=>matches.map((m)=>(0, $f4me1.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
};
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ const $33761f973d53d162$export$1448a5050d252c4d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useLoaderData() {
    const state = $33761f973d53d162$var$useDataRouterState($33761f973d53d162$var$DataRouterStateHook.UseLoaderData);
    const routeId = $33761f973d53d162$var$useCurrentRouteId($33761f973d53d162$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return;
    }
    return state.loaderData[routeId];
} : function useLoaderData() {
    let state = $33761f973d53d162$var$useDataRouterState($33761f973d53d162$var$DataRouterStateHook.UseLoaderData);
    let routeId = $33761f973d53d162$var$useCurrentRouteId($33761f973d53d162$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
};
/**
 * Returns the loaderData for the given routeId
 */ const $33761f973d53d162$export$fd5d37484eab868d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useRouteLoaderData(routeId) {
    const state = $33761f973d53d162$var$useDataRouterState($33761f973d53d162$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
} : function useRouteLoaderData(routeId) {
    let state = $33761f973d53d162$var$useDataRouterState($33761f973d53d162$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
};
/**
 * Returns the action data for the nearest ancestor Route action
 */ const $33761f973d53d162$export$fdc00f3f26066d5e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useActionData() {
    const state = $33761f973d53d162$var$useDataRouterState($33761f973d53d162$var$DataRouterStateHook.UseActionData);
    const routeId = $33761f973d53d162$var$useCurrentRouteId($33761f973d53d162$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
} : function useActionData() {
    let state = $33761f973d53d162$var$useDataRouterState($33761f973d53d162$var$DataRouterStateHook.UseActionData);
    let routeId = $33761f973d53d162$var$useCurrentRouteId($33761f973d53d162$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
};
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $33761f973d53d162$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $cozmU.useContext($33761f973d53d162$var$RouteErrorContext);
    let state = $33761f973d53d162$var$useDataRouterState($33761f973d53d162$var$DataRouterStateHook.UseRouteError);
    let routeId = $33761f973d53d162$var$useCurrentRouteId($33761f973d53d162$var$DataRouterStateHook.UseRouteError); // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
     // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
} /**
   * Returns the happy-path data from the nearest ancestor `<Await />` value
   */ 
const $33761f973d53d162$export$78a72ddb39bdd145 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useAsyncValue() {
    const value = $cozmU.useContext($33761f973d53d162$var$AwaitContext);
    return value == null ? void 0 : value._data;
} : function useAsyncValue() {
    let value = $cozmU.useContext($33761f973d53d162$var$AwaitContext);
    return value == null ? void 0 : value._data;
};
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ const $33761f973d53d162$export$17f53340677d5831 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useAsyncError() {
    const value = $cozmU.useContext($33761f973d53d162$var$AwaitContext);
    return value == null ? void 0 : value._error;
} : function useAsyncError() {
    let value = $cozmU.useContext($33761f973d53d162$var$AwaitContext);
    return value == null ? void 0 : value._error;
};
let $33761f973d53d162$var$blockerId = 0; /**
                    * Allow the application to block navigations within the SPA and present the
                    * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
                    * using half-filled form data.  This does not handle hard-reloads or
                    * cross-origin navigations.
                    */ 
function $33761f973d53d162$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $33761f973d53d162$var$useDataRouterContext($33761f973d53d162$var$DataRouterHook.UseBlocker);
    let state = $33761f973d53d162$var$useDataRouterState($33761f973d53d162$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $cozmU.useState("");
    let blockerFunction = $cozmU.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
         // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $33761f973d53d162$var$_extends({}, currentLocation, {
                pathname: (0, $f4me1.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $33761f973d53d162$var$_extends({}, nextLocation, {
                pathname: (0, $f4me1.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]); // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $cozmU.useEffect(()=>{
        let key = String(++$33761f973d53d162$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]); // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $cozmU.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]); // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $f4me1.IDLE_BLOCKER);
} /**
   * Stable version of useNavigate that is used when we are in the context of
   * a RouterProvider.
   */ 
const $33761f973d53d162$var$useNavigateStable = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useNavigateStable() {
    const $ = (0, $bDgLe.c)(4);
    const { router: router } = $33761f973d53d162$var$useDataRouterContext($33761f973d53d162$var$DataRouterHook.UseNavigateStable);
    const id = $33761f973d53d162$var$useCurrentRouteId($33761f973d53d162$var$DataRouterStateHook.UseNavigateStable);
    const activeRef = $cozmU.useRef(false);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            activeRef.current = true;
        };
        $[0] = t0;
    } else t0 = $[0];
    $33761f973d53d162$var$useIsomorphicLayoutEffect(t0);
    let t1;
    if ($[1] !== id || $[2] !== router) {
        t1 = function(to, options) {
            if (options === void 0) options = {};
            if (!activeRef.current) return;
            if (typeof to === "number") router.navigate(to);
            else router.navigate(to, $33761f973d53d162$var$_extends({
                fromRouteId: id
            }, options));
        };
        $[1] = id;
        $[2] = router;
        $[3] = t1;
    } else t1 = $[3];
    const navigate = t1;
    return navigate;
} : function useNavigateStable() {
    let { router: router } = $33761f973d53d162$var$useDataRouterContext($33761f973d53d162$var$DataRouterHook.UseNavigateStable);
    let id = $33761f973d53d162$var$useCurrentRouteId($33761f973d53d162$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $cozmU.useRef(false);
    $33761f973d53d162$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $cozmU.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $33761f973d53d162$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
};
const $33761f973d53d162$var$alreadyWarned$1 = {};
function $33761f973d53d162$var$warningOnce(key, cond, message) {
    if (!cond && !$33761f973d53d162$var$alreadyWarned$1[key]) $33761f973d53d162$var$alreadyWarned$1[key] = true;
}
const $33761f973d53d162$var$alreadyWarned = {};
function $33761f973d53d162$var$warnOnce(key, message) {}
const $33761f973d53d162$var$logDeprecation = (flag, msg, link)=>$33761f973d53d162$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $33761f973d53d162$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $33761f973d53d162$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $33761f973d53d162$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $33761f973d53d162$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $33761f973d53d162$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $33761f973d53d162$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $33761f973d53d162$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $33761f973d53d162$var$START_TRANSITION = "startTransition";
const $33761f973d53d162$var$startTransitionImpl = $cozmU[$33761f973d53d162$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $33761f973d53d162$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $cozmU.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $cozmU.useCallback((newState)=>{
        if (v7_startTransition && $33761f973d53d162$var$startTransitionImpl) $33761f973d53d162$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $cozmU.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $cozmU.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $cozmU.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $cozmU.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $cozmU.useEffect(()=>$33761f973d53d162$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement($33761f973d53d162$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $cozmU.createElement($33761f973d53d162$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $cozmU.createElement($33761f973d53d162$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $cozmU.createElement($33761f973d53d162$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
const $33761f973d53d162$var$DataRoutes = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DataRoutes(_ref2) {
    const { routes: routes, future: future, state: state } = _ref2;
    return $33761f973d53d162$export$5fcee62552a12fbf(routes, undefined, state, future);
} : function DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $33761f973d53d162$export$5fcee62552a12fbf(routes, undefined, state, future);
};
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $33761f973d53d162$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $cozmU.useRef();
    if (historyRef.current == null) historyRef.current = (0, $f4me1.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $cozmU.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $cozmU.useCallback((newState)=>{
        v7_startTransition && $33761f973d53d162$var$startTransitionImpl ? $33761f973d53d162$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $cozmU.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $cozmU.useEffect(()=>$33761f973d53d162$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $cozmU.createElement($33761f973d53d162$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ const $33761f973d53d162$export$444b3ab0cb9aec40 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Navigate(_ref4) {
    const $ = (0, $bDgLe.c)(13);
    const { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$33761f973d53d162$export$9c954a9d03d32f4a() && (0, $f4me1.UNSAFE_invariant)(false);
    const { future: future, static: isStatic } = $cozmU.useContext($33761f973d53d162$export$26749e8557646306);
    const { matches: matches } = $cozmU.useContext($33761f973d53d162$export$9072aa6dd1f93057);
    const { pathname: locationPathname } = $33761f973d53d162$export$45d76561a5302f2b();
    const navigate = $33761f973d53d162$export$9770f232ac06a008();
    let t0;
    if ($[0] !== future.v7_relativeSplatPath || $[1] !== locationPathname || $[2] !== matches || $[3] !== relative || $[4] !== to) {
        const path = (0, $f4me1.resolveTo)(to, (0, $f4me1.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
        t0 = JSON.stringify(path);
        $[0] = future.v7_relativeSplatPath;
        $[1] = locationPathname;
        $[2] = matches;
        $[3] = relative;
        $[4] = to;
        $[5] = t0;
    } else t0 = $[5];
    const jsonPath = t0;
    let t1;
    let t2;
    if ($[6] !== jsonPath || $[7] !== navigate || $[8] !== relative || $[9] !== replace || $[10] !== state) {
        t1 = ()=>navigate(JSON.parse(jsonPath), {
                replace: replace,
                state: state,
                relative: relative
            });
        t2 = [
            navigate,
            jsonPath,
            relative,
            replace,
            state
        ];
        $[6] = jsonPath;
        $[7] = navigate;
        $[8] = relative;
        $[9] = replace;
        $[10] = state;
        $[11] = t1;
        $[12] = t2;
    } else {
        t1 = $[11];
        t2 = $[12];
    }
    $cozmU.useEffect(t1, t2);
    return null;
} : function Navigate(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$33761f973d53d162$export$9c954a9d03d32f4a() && (0, $f4me1.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $cozmU.useContext($33761f973d53d162$export$26749e8557646306);
    let { matches: matches } = $cozmU.useContext($33761f973d53d162$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $33761f973d53d162$export$45d76561a5302f2b();
    let navigate = $33761f973d53d162$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $f4me1.resolveTo)(to, (0, $f4me1.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $cozmU.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
};
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ const $33761f973d53d162$export$910ae8079b2c2852 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Outlet(props) {
    return $33761f973d53d162$export$a3be3530d8e40d0b(props.context);
} : function Outlet(props) {
    return $33761f973d53d162$export$a3be3530d8e40d0b(props.context);
};
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $33761f973d53d162$export$e7b0ac011bb776c6(_props) {
    (0, $f4me1.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ const $33761f973d53d162$export$55185c17a0fcbe46 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Router(_ref5) {
    const $ = (0, $bDgLe.c)(31);
    let { basename: t0, children: t1, location: locationProp, navigationType: t2, navigator: navigator, static: t3, future: future } = _ref5;
    const basenameProp = t0 === undefined ? "/" : t0;
    const children = t1 === undefined ? null : t1;
    const navigationType = t2 === undefined ? (0, $f4me1.Action).Pop : t2;
    const staticProp = t3 === undefined ? false : t3;
    !!$33761f973d53d162$export$9c954a9d03d32f4a() && (0, $f4me1.UNSAFE_invariant)(false);
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /^\/*/;
        $[0] = t4;
    } else t4 = $[0];
    const basename = basenameProp.replace(t4, "/");
    const t5 = navigator;
    let t6;
    if ($[1] !== future) {
        t6 = $33761f973d53d162$var$_extends({
            v7_relativeSplatPath: false
        }, future);
        $[1] = future;
        $[2] = t6;
    } else t6 = $[2];
    let t7;
    if ($[3] !== basename || $[4] !== navigator || $[5] !== staticProp || $[6] !== t6) {
        t7 = {
            basename: basename,
            navigator: t5,
            static: staticProp,
            future: t6
        };
        $[3] = basename;
        $[4] = navigator;
        $[5] = staticProp;
        $[6] = t6;
        $[7] = t7;
    } else t7 = $[7];
    const navigationContext = t7;
    if (typeof locationProp === "string") {
        let t8;
        if ($[8] !== locationProp) {
            t8 = (0, $f4me1.parsePath)(locationProp);
            $[8] = locationProp;
            $[9] = t8;
        } else t8 = $[9];
        locationProp = t8;
    }
    const { pathname: t8, search: t9, hash: t10, state: t11, key: t12 } = locationProp;
    const pathname = t8 === undefined ? "/" : t8;
    const search = t9 === undefined ? "" : t9;
    const hash = t10 === undefined ? "" : t10;
    const state = t11 === undefined ? null : t11;
    const key = t12 === undefined ? "default" : t12;
    let t13;
    bb0: {
        let t14;
        if ($[10] !== basename || $[11] !== pathname) {
            t14 = (0, $f4me1.stripBasename)(pathname, basename);
            $[10] = basename;
            $[11] = pathname;
            $[12] = t14;
        } else t14 = $[12];
        const trailingPathname = t14;
        if (trailingPathname == null) {
            t13 = null;
            break bb0;
        }
        let t15;
        if ($[13] !== hash || $[14] !== key || $[15] !== search || $[16] !== state || $[17] !== trailingPathname) {
            t15 = {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            };
            $[13] = hash;
            $[14] = key;
            $[15] = search;
            $[16] = state;
            $[17] = trailingPathname;
            $[18] = t15;
        } else t15 = $[18];
        let t16;
        if ($[19] !== navigationType || $[20] !== t15) {
            t16 = {
                location: t15,
                navigationType: navigationType
            };
            $[19] = navigationType;
            $[20] = t15;
            $[21] = t16;
        } else t16 = $[21];
        t13 = t16;
    }
    const locationContext = t13;
    if (locationContext == null) return null;
    let t14;
    if ($[22] !== children || $[23] !== locationContext || $[24] !== navigationContext) {
        let t15;
        if ($[26] !== navigationContext) {
            t15 = {
                value: navigationContext
            };
            $[26] = navigationContext;
            $[27] = t15;
        } else t15 = $[27];
        let t16;
        if ($[28] !== children || $[29] !== locationContext) {
            t16 = $cozmU.createElement($33761f973d53d162$export$c7914228fb69b0f5.Provider, {
                children: children,
                value: locationContext
            });
            $[28] = children;
            $[29] = locationContext;
            $[30] = t16;
        } else t16 = $[30];
        t14 = $cozmU.createElement($33761f973d53d162$export$26749e8557646306.Provider, t15, t16);
        $[22] = children;
        $[23] = locationContext;
        $[24] = navigationContext;
        $[25] = t14;
    } else t14 = $[25];
    return t14;
} : function Router(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $f4me1.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$33761f973d53d162$export$9c954a9d03d32f4a() && (0, $f4me1.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $cozmU.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $33761f973d53d162$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $f4me1.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $cozmU.useMemo(()=>{
        let trailingPathname = (0, $f4me1.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $cozmU.createElement($33761f973d53d162$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $cozmU.createElement($33761f973d53d162$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
};
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ const $33761f973d53d162$export$3565eb3d00ca5a74 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Routes(_ref6) {
    const $ = (0, $bDgLe.c)(2);
    const { children: children, location: location } = _ref6;
    let t0;
    if ($[0] !== children) {
        t0 = $33761f973d53d162$export$16da398f5434bdec(children);
        $[0] = children;
        $[1] = t0;
    } else t0 = $[1];
    return $33761f973d53d162$export$5d3fca4a98652595(t0, location);
} : function Routes(_ref6) {
    let { children: children, location: location } = _ref6;
    return $33761f973d53d162$export$5d3fca4a98652595($33761f973d53d162$export$16da398f5434bdec(children), location);
};
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $33761f973d53d162$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $cozmU.createElement($33761f973d53d162$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $cozmU.createElement($33761f973d53d162$var$ResolveAwait, null, children));
}
var $33761f973d53d162$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($33761f973d53d162$var$AwaitRenderStatus || {});
const $33761f973d53d162$var$neverSettledPromise = new Promise(()=>{});
class $33761f973d53d162$var$AwaitErrorBoundary extends $cozmU.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $33761f973d53d162$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $33761f973d53d162$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $33761f973d53d162$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $33761f973d53d162$var$AwaitRenderStatus.error : "_data" in promise ? $33761f973d53d162$var$AwaitRenderStatus.success : $33761f973d53d162$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $33761f973d53d162$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $33761f973d53d162$var$AwaitRenderStatus.error && promise._error instanceof (0, $f4me1.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $33761f973d53d162$var$neverSettledPromise;
        if (status === $33761f973d53d162$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $33761f973d53d162$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $cozmU.createElement($33761f973d53d162$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $33761f973d53d162$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $cozmU.createElement($33761f973d53d162$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ const $33761f973d53d162$var$ResolveAwait = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ResolveAwait(_ref8) {
    const $ = (0, $bDgLe.c)(5);
    const { children: children } = _ref8;
    const data = $33761f973d53d162$export$78a72ddb39bdd145();
    let t0;
    if ($[0] !== children || $[1] !== data) {
        t0 = typeof children === "function" ? children(data) : children;
        $[0] = children;
        $[1] = data;
        $[2] = t0;
    } else t0 = $[2];
    const toRender = t0;
    let t1;
    if ($[3] !== toRender) {
        t1 = $cozmU.createElement($cozmU.Fragment, null, toRender);
        $[3] = toRender;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : function ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $33761f973d53d162$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, toRender);
}; ///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $33761f973d53d162$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $cozmU.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $cozmU.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $cozmU.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $33761f973d53d162$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $33761f973d53d162$export$e7b0ac011bb776c6) && (0, $f4me1.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $f4me1.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $33761f973d53d162$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $33761f973d53d162$export$daf73786167a7f72(matches) {
    return $33761f973d53d162$var$_renderMatches(matches);
}
function $33761f973d53d162$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $cozmU.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $cozmU.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $cozmU.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $33761f973d53d162$export$f30f7e456d254e83(routes, opts) {
    return (0, $f4me1.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $33761f973d53d162$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $f4me1.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $33761f973d53d162$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



var $jIrdU = parcelRequire("jIrdU");


var $36Uax = parcelRequire("36Uax");


var $bVevd = parcelRequire("bVevd");


var $b4pEE = parcelRequire("b4pEE");

function $245af5902b743504$export$41eb0a358b69a9df(props) {
    let { contentId: contentId = '', hostname: hostname, parentProduct: parentProduct = '', spaceKey: spaceKey, url: url, allowedFeatures: allowedFeatures, mode: mode, draftShareId: draftShareId, hash: hash, themeState: themeState, showFooter: showFooter, ...passThroughProps } = props;
    const parsedAllowedFeatures = $245af5902b743504$export$350c411f568eceb9(allowedFeatures);
    if (!url) return {
        contentId: contentId,
        hostname: hostname,
        parentProduct: parentProduct,
        spaceKey: spaceKey,
        protocol: 'https:',
        mode: mode ?? (0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        allowedFeatures: parsedAllowedFeatures,
        draftShareId: draftShareId,
        hash: hash,
        themeState: themeState,
        showFooter: showFooter,
        ...passThroughProps
    };
    const parsedProps = $245af5902b743504$export$7a5253c0f62e0150(url);
    if (!parsedProps) return {
        hostname: hostname,
        contentId: contentId,
        spaceKey: spaceKey,
        parentProduct: parentProduct,
        mode: mode,
        protocol: 'https:',
        allowedFeatures: parsedAllowedFeatures,
        draftShareId: draftShareId,
        hash: hash,
        themeState: themeState,
        showFooter: showFooter,
        ...passThroughProps
    };
    const themeStateParsedObject = parsedProps.themeState ? (0, $jIrdU.themeStringToObject)(decodeURIComponent(parsedProps.themeState)) : undefined;
    const previewPanels = $245af5902b743504$var$parseQueryParam(parsedProps.query, 'previewPanels');
    // Override with URL-extracted props
    contentId = contentId || parsedProps.contentId;
    parentProduct = parentProduct || parsedProps.parentProduct || '';
    hostname = hostname || parsedProps.hostname || window.location.hostname;
    spaceKey = spaceKey || parsedProps.spaceKey;
    draftShareId = draftShareId || parsedProps.draftShareId;
    hash = hash || parsedProps.hash;
    themeState = themeState || themeStateParsedObject;
    let modeFromUrl;
    switch(parsedProps.route){
        case (0, $b4pEE.VIEW_PAGE).name:
        case (0, $b4pEE.VIEW_BLOG).name:
        case (0, $b4pEE.VIEW_BLOG_DATE_LEGACY).name:
            modeFromUrl = (0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE;
            break;
        case (0, $b4pEE.EDIT_PAGE_EMBED).name:
        case (0, $b4pEE.EDIT_PAGE_V2).name:
            modeFromUrl = (0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE;
            break;
        case (0, $b4pEE.WHITEBOARD).name:
    }
    const contentSlug = parsedProps.route === (0, $b4pEE.VIEW_BLOG_DATE_LEGACY).name ? undefined : parsedProps.contentSlug;
    return {
        allowedFeatures: parsedAllowedFeatures,
        contentId: contentId,
        draftShareId: draftShareId,
        hash: hash,
        hostname: hostname,
        mode: mode || modeFromUrl,
        parentProduct: parentProduct,
        protocol: parsedProps.protocol,
        spaceKey: spaceKey,
        themeState: themeState,
        contentSlug: contentSlug,
        showFooter: showFooter,
        previewPanels: previewPanels,
        ...passThroughProps
    };
}
function $245af5902b743504$export$7a5253c0f62e0150(url) {
    if (!url) return null;
    const matchedRoute = $245af5902b743504$var$findAndMatchRoute((0, $b4pEE.namedRoutes), url);
    if (!matchedRoute) return null;
    const { routeName: routeName, ...match } = matchedRoute;
    const { year: year, month: month, day: day, contentId: contentId } = match.params;
    // Validate date parameters
    const isValidYear = /^\d+$/.test(year || '');
    const isValidMonth = /^\d+$/.test(month || '');
    const isValidDay = /^\d+$/.test(day || '');
    const isValidContentId = /^\d+$/.test(contentId || '');
    // If route requires validation, and any parameter is invalid, return null
    if (routeName === (0, $b4pEE.VIEW_BLOG_DATE_LEGACY).name && (!isValidYear || !isValidMonth || !isValidDay || !isValidContentId)) return null;
    return {
        route: routeName,
        hostname: match.host,
        protocol: match.protocol,
        contentId: contentId || '',
        spaceKey: match.params.spaceKey || '',
        hash: match.hash || '',
        // EP currently supports only 1 parent product, no more than 1 parent product should be passed in
        parentProduct: Array.isArray(match.query.parentProduct) ? match.query.parentProduct[0] : match.query.parentProduct || '',
        draftShareId: Array.isArray(match.query.draftShareId) ? match.query.draftShareId[0] : match.query.draftShareId,
        themeState: match.query.themeState,
        contentSlug: match.params.contentSlug || undefined,
        query: match.query
    };
}
function $245af5902b743504$var$findAndMatchRoute(routes, url) {
    for (const routeKey of Object.keys(routes)){
        const route = routes[routeKey];
        const match = $245af5902b743504$var$matchUrl(route.pattern, url);
        if (match) return {
            routeName: route.name,
            ...match
        };
    }
    return null;
}
function $245af5902b743504$var$isValidURL(url) {
    try {
        new URL(url, window.location.origin);
        return true;
    } catch  {
        return false;
    }
}
function $245af5902b743504$var$matchUrl(pattern, url) {
    if (!$245af5902b743504$var$isValidURL(url)) return null;
    const parsed = new URL(url, window.location.origin);
    const pathname = parsed.pathname || '';
    const search = parsed.search || '';
    let match = (0, $f4me1.matchPath)({
        path: pattern,
        end: true
    }, pathname);
    // If initial match fails and the route requires query parameters, attempt to match including search
    // some of our routes need query params to match
    if (!match && search) match = (0, $f4me1.matchPath)({
        path: pattern,
        end: true
    }, `${pathname}${search}`);
    if (!match) return null;
    // URI decode params
    const decodedParams = {};
    if (match.params) {
        for (const [key, value] of Object.entries(match.params))if (value !== undefined) decodedParams[key] = value;
    }
    return {
        url: url,
        protocol: parsed.protocol,
        host: parsed.host,
        pathname: pathname,
        search: parsed.search,
        hash: parsed.hash,
        pattern: pattern,
        params: decodedParams,
        query: Object.fromEntries(parsed.searchParams.entries())
    };
}
function $245af5902b743504$export$350c411f568eceb9(allowedFeatures) {
    let parsedAllowedFeatures = {
        view: allowedFeatures?.view,
        edit: allowedFeatures?.edit
    };
    if (!allowedFeatures?.view) parsedAllowedFeatures.view = [
        ...(0, $36Uax.DEFAULT_ALLOWED_FEATURES).view,
        'edit'
    ];
    else if (Array.isArray(allowedFeatures.view)) parsedAllowedFeatures.view = [
        ...allowedFeatures.view,
        'edit'
    ];
    return parsedAllowedFeatures;
}
function $245af5902b743504$var$parseQueryParam(query, keyName) {
    for (const [key, value] of Object.entries(query)){
        if (key === keyName) return Array.isArray(value) ? value.join(',') : value;
    }
    return undefined;
}
module.exports["parsePageProps"] = $245af5902b743504$export$41eb0a358b69a9df;
module.exports["parseUrl"] = $245af5902b743504$export$7a5253c0f62e0150;

});

parcelRegister("hOFc9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $boaiH = parcelRequire("boaiH");

var $fULE8 = parcelRequire("fULE8");





var $9DHhW = parcelRequire("9DHhW");


var $5csBp = parcelRequire("5csBp");


var $kNKCD = parcelRequire("kNKCD");


var $63MMY = parcelRequire("63MMY");

const $aa446c8ee43105ea$export$e955abb82869dc84 = (experienceTracker)=>{
    const unsubscribeRef = (0, $cozmU.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    if (!unsubscribeRef.current && experienceTracker) unsubscribeRef.current = experienceTracker.subscribe((event)=>{
        if (event.name.startsWith((0, $5csBp.EXPERIENCE_NAME_PREFIX))) // Fire the analytic event to dedicated ANALYTICS_CHANNEL channel for EP analytics.
        createAnalyticsEvent((0, $kNKCD.createExperienceTrackerAnalyticsEventPayload)(event)).fire((0, $63MMY.ANALYTICS_CHANNEL));
    });
    (0, $cozmU.useEffect)(()=>unsubscribeRef.current, []);
};


function $83dc1e2f9f574007$export$7ecf150f65423c3f(fromExperienceTracker, toExperienceTracker) {
    if (!fromExperienceTracker || !toExperienceTracker) return;
    const cancelExperiencesForwarding = fromExperienceTracker.subscribe(({ action: action, ...options })=>{
        switch(action){
            case 'taskAbort':
                toExperienceTracker.abort({
                    ...options,
                    checkForTimeout: false // disallow `taskAbort` to be converted into `taskFail`
                });
                break;
            case 'taskFail':
                toExperienceTracker.fail(options);
                break;
            case 'taskStart':
                toExperienceTracker.start(options);
                break;
            case 'taskSuccess':
                toExperienceTracker.succeed(options);
                break;
        }
    });
    return cancelExperiencesForwarding;
}


function $403a10e5fc45f46e$export$cdefb2a8b53f879f() {
    const embeddedConfluenceETRef = (0, $cozmU.useRef)();
    if (!embeddedConfluenceETRef.current) embeddedConfluenceETRef.current = new (0, $boaiH.ExperienceTracker)();
    (0, $aa446c8ee43105ea$export$e955abb82869dc84)(embeddedConfluenceETRef.current);
    $403a10e5fc45f46e$var$useExperiencesForwarding(embeddedConfluenceETRef.current);
    return embeddedConfluenceETRef.current;
}
const $403a10e5fc45f46e$var$useExperiencesForwarding = (experienceTracker)=>{
    const unsubscribeRef = (0, $cozmU.useRef)();
    // Make sure the Embeddable Pages ExperienceTrackerAPI instance forwards experence events to the embedding product.
    const embeddingProductETRef = (0, $cozmU.useRef)();
    const embeddingProductET = (0, $cozmU.useContext)((0, $fULE8.ExperienceTrackerContext));
    if (embeddingProductETRef.current !== embeddingProductET) {
        // Cancel the old forwarding on embedding product ExperienceTrackerAPI instance change.
        if (unsubscribeRef.current) unsubscribeRef.current();
        embeddingProductETRef.current = embeddingProductET;
        // Set the new forwarding up.
        unsubscribeRef.current = (0, $83dc1e2f9f574007$export$7ecf150f65423c3f)(experienceTracker, embeddingProductETRef.current);
    }
    // Cancel the forwarding on unmount.
    (0, $cozmU.useEffect)(()=>unsubscribeRef.current, []);
};
module.exports["useExperienceTracker"] = $403a10e5fc45f46e$export$cdefb2a8b53f879f;

});

parcelRegister("5csBp", function(module, exports) {
const $5c3514be5e37391a$export$b9fadc635fed6276 = 'embedded-confluence/';
var $5c3514be5e37391a$export$312b1a9f1141bdaa = /*#__PURE__*/ function(ExperienceNames) {
    ExperienceNames["VIEW_PAGE"] = "embedded-confluence/view-page";
    ExperienceNames["CC_VIEW_PAGE"] = "view-page";
    ExperienceNames["EDIT_PAGE"] = "embedded-confluence/edit-page";
    ExperienceNames["CC_EDIT_PAGE_EMBED"] = "edit-page-embed";
    ExperienceNames["WHITEBOARD"] = "embedded-confluence/whiteboard";
    ExperienceNames["CC_WHITEBOARD"] = "whiteboard-page";
    ExperienceNames["LOGIN_PAGE"] = "embedded-confluence/login-page";
    ExperienceNames["STORAGE_ACCESS_PAGE"] = "embedded-confluence/storage-access-page";
    ExperienceNames["PAGE_NOT_FOUND"] = "not-found";
    return ExperienceNames;
}({});
var $5c3514be5e37391a$export$db5add30a8721c38 = /*#__PURE__*/ function(ExperienceReasons) {
    ExperienceReasons["UNABLE_TO_DISPLAY_CONTENT"] = "Unable to display page content";
    ExperienceReasons["STORAGE_ACCESS_ERROR"] = "Error when obtaining Storage access";
    ExperienceReasons["STORAGE_ACCESS_NOT_SUPPORTED"] = "Storage access API is not supported";
    ExperienceReasons["STORAGE_ACCESS_REJECTED"] = "Storage access is rejected";
    return ExperienceReasons;
}({});
var $5c3514be5e37391a$export$ce9b20b2ad3e7bc6 = /*#__PURE__*/ function(SupportedExperienceNames) {
    SupportedExperienceNames["ADD_COMMENT"] = "add-page-comment";
    SupportedExperienceNames["DELETE_COMMENT"] = "delete-page-comment";
    SupportedExperienceNames["DELETE_PAGE"] = "delete-page";
    SupportedExperienceNames["DELETE_DRAFT"] = "edit-page/revert-draft";
    SupportedExperienceNames["EDIT_CLOSE"] = "edit-page/close";
    SupportedExperienceNames["EDIT_LOAD"] = "edit-page/load";
    SupportedExperienceNames["EDIT_PAGE_EMBED"] = "embedded-confluence/edit-page";
    SupportedExperienceNames["EDIT_PUBLISH"] = "edit-page/publish";
    SupportedExperienceNames["LOGIN_PAGE"] = "embedded-confluence/login-page";
    SupportedExperienceNames["STORAGE_ACCESS_PAGE"] = "embedded-confluence/storage-access-page";
    SupportedExperienceNames["VIEW_CONTENT"] = "view-content";
    SupportedExperienceNames["VIEW_EDIT"] = "view-page/edit";
    SupportedExperienceNames["VIEW_PAGE"] = "embedded-confluence/view-page";
    return SupportedExperienceNames;
}({});
module.exports["EXPERIENCE_NAME_PREFIX"] = $5c3514be5e37391a$export$b9fadc635fed6276;
module.exports["ExperienceNames"] = $5c3514be5e37391a$export$312b1a9f1141bdaa;
module.exports["ExperienceReasons"] = $5c3514be5e37391a$export$db5add30a8721c38;
module.exports["SupportedExperienceNames"] = $5c3514be5e37391a$export$ce9b20b2ad3e7bc6;

});

parcelRegister("63MMY", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3d3WW = parcelRequire("3d3WW");


var $NF6kd = parcelRequire("NF6kd");

var $l7jo6 = parcelRequire("l7jo6");

const $3ccacddc09a3fad3$var$ANALYTICS_PRODUCT = 'embeddedConfluence';
const $3ccacddc09a3fad3$var$defaultOrgId = '';
const $3ccacddc09a3fad3$var$orgIdQuery = `query OrgId($hostNames: [String!]) {
    tenantContexts(hostNames: $hostNames) {
      orgId
    }
  }`;
const $3ccacddc09a3fad3$var$getAGGOrgId = async (hostname)=>{
    let orgId = $3ccacddc09a3fad3$var$defaultOrgId; // default value set to empty string for orgid when no orgid exists
    const prefix = `${window.location.protocol}//${hostname || window.location.hostname}`;
    try {
        const response = await fetch(`${prefix}/gateway/api/graphql`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: $3ccacddc09a3fad3$var$orgIdQuery,
                variables: {
                    hostNames: [
                        hostname
                    ]
                }
            })
        });
        const result = await response.json();
        orgId = result.data?.tenantContexts[0]?.orgId ?? $3ccacddc09a3fad3$var$defaultOrgId;
    } catch  {
        // eslint-disable-next-line no-console
        console.error(`Error fetching orgId from ${hostname}/gateway/api/graphql`);
    }
    return orgId;
};
// Define default analytic-web-client environment config for now
const $3ccacddc09a3fad3$var$getAnalyticsEnv = (hostname)=>{
    if (hostname.includes('localhost')) return (0, $l7jo6.envType).LOCAL;
    if (hostname.includes('jira-dev')) return (0, $l7jo6.envType).DEV;
    return (0, $l7jo6.envType).PROD;
};
let $3ccacddc09a3fad3$var$analyticsClient;
const $3ccacddc09a3fad3$var$getUserInfo = async (hostname, userInfo)=>{
    if (userInfo) return {
        userId: userInfo?.userId,
        userIdType: userInfo?.userIdType
    };
    else {
        const prefix = `${window.location.protocol}//${hostname || window.location.hostname}`;
        const res = await fetch(`${prefix}/gateway/api/me`);
        const resJson = await res.json();
        const { account_id: account_id, account_type: account_type } = resJson;
        return account_type === 'atlassian' ? {
            userId: account_id,
            userIdType: (0, $l7jo6.userType).ATLASSIAN_ACCOUNT
        } : undefined;
    }
};
const $3ccacddc09a3fad3$export$e9ba7ef9458d1a4a = async ({ hostname: hostname, userInfo: userInfo })=>{
    if (!$3ccacddc09a3fad3$var$analyticsClient) {
        $3ccacddc09a3fad3$var$analyticsClient = new (0, $NF6kd.default)({
            product: $3ccacddc09a3fad3$var$ANALYTICS_PRODUCT,
            env: $3ccacddc09a3fad3$var$getAnalyticsEnv(hostname || window.location.hostname),
            origin: (0, $l7jo6.originType).WEB
        });
        try {
            const orgId = await $3ccacddc09a3fad3$var$getAGGOrgId(hostname);
            $3ccacddc09a3fad3$var$analyticsClient.setOrgInfo(orgId);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error); // orgId is not set when undefined or empty string based on current impl of setOrgInfo
        }
        try {
            const fetchedUserInfo = await $3ccacddc09a3fad3$var$getUserInfo(hostname, userInfo);
            if (fetchedUserInfo) $3ccacddc09a3fad3$var$analyticsClient.setUserInfo(fetchedUserInfo.userIdType, fetchedUserInfo.userId);
        } catch  {
            // eslint-disable-next-line no-console
            console.error(`Error fetching userInfo from ${hostname}/gateway/api/me`);
        }
    }
    return $3ccacddc09a3fad3$var$analyticsClient;
};


const $4c9b6dc68ec33da8$export$85183a312807388d = 'embeddedConfluence';
const $4c9b6dc68ec33da8$var$packageName = "platform-pkg";
const $4c9b6dc68ec33da8$var$packageVersion = "0.0.0-use.local";
const $4c9b6dc68ec33da8$var$AnalyticsListener = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { children: children, embeddedConfluenceSource: embeddedConfluenceSource, hostname: hostname, parentProduct: parentProduct, userInfo: userInfo } = t0;
    const [analyticsClient, setAnalyticsClient] = (0, $cozmU.useState)(null);
    let t1;
    let t2;
    if ($[0] !== hostname || $[1] !== userInfo) {
        t1 = ()=>{
            (0, $3ccacddc09a3fad3$export$e9ba7ef9458d1a4a)({
                hostname: hostname,
                userInfo: userInfo
            }).then((res)=>{
                setAnalyticsClient(res);
            });
        };
        t2 = [
            hostname,
            userInfo
        ];
        $[0] = hostname;
        $[1] = userInfo;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[4] !== analyticsClient || $[5] !== embeddedConfluenceSource || $[6] !== parentProduct) {
        t3 = (t4)=>{
            const { payload: payload } = t4;
            analyticsClient?.onEvent?.($4c9b6dc68ec33da8$export$85183a312807388d, {
                ...payload,
                attributes: {
                    ...payload?.attributes,
                    embeddedConfluenceSource: embeddedConfluenceSource,
                    packageName: $4c9b6dc68ec33da8$var$packageName,
                    packageVersion: $4c9b6dc68ec33da8$var$packageVersion,
                    parentProduct: parentProduct
                }
            });
        };
        $[4] = analyticsClient;
        $[5] = embeddedConfluenceSource;
        $[6] = parentProduct;
        $[7] = t3;
    } else t3 = $[7];
    const onEvent = t3;
    if (!analyticsClient) return null;
    let t4;
    if ($[8] !== children || $[9] !== onEvent) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
            channel: $4c9b6dc68ec33da8$export$85183a312807388d,
            onEvent: onEvent
        }, children);
        $[8] = children;
        $[9] = onEvent;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ({ children: children, embeddedConfluenceSource: embeddedConfluenceSource, hostname: hostname, parentProduct: parentProduct, userInfo: userInfo })=>{
    const [analyticsClient, setAnalyticsClient] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        (0, $3ccacddc09a3fad3$export$e9ba7ef9458d1a4a)({
            hostname: hostname,
            userInfo: userInfo
        }).then((res)=>{
            setAnalyticsClient(res);
        });
    }, [
        hostname,
        userInfo
    ]);
    const onEvent = (0, $cozmU.useCallback)(({ payload: payload })=>{
        analyticsClient?.onEvent?.($4c9b6dc68ec33da8$export$85183a312807388d, {
            ...payload,
            attributes: {
                ...payload?.attributes,
                embeddedConfluenceSource: embeddedConfluenceSource,
                packageName: $4c9b6dc68ec33da8$var$packageName,
                packageVersion: $4c9b6dc68ec33da8$var$packageVersion,
                parentProduct: parentProduct
            }
        });
    }, [
        analyticsClient,
        parentProduct,
        embeddedConfluenceSource
    ]);
    if (!analyticsClient) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        channel: $4c9b6dc68ec33da8$export$85183a312807388d,
        onEvent: onEvent
    }, children);
};
var $4c9b6dc68ec33da8$export$2e2bcd8739ae039 = $4c9b6dc68ec33da8$var$AnalyticsListener;
module.exports["ANALYTICS_CHANNEL"] = $4c9b6dc68ec33da8$export$85183a312807388d;
module.exports["default"] = $4c9b6dc68ec33da8$export$2e2bcd8739ae039;

});

parcelRegister("eRLgK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $RfroO = parcelRequire("RfroO");


var $iMnC5 = parcelRequire("iMnC5");




const $8b703cf521b117e0$var$messages = (0, $kSwu1.defineMessages)({
    pageNotFoundImageAriaLabel: {
        defaultMessage: "Page not found",
        id: "embedded-confluence-common.src.content.page-not-found-image.aria-label"
    },
    emptyStateHeader: {
        defaultMessage: "We couldn't find what you're looking for",
        id: "embedded-confluence-common.src.content.empty-state-header"
    },
    emptyStateDescription: {
        defaultMessage: "We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it \uD83D\uDE09",
        id: "embedded-confluence-common.src.content.empty-state-description"
    }
});
var $8b703cf521b117e0$export$2e2bcd8739ae039 = $8b703cf521b117e0$var$messages;


var $b018ceaf494cccfa$exports = {};
$b018ceaf494cccfa$exports = new URL("PageNotFoundSVG.5a354fce.svg", import.meta.url).toString();


const $d65248af0d2439a9$var$styles = {
    image: "_1EqgXlBfNa _39xV02N91d _0jFU0VN91d _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT"
};
const $d65248af0d2439a9$var$PageNotFoundSVG = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $8b703cf521b117e0$export$2e2bcd8739ae039).pageNotFoundImageAriaLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ $cozmU.createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($b018ceaf494cccfa$exports))),
            alt: t0,
            width: "476.06",
            height: "482.63"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b018ceaf494cccfa$exports))),
        alt: formatMessage((0, $8b703cf521b117e0$export$2e2bcd8739ae039).pageNotFoundImageAriaLabel),
        width: "476.06",
        height: "482.63"
    });
}; // Due to the small width of the preview panel, we need to wrap the PageNotFoundSVG with specific styles
const $d65248af0d2439a9$var$PreviewPanelPageNotFoundSVG = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $d65248af0d2439a9$var$styles.image
        }, /*#__PURE__*/ $cozmU.createElement($d65248af0d2439a9$var$PageNotFoundSVG, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $d65248af0d2439a9$var$styles.image
    }, /*#__PURE__*/ $cozmU.createElement($d65248af0d2439a9$var$PageNotFoundSVG, null));
};
const $d65248af0d2439a9$export$d3ec4d3c4e3e468c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { embeddedConfluenceSource: embeddedConfluenceSource } = t0 === undefined ? {} : t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isInPreviewPanel = embeddedConfluenceSource === "confluence-page-preview-panel";
    const EmptyStateImage = isInPreviewPanel ? $d65248af0d2439a9$var$PreviewPanelPageNotFoundSVG : $d65248af0d2439a9$var$PageNotFoundSVG;
    const EmptyStateWidth = isInPreviewPanel ? "narrow" : "wide";
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $8b703cf521b117e0$export$2e2bcd8739ae039).emptyStateHeader);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== formatMessage) {
        t2 = formatMessage((0, $8b703cf521b117e0$export$2e2bcd8739ae039).emptyStateDescription);
        $[2] = formatMessage;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== EmptyStateImage) {
        t3 = ()=>/*#__PURE__*/ $cozmU.createElement(EmptyStateImage, null);
        $[4] = EmptyStateImage;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== EmptyStateWidth || $[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $RfroO.default), {
            header: t1,
            description: t2,
            width: EmptyStateWidth,
            renderImage: t3
        });
        $[6] = EmptyStateWidth;
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ({ embeddedConfluenceSource: embeddedConfluenceSource } = {})=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isInPreviewPanel = embeddedConfluenceSource === 'confluence-page-preview-panel';
    const EmptyStateImage = isInPreviewPanel ? $d65248af0d2439a9$var$PreviewPanelPageNotFoundSVG : $d65248af0d2439a9$var$PageNotFoundSVG;
    const EmptyStateWidth = isInPreviewPanel ? 'narrow' : 'wide';
    return /*#__PURE__*/ $cozmU.createElement((0, $RfroO.default), {
        header: formatMessage((0, $8b703cf521b117e0$export$2e2bcd8739ae039).emptyStateHeader),
        description: formatMessage((0, $8b703cf521b117e0$export$2e2bcd8739ae039).emptyStateDescription),
        width: EmptyStateWidth,
        renderImage: ()=>/*#__PURE__*/ $cozmU.createElement(EmptyStateImage, null)
    });
};
module.exports["PageNotFoundEmptyState"] = $d65248af0d2439a9$export$d3ec4d3c4e3e468c;

});

parcelRegister("eBMyn", function(module, exports) {
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $0a28039a944d9e6e$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Hledali jsme v\u0161ude, ale tato polo\u017Eka neexistuje. Mohla b\xfdt odstran\u011Bna. Pokud ov\u0161em nem\xe1te p\u0159eklep v\xa0adrese URL.",
    'embedded-confluence-common.src.content.empty-state-header': "Nem\u016F\u017Eeme naj\xedt, co hled\xe1te",
    'embedded.confluence.already-logged-in-paragraph': "Jste ji\u017E p\u0159ihl\xe1\u0161eni? Zkuste obnovit str\xe1nku.",
    'embedded.confluence.connect-to-confluence.button': "P\u0159ipojit Confluence",
    'embedded.confluence.connect-to-confluence.button.aria-label': "Tla\u010D\xedtko P\u0159ipojit Confluence",
    'embedded.confluence.connect-to-confluence.description': "Ukl\xe1dejte n\xe1pady, sledujte polo\u017Eky agendy a d\u011Blejte si pozn\xe1mky spole\u010Dn\u011B jako t\xfdm.",
    'embedded.confluence.connect-to-confluence.heading': "P\u0159ipojit ke Confluence",
    'embedded.confluence.footer.hover.text': "Zobrazit v\xa0Confluence",
    'embedded.confluence.footer.prefix': "Pou\u017E\xedv\xe1 technologii",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "P\u0159ihlaste se do Confluence",
    'embedded.confluence.login-page.login-button': "P\u0159ihl\xe1sit se do Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "Tla\u010D\xedtko p\u0159ihl\xe1\u0161en\xed",
    'embedded.confluence.login-page.login-text': "Chcete-li zobrazit tuto str\xe1nku, mus\xedte b\xfdt p\u0159ihl\xe1\u0161eni.",
    'embedded.confluence.login-page.refresh-page-banner': "Po p\u0159ihl\xe1\u0161en\xed by se tato str\xe1nka m\u011Bla automaticky obnovit. Pokud ne, m\u016F\u017Eete ji obnovit kliknut\xedm zde.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Obnovit str\xe1nku",
    'embedded.confluence.need-to-log-in-paragraph': "Chcete-li zobrazit tuto str\xe1nku, mus\xedte b\xfdt p\u0159ihl\xe1\u0161eni.",
    'embedded.confluence.still-having-trouble-paragraph': "Po\u0159\xe1d m\xe1te pot\xed\u017Ee? Ujist\u011Bte se, \u017Ee jsou povoleny soubory cookies t\u0159et\xedch stran, nebo {link}",
    'embedded.confluence.troubleshooting-link-text': "se pod\xedvejte se do pr\u016Fvodce \u0159e\u0161en\xedm probl\xe9m\u016F.",
    'embedded.confluence.troubleshooting-link.aria-label': "odkaz na pr\u016Fvodce \u0159e\u0161en\xedm probl\xe9m\u016F"
};


var $db096865ea597f4f$export$2e2bcd8739ae039 = (0, $0a28039a944d9e6e$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $36563d47426e12b4$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Vi har ledt overalt, men den eksisterer ikke. Den er muligvis blevet slettet. Medmindre der er en sl\xe5fejl i webadressen, selvf\xf8lgelig \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Vi kunne ikke finde det, du leder efter',
    'embedded.confluence.already-logged-in-paragraph': "Er du allerede logget ind? Pr\xf8v at genindl\xe6se.",
    'embedded.confluence.connect-to-confluence.button': 'Forbind Confluence',
    'embedded.confluence.connect-to-confluence.button.aria-label': 'Knappen Forbind Confluence',
    'embedded.confluence.connect-to-confluence.description': "Gem ideer, f\xf8lg dagsordenspunkter, og tag noter sammen som et team.",
    'embedded.confluence.connect-to-confluence.heading': 'Opret forbindelse til Confluence',
    'embedded.confluence.footer.hover.text': 'Vis i Confluence',
    'embedded.confluence.footer.prefix': 'Drevet af',
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Log p\xe5 Confluence",
    'embedded.confluence.login-page.login-button': "Log ind p\xe5 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': 'Loginknap',
    'embedded.confluence.login-page.login-text': "Du skal v\xe6re logget ind for at kunne se denne side",
    'embedded.confluence.login-page.refresh-page-banner': "N\xe5r du har logget ind, b\xf8r denne side genindl\xe6ses automatisk. Hvis ikke, kan du klikke her for at genindl\xe6se",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Genindl\xe6s siden",
    'embedded.confluence.need-to-log-in-paragraph': "Du skal v\xe6re logget ind for at kunne se denne side",
    'embedded.confluence.still-having-trouble-paragraph': "Har du stadig problemer? S\xf8rg for, at tredjepartscookies er aktiveret, eller {link}",
    'embedded.confluence.troubleshooting-link-text': 'se denne fejlfindingsvejledning.',
    'embedded.confluence.troubleshooting-link.aria-label': 'link til fejlfindingsvejledning'
};


var $1d0fc6597744fadd$export$2e2bcd8739ae039 = (0, $36563d47426e12b4$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $0538aced3eb80045$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Wir haben \xfcberall gesucht, aber sie existiert nicht. Sie k\xf6nnte gel\xf6scht worden sein. Es sei denn, in der URL ist ein Tippfehler enthalten \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Wir konnten nicht finden, wonach Sie suchen',
    'embedded.confluence.already-logged-in-paragraph': 'Bereits eingeloggt? Aktualisieren Sie die Seite.',
    'embedded.confluence.connect-to-confluence.button': 'Confluence verbinden',
    'embedded.confluence.connect-to-confluence.button.aria-label': 'Schaltfl\xe4che "Confluence verbinden"',
    'embedded.confluence.connect-to-confluence.description': 'Halten Sie Ideen fest, verfolgen Sie Agendapunkte und machen Sie sich im Team Notizen.',
    'embedded.confluence.connect-to-confluence.heading': 'Mit Confluence verbinden',
    'embedded.confluence.footer.hover.text': 'In Confluence anzeigen',
    'embedded.confluence.footer.prefix': 'Bereitgestellt von',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Bei Confluence einloggen',
    'embedded.confluence.login-page.login-button': 'Bei Confluence einloggen',
    'embedded.confluence.login-page.login-button.aria-label': "Login-Schaltfl\xe4che",
    'embedded.confluence.login-page.login-text': "Sie m\xfcssen eingeloggt sein, damit diese Seite angezeigt wird.",
    'embedded.confluence.login-page.refresh-page-banner': "Nach dem Einloggen sollte diese Seite automatisch aktualisiert werden. Wenn dies nicht der Fall ist, k\xf6nnen Sie zum Aktualisieren hier klicken.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Seite aktualisieren',
    'embedded.confluence.need-to-log-in-paragraph': "Sie m\xfcssen eingeloggt sein, damit diese Seite angezeigt wird.",
    'embedded.confluence.still-having-trouble-paragraph': 'Besteht das Problem weiterhin? Vergewissern Sie sich, dass Cookies von Drittanbietern aktiviert sind, oder {link}',
    'embedded.confluence.troubleshooting-link-text': 'lesen Sie den Leitfaden zur Fehlerbehebung.',
    'embedded.confluence.troubleshooting-link.aria-label': 'Link zum Leitfaden zur Fehlerbehebung'
};


var $b6ae0df92217897d$export$2e2bcd8739ae039 = (0, $0538aced3eb80045$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $40f5b844ea2de35c$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "We couldn't find what you're looking for",
    'embedded.confluence.already-logged-in-paragraph': 'Already logged in? Try refreshing.',
    'embedded.confluence.connect-to-confluence.button': 'Connect Confluence',
    'embedded.confluence.connect-to-confluence.button.aria-label': 'Connect Confluence Button',
    'embedded.confluence.connect-to-confluence.description': 'Save ideas, track agenda items, and take notes together as a team.',
    'embedded.confluence.connect-to-confluence.heading': 'Connect to Confluence',
    'embedded.confluence.footer.hover.text': 'View in Confluence',
    'embedded.confluence.footer.prefix': 'Powered by',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Log in to Confluence',
    'embedded.confluence.login-page.login-button': 'Log in to Confluence',
    'embedded.confluence.login-page.login-button.aria-label': 'Login Button',
    'embedded.confluence.login-page.login-text': 'You need to be logged in to view this page',
    'embedded.confluence.login-page.refresh-page-banner': 'After logging in, this page should refresh automatically. If not, you can click here to refresh',
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Refresh page',
    'embedded.confluence.need-to-log-in-paragraph': 'You need to be logged in to view this page',
    'embedded.confluence.still-having-trouble-paragraph': 'Still having trouble? Make sure 3rd party cookies are enabled, or {link}',
    'embedded.confluence.troubleshooting-link-text': 'refer to this troubleshooting guide.',
    'embedded.confluence.troubleshooting-link.aria-label': 'troubleshooting guide link'
};


var $8f2e4db5faa20bce$export$2e2bcd8739ae039 = (0, $40f5b844ea2de35c$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $5fe447320143a08a$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "We couldn't find what you're looking for",
    'embedded.confluence.already-logged-in-paragraph': 'Already logged in? Try refreshing.',
    'embedded.confluence.connect-to-confluence.button': 'Connect Confluence',
    'embedded.confluence.connect-to-confluence.button.aria-label': 'Connect Confluence Button',
    'embedded.confluence.connect-to-confluence.description': 'Save ideas, track agenda items, and take notes together as a team.',
    'embedded.confluence.connect-to-confluence.heading': 'Connect to Confluence',
    'embedded.confluence.footer.hover.text': 'View in Confluence',
    'embedded.confluence.footer.prefix': 'Powered by',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Log in to Confluence',
    'embedded.confluence.login-page.login-button': 'Log in to Confluence',
    'embedded.confluence.login-page.login-button.aria-label': 'Login Button',
    'embedded.confluence.login-page.login-text': 'You need to be logged in to view this page',
    'embedded.confluence.login-page.refresh-page-banner': 'After logging in, this page should refresh automatically. If not, you can click here to refresh',
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Refresh page',
    'embedded.confluence.need-to-log-in-paragraph': 'You need to be logged in to view this page',
    'embedded.confluence.still-having-trouble-paragraph': 'Still having trouble? Make sure 3rd party cookies are enabled, or {link}',
    'embedded.confluence.troubleshooting-link-text': 'refer to this troubleshooting guide.',
    'embedded.confluence.troubleshooting-link.aria-label': 'troubleshooting guide link'
};


var $33ea8e64ca8668d2$export$2e2bcd8739ae039 = (0, $5fe447320143a08a$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $579e481994b7c57c$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u2063\u2062We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it \uD83D\uDE09\u206A\x81\u206C\u2061\u200D\u2060\u061C\u206E\u2061\x9d\u2061\u2061\u206F\x8f\u206F\u206A\u2061\u206E\u206E\u206B\u2060\u2061\u061C\u206B\x9d\x8f\u206E\x9d\x81\u200D\x8d\u206F\u2063\u2064",
    'embedded-confluence-common.src.content.empty-state-header': "\u2063\u2062We couldn't find what you're looking for\u2061\u200C\u206E\x81\x8f\u206E\u206C\u206A\u206C\u061C\u206B\u206B\u200C\u206D\x8d\x8f\u206A\u200D\u2061\u2061\x8d\u200C\u200D\u2061\u206C\x8f\u206F\u206D\u206F\u2061\u206D\u206D\u2063\u2064",
    'embedded.confluence.already-logged-in-paragraph': "\u2063\u2062Already logged in? Try refreshing.\x90\x90\u206A\x8f\u200D\u206C\u200D\x9d\u206A\x8f\x81\x8f\u200C\x9d\x8d\u206C\x8f\u2060\x90\x90\u206D\x81\u061C\x8d\u2061\x81\u206E\u206D\x90\u2060\u200D\u206F\u2063\u2064",
    'embedded.confluence.connect-to-confluence.button': "\u2063\u2062Connect Confluence\x90\u200D\x8f\u200D\u200D\x9d\x8d\u200C\u200C\x8f\u206D\u206D\u206B\x9d\u061C\x9d\u206A\u2061\u200C\u206F\x9d\u206B\u061C\u2061\u206D\u206C\x81\u206F\u061C\u206A\u206A\u206D\u2063\u2064",
    'embedded.confluence.connect-to-confluence.button.aria-label': "\u2063\u2062Connect Confluence Button\x81\u206C\u2061\u200D\x9d\x9d\u2060\u206C\x81\u206A\u2060\u206E\x8f\u206A\u206B\u206B\u200D\x8f\u200C\u206D\u206F\x81\x8d\u206E\u206E\u200C\u2060\u206F\x8f\u206D\u200D\u2060\u2063\u2064",
    'embedded.confluence.connect-to-confluence.description': "\u2063\u2062Save ideas, track agenda items, and take notes together as a team.\u206D\u206B\u2060\u2061\u200D\u200C\u061C\x81\u2060\x8f\u200D\x90\x90\u206C\u2061\u206B\u206A\u206B\u061C\x81\u206D\x90\u206B\u206D\u2061\u206C\u2060\u206C\u061C\u2061\u206F\u2061\u2063\u2064",
    'embedded.confluence.connect-to-confluence.heading': "\u2063\u2062Connect to Confluence\x8d\u206A\u206F\u206F\u061C\x81\u200C\u2061\x8d\u2060\u200D\u206C\x8d\x9d\u061C\u206C\u200C\u206D\x90\u206D\u061C\u200D\u2060\x90\u206A\u200C\u206C\x8f\x8d\u061C\u061C\x8d\u2063\u2064",
    'embedded.confluence.footer.hover.text': "\u2063\u2062View in Confluence\u200C\u206D\u200D\x90\u200D\u2061\u206C\u206D\x9d\u2060\x9d\x9d\u206A\u2061\u2061\u061C\u2060\u2060\u2060\u200D\u206E\x90\x81\u200C\x8f\u2060\u2060\u206D\u2060\u2060\u206C\u206F\u2063\u2064",
    'embedded.confluence.footer.prefix': "\u2063\u2062Powered by\u206C\x8f\u206B\u206E\u206B\u200C\x8d\x90\u206C\x81\x8f\u206C\x8f\u200C\x8d\x9d\u206F\u061C\u206E\x9d\u206D\x9d\u206F\x90\u061C\u061C\u200C\x8f\u200C\u206B\u206F\u200C\u2063\u2064",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u2063\u2062Log in to Confluence\u061C\u2060\u2060\u206F\x8d\u2061\u206E\x81\x9d\x90\x8f\u206E\x81\x8d\x8f\x90\u206F\u2061\u061C\x8d\u206C\u206D\u206A\x81\u206D\x9d\u206A\x8f\u206E\x81\u206E\u206D\u2063\u2064",
    'embedded.confluence.login-page.login-button': "\u2063\u2062Log in to Confluence\u206D\u206A\u206A\x8d\u206F\u061C\u200C\u061C\u206C\u206B\u2061\u061C\u200C\x90\u206A\u206D\u206A\u206B\u200D\u061C\u206B\x8f\x90\u200C\u206B\u206E\u206C\u206A\u2061\x81\u206A\x90\u2063\u2064",
    'embedded.confluence.login-page.login-button.aria-label': "\u2063\u2062Login Button\x8d\x90\u206E\x90\u206D\x8d\u061C\u200C\u206E\x90\x8d\u061C\u2060\u200D\u206F\x8d\u206D\u2061\x81\u200D\x90\x8d\x90\x90\x9d\u061C\u206F\x81\u206E\u200C\x9d\x90\u2063\u2064",
    'embedded.confluence.login-page.login-text': "\u2063\u2062You need to be logged in to view this page\u206F\u206A\u200C\x8d\u206E\x81\x81\u2061\x81\x90\u206F\u2060\x8d\u206E\x8f\x9d\x90\u2061\u2061\u206F\u200D\x81\x90\u206C\u206D\u206B\x90\u206A\u206E\u2060\u2061\x90\u2063\u2064",
    'embedded.confluence.login-page.refresh-page-banner': "\u2063\u2062After logging in, this page should refresh automatically. If not, you can click here to refresh\u200C\x81\u200D\u200D\u206F\u206D\x90\u200C\u206D\x81\u2060\u206A\u2061\x8d\u206C\u200C\x90\x8d\x8f\x8f\u2061\x9d\u206E\x9d\u2060\u2061\u2060\u061C\x8f\u206C\u206D\u2061\u2063\u2064",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u2063\u2062Refresh page\u2060\x90\u2061\u061C\u200D\u206E\x8d\x90\u200D\x9d\u2060\u206A\u2061\x90\x8d\x8f\u206E\x8d\x9d\u206A\x9d\u061C\u206B\x8f\u206B\u200D\u061C\u206E\u206A\u206C\u206A\x90\u2063\u2064",
    'embedded.confluence.need-to-log-in-paragraph': "\u2063\u2062You need to be logged in to view this page\u200D\u061C\u206D\u206C\u206E\u206D\u206F\x8d\u206F\x8d\u061C\u206E\u206A\u206F\u206E\u206C\u206F\u200D\x90\u2061\x81\x90\x81\u206E\x8d\x8f\x8f\x90\u206D\x90\u206C\u206F\u2063\u2064",
    'embedded.confluence.still-having-trouble-paragraph': "\u2063\u2062Still having trouble? Make sure 3rd party cookies are enabled, or {link}\x90\x90\u061C\u206E\x90\u206D\x90\x8f\u200D\x8d\x8d\u061C\u206D\x9d\x9d\x90\u061C\u206D\x8d\x8f\u061C\u200C\u2061\u206E\u206A\x9d\x9d\u206F\x81\u206F\u2061\u206F\u2063\u2064",
    'embedded.confluence.troubleshooting-link-text': "\u2063\u2062refer to this troubleshooting guide.\u206C\u206A\x90\u206D\u2061\x81\x8d\x8f\u206F\x9d\u206B\u206C\x81\u206A\u206B\u206C\u200D\u200C\x8d\u206B\u200C\x90\u206C\u061C\u061C\x8f\u2061\x9d\u2060\u206A\u2060\u061C\u2063\u2064",
    'embedded.confluence.troubleshooting-link.aria-label': "\u2063\u2062troubleshooting guide link\u200C\x90\u206C\u206D\u206E\x9d\u206D\u200D\x90\x8f\u200D\x8f\x90\u206A\u206D\x90\u206D\u200C\u200D\u206F\u206A\x90\u206F\x90\u200C\u2061\x90\u206E\u200D\x8d\u206C\u206A\u2063\u2064"
};


var $d507afa8475356fa$export$2e2bcd8739ae039 = (0, $579e481994b7c57c$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $40e92902a452cd4d$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Hemos buscado en todas partes, pero no existe. Puede que se haya borrado. A no ser que la URL contenga un error \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'No hemos podido encontrar lo que buscas.',
    'embedded.confluence.already-logged-in-paragraph': "\xbfHas iniciado sesi\xf3n? Prueba a actualizar.",
    'embedded.confluence.connect-to-confluence.button': 'Conectarse a Confluence',
    'embedded.confluence.connect-to-confluence.button.aria-label': "Bot\xf3n de conexi\xf3n a Confluence",
    'embedded.confluence.connect-to-confluence.description': "Guarda ideas, realiza un seguimiento de los puntos del orden del d\xeda y toma notas en equipo.",
    'embedded.confluence.connect-to-confluence.heading': 'Conectarse a Confluence',
    'embedded.confluence.footer.hover.text': 'Ver en Confluence',
    'embedded.confluence.footer.prefix': "Con tecnolog\xeda de",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Iniciar sesi\xf3n en Confluence",
    'embedded.confluence.login-page.login-button': "Iniciar sesi\xf3n en Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "Bot\xf3n de inicio de sesi\xf3n",
    'embedded.confluence.login-page.login-text': "Tienes que iniciar sesi\xf3n para poder ver esta p\xe1gina",
    'embedded.confluence.login-page.refresh-page-banner': "Tras iniciar sesi\xf3n, esta p\xe1gina deber\xeda actualizarse autom\xe1ticamente. Si no, puedes hacer clic aqu\xed para actualizar.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Actualizar p\xe1gina",
    'embedded.confluence.need-to-log-in-paragraph': "Tienes que iniciar sesi\xf3n para poder ver esta p\xe1gina",
    'embedded.confluence.still-having-trouble-paragraph': "\xbfSigues teniendo problemas? Aseg\xfarate de que las cookies de terceros est\xe1n habilitadas o {link}",
    'embedded.confluence.troubleshooting-link-text': "consulta esta gu\xeda de soluci\xf3n de problemas.",
    'embedded.confluence.troubleshooting-link.aria-label': "enlace a la gu\xeda de soluci\xf3n de problemas"
};


var $385e67f32021aa6d$export$2e2bcd8739ae039 = (0, $40e92902a452cd4d$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Finnish
var $b4c40bf7d224b4bc$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Etsimme kaikkialta, mutta sit\xe4 ei ole olemassa. Se on saatettu poistaa. Paitsi tietenkin jos URL-osoitteessa on kirjoitusvirhe \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Emme l\xf6yt\xe4neet etsim\xe4\xe4si",
    'embedded.confluence.already-logged-in-paragraph': "Oletko jo kirjautuneena sis\xe4\xe4n? Kokeile p\xe4ivitt\xe4\xe4.",
    'embedded.confluence.connect-to-confluence.button': "Yhdist\xe4 Confluenceen",
    'embedded.confluence.connect-to-confluence.button.aria-label': "Yhdist\xe4 Confluenceen \u2011painike",
    'embedded.confluence.connect-to-confluence.description': "Tallenna ideoita, seuraa esityslistan kohteita ja tee muistiinpanoja tiimin\xe4.",
    'embedded.confluence.connect-to-confluence.heading': "Yhdist\xe4 Confluenceen",
    'embedded.confluence.footer.hover.text': "N\xe4yt\xe4 Confluencessa",
    'embedded.confluence.footer.prefix': 'Palvelun tarjoaa',
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Kirjaudu sis\xe4\xe4n Confluenceen",
    'embedded.confluence.login-page.login-button': "Kirjaudu sis\xe4\xe4n Confluenceen",
    'embedded.confluence.login-page.login-button.aria-label': 'Kirjautumispainike',
    'embedded.confluence.login-page.login-text': "Sinun on oltava kirjautuneena sis\xe4\xe4n, jotta voit tarkastella t\xe4t\xe4 sivua",
    'embedded.confluence.login-page.refresh-page-banner': "T\xe4m\xe4n sivun tulisi p\xe4ivitty\xe4 automaattisesti sis\xe4\xe4nkirjautumisen j\xe4lkeen. Jos n\xe4in ei tapahdu, voit p\xe4ivitt\xe4\xe4 sivun napsauttamalla t\xe4t\xe4.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "P\xe4ivit\xe4 sivu",
    'embedded.confluence.need-to-log-in-paragraph': "Sinun on oltava kirjautuneena sis\xe4\xe4n, jotta voit katsoa t\xe4t\xe4 sivua",
    'embedded.confluence.still-having-trouble-paragraph': "Onko sinulla viel\xe4 ongelmia? Varmista, ett\xe4 kolmansien osapuolten ev\xe4steet ovat k\xe4yt\xf6ss\xe4, tai {link}",
    'embedded.confluence.troubleshooting-link-text': "katso t\xe4m\xe4 ongelmanratkaisuopas.",
    'embedded.confluence.troubleshooting-link.aria-label': 'ongelmanratkaisuoppaan linkki'
};


var $1b2d05444ac1591b$export$2e2bcd8739ae039 = (0, $b4c40bf7d224b4bc$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $bdd83afdfe9ecad5$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Nous avons cherch\xe9 partout, mais ce contenu n'existe pas. Il a peut-\xeatre \xe9t\xe9 supprim\xe9. Il est possible que l'URL contienne une faute de frappe. V\xe9rifiez bien \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Impossible de trouver ce que vous recherchez',
    'embedded.confluence.already-logged-in-paragraph': "D\xe9j\xe0 connect\xe9\xa0? Essayez d'actualiser.",
    'embedded.confluence.connect-to-confluence.button': "Connecter \xe0 Confluence",
    'embedded.confluence.connect-to-confluence.button.aria-label': "Bouton Connecter \xe0 Confluence",
    'embedded.confluence.connect-to-confluence.description': "Enregistrez des id\xe9es, suivez les points de l'ordre du jour et prenez des notes en \xe9quipe.",
    'embedded.confluence.connect-to-confluence.heading': "Connecter \xe0 Confluence",
    'embedded.confluence.footer.hover.text': 'Afficher dans Confluence',
    'embedded.confluence.footer.prefix': "Optimis\xe9 par",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Connexion \xe0 Confluence",
    'embedded.confluence.login-page.login-button': "Connexion \xe0 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': 'Bouton de connexion',
    'embedded.confluence.login-page.login-text': "Vous devez \xeatre connect\xe9 pour voir cette page",
    'embedded.confluence.login-page.refresh-page-banner': "Apr\xe8s la connexion, cette page devrait s'actualiser automatiquement. Si ce n'est pas le cas, cliquez ici pour l'actualiser.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Actualiser la page',
    'embedded.confluence.need-to-log-in-paragraph': "Vous devez \xeatre connect\xe9 pour voir cette page",
    'embedded.confluence.still-having-trouble-paragraph': "Vous rencontrez toujours des probl\xe8mes\xa0? Assurez-vous que les cookies tiers sont activ\xe9s, ou {link}.",
    'embedded.confluence.troubleshooting-link-text': "reportez-vous \xe0 ce guide de d\xe9pannage",
    'embedded.confluence.troubleshooting-link.aria-label': "lien vers le guide de d\xe9pannage"
};


var $94b830b71455238d$export$2e2bcd8739ae039 = (0, $bdd83afdfe9ecad5$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Hungarian
var $7648c8d0d58c6b10$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Megpr\xf3b\xe1ltuk megkeresni, de nincs ilyen oldal. Lehet, hogy t\xf6r\xf6lt\xe9k. Az is lehet, hogy csak el\xedrtad az URL-t \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Nem tal\xe1ltuk meg, amit keresel",
    'embedded.confluence.already-logged-in-paragraph': "M\xe1r bejelentkezt\xe9l? Pr\xf3b\xe1lj meg friss\xedteni.",
    'embedded.confluence.connect-to-confluence.button': "Confluence csatlakoztat\xe1sa",
    'embedded.confluence.connect-to-confluence.button.aria-label': "Confluence csatlakoztat\xe1sa gomb",
    'embedded.confluence.connect-to-confluence.description': "Csapatk\xe9nt menthetitek az \xf6tleteket, nyomon k\xf6vethetitek a napirendi pontokat \xe9s jegyzetelhettek.",
    'embedded.confluence.connect-to-confluence.heading': "Csatlakoz\xe1s a Confluence-hez",
    'embedded.confluence.footer.hover.text': "Megtekint\xe9s a Confluence-ben",
    'embedded.confluence.footer.prefix': "Szolg\xe1ltat\xf3:",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Bejelentkez\xe9s a Confluence-be",
    'embedded.confluence.login-page.login-button': "Bejelentkez\xe9s a Confluence-be",
    'embedded.confluence.login-page.login-button.aria-label': "Bejelentkez\xe9s gomb",
    'embedded.confluence.login-page.login-text': "Az oldal megtekint\xe9s\xe9hez be kell jelentkezned",
    'embedded.confluence.login-page.refresh-page-banner': "Bejelentkez\xe9s ut\xe1n az oldal automatikusan friss\xfcl. Ha nem, kattints ide a friss\xedt\xe9shez.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Oldal friss\xedt\xe9se",
    'embedded.confluence.need-to-log-in-paragraph': "Az oldal megtekint\xe9s\xe9hez be kell jelentkezned",
    'embedded.confluence.still-having-trouble-paragraph': "M\xe9g mindig probl\xe9m\xe1ba \xfctk\xf6z\xf6l? Gy\u0151z\u0151dj meg r\xf3la, hogy enged\xe9lyezted a harmadik felekt\u0151l sz\xe1rmaz\xf3 s\xfctiket, vagy {link}",
    'embedded.confluence.troubleshooting-link-text': "olvasd el ezt a hibaelh\xe1r\xedt\xe1si \xfatmutat\xf3t.",
    'embedded.confluence.troubleshooting-link.aria-label': "hibaelh\xe1r\xedt\xe1si \xfatmutat\xf3 linkje"
};


var $4b30be4ed3b30b71$export$2e2bcd8739ae039 = (0, $7648c8d0d58c6b10$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $33c2ed14ec726faf$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Abbiamo cercato ovunque, ma la pagina non esiste. Potrebbe essere stata eliminata, o forse hai sbagliato a scrivere l'URL \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Non siamo riusciti a trovare la pagina cercata',
    'embedded.confluence.already-logged-in-paragraph': "Hai gi\xe0 effettuato l'accesso? Prova ad aggiornare la pagina.",
    'embedded.confluence.connect-to-confluence.button': 'Connetti Confluence',
    'embedded.confluence.connect-to-confluence.button.aria-label': 'Pulsante Connetti Confluence',
    'embedded.confluence.connect-to-confluence.description': "Memorizza le idee, monitora le voci all'ordine del giorno e prendi appunti insieme ai colleghi del team.",
    'embedded.confluence.connect-to-confluence.heading': 'Connetti a Confluence',
    'embedded.confluence.footer.hover.text': 'Visualizza in Confluence',
    'embedded.confluence.footer.prefix': 'Offerto da',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Accedi a Confluence',
    'embedded.confluence.login-page.login-button': 'Accedi a Confluence',
    'embedded.confluence.login-page.login-button.aria-label': 'Pulsante di accesso',
    'embedded.confluence.login-page.login-text': "Per visualizzare questa pagina devi avere effettuato l'accesso.",
    'embedded.confluence.login-page.refresh-page-banner': "Dopo l'accesso, questa pagina dovrebbe aggiornarsi automaticamente. In caso contrario, clicca qui per aggiornarla",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Aggiorna la pagina',
    'embedded.confluence.need-to-log-in-paragraph': "Deve avere effettuato l'accesso per visualizzare questa pagina",
    'embedded.confluence.still-having-trouble-paragraph': 'Riscontri ancora problemi? Assicurati che i cookie di terze parti siano abilitati, oppure {link}',
    'embedded.confluence.troubleshooting-link-text': 'consulta questa guida alla risoluzione dei problemi.',
    'embedded.confluence.troubleshooting-link.aria-label': 'link alla guida alla risoluzione dei problemi'
};


var $b50005aafa8cdb37$export$2e2bcd8739ae039 = (0, $33c2ed14ec726faf$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $36b62ea78ba1a889$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u304A\u63A2\u3057\u306E\u30DA\u30FC\u30B8\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002\u524A\u9664\u3055\u308C\u305F\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002URL \u306B\u5165\u529B\u30DF\u30B9\u304C\u306A\u3044\u304B\u3001\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u304A\u63A2\u3057\u306E\u3082\u306E\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F",
    'embedded.confluence.already-logged-in-paragraph': "\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u3044\u307E\u3059\u304B?\u66F4\u65B0\u3057\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002",
    'embedded.confluence.connect-to-confluence.button': "Confluence \u306B\u63A5\u7D9A",
    'embedded.confluence.connect-to-confluence.button.aria-label': '"Confluence \u306B\u63A5\u7D9A" \u30DC\u30BF\u30F3',
    'embedded.confluence.connect-to-confluence.description': "\u30C1\u30FC\u30E0\u3067\u5354\u529B\u3057\u3066\u30A2\u30A4\u30C7\u30A2\u3092\u4FDD\u5B58\u3057\u3001\u8B70\u984C\u9805\u76EE\u3092\u8FFD\u8DE1\u3057\u3066\u30E1\u30E2\u3092\u53D6\u308A\u307E\u3057\u3087\u3046\u3002",
    'embedded.confluence.connect-to-confluence.heading': "Confluence \u306B\u63A5\u7D9A\u3059\u308B",
    'embedded.confluence.footer.hover.text': "Confluence \u3067\u8868\u793A",
    'embedded.confluence.footer.prefix': "\u4F7F\u7528\u30BD\u30EA\u30E5\u30FC\u30B7\u30E7\u30F3: ",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Confluence \u306B\u30ED\u30B0\u30A4\u30F3",
    'embedded.confluence.login-page.login-button': "Confluence \u306B\u30ED\u30B0\u30A4\u30F3",
    'embedded.confluence.login-page.login-button.aria-label': "\u30ED\u30B0\u30A4\u30F3 \u30DC\u30BF\u30F3",
    'embedded.confluence.login-page.login-text': "\u3053\u306E\u30DA\u30FC\u30B8\u3092\u8868\u793A\u3059\u308B\u306B\u306F\u3001\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059",
    'embedded.confluence.login-page.refresh-page-banner': "\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u3068\u3001\u3053\u306E\u30DA\u30FC\u30B8\u306F\u81EA\u52D5\u3067\u66F4\u65B0\u3055\u308C\u307E\u3059\u3002\u66F4\u65B0\u3055\u308C\u306A\u3044\u5834\u5408\u306F\u3001\u3053\u3053\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u66F4\u65B0\u3067\u304D\u307E\u3059",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u30DA\u30FC\u30B8\u3092\u66F4\u65B0",
    'embedded.confluence.need-to-log-in-paragraph': "\u3053\u306E\u30DA\u30FC\u30B8\u3092\u8868\u793A\u3059\u308B\u306B\u306F\u3001\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002",
    'embedded.confluence.still-having-trouble-paragraph': "\u554F\u984C\u304C\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u3001\u30B5\u30FC\u30C9\u30D1\u30FC\u30C6\u30A3 Cookie \u304C\u6709\u52B9\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u307E\u305F\u306F\u3001{link}",
    'embedded.confluence.troubleshooting-link-text': "\u3053\u306E\u30C8\u30E9\u30D6\u30EB\u30B7\u30E5\u30FC\u30C6\u30A3\u30F3\u30B0 \u30AC\u30A4\u30C9\u3092\u53C2\u7167\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'embedded.confluence.troubleshooting-link.aria-label': "\u30C8\u30E9\u30D6\u30EB\u30B7\u30E5\u30FC\u30C6\u30A3\u30F3\u30B0 \u30AC\u30A4\u30C9\u306E\u30EA\u30F3\u30AF"
};


var $f077125da86827d1$export$2e2bcd8739ae039 = (0, $36b62ea78ba1a889$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $22cd7a5c67ee6762$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\uC790\uC138\uD788 \uB458\uB7EC\uBCF4\uC558\uC9C0\uB9CC \uCC3E\uC744 \uC218\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4. \uC0AD\uC81C\uB418\uC5C8\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4. URL\uC5D0 \uC785\uB825 \uC624\uB958\uAC00 \uC788\uB294\uC9C0 \uD655\uC778\uD574\uBCF4\uC138\uC694 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\uC6D0\uD558\uB294 \uD56D\uBAA9\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
    'embedded.confluence.already-logged-in-paragraph': "\uC774\uBBF8 \uB85C\uADF8\uC778\uD558\uC168\uC2B5\uB2C8\uAE4C? \uC0C8\uB85C \uACE0\uCCD0 \uBCF4\uC138\uC694.",
    'embedded.confluence.connect-to-confluence.button': "Confluence \uC5F0\uACB0",
    'embedded.confluence.connect-to-confluence.button.aria-label': "Confluence \uC5F0\uACB0 \uBC84\uD2BC",
    'embedded.confluence.connect-to-confluence.description': "\uD55C \uD300\uC73C\uB85C \uD568\uAED8 \uC544\uC774\uB514\uC5B4\uB97C \uC800\uC7A5\uD558\uACE0 \uC5B4\uC820\uB354 \uD56D\uBAA9\uC744 \uCD94\uC801\uD558\uBA70 \uBA54\uBAA8\uB97C \uC791\uC131\uD569\uB2C8\uB2E4.",
    'embedded.confluence.connect-to-confluence.heading': "Confluence\uC5D0 \uC5F0\uACB0",
    'embedded.confluence.footer.hover.text': "Confluence\uC5D0\uC11C \uBCF4\uAE30",
    'embedded.confluence.footer.prefix': "\uC81C\uACF5:",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Confluence\uC5D0 \uB85C\uADF8\uC778",
    'embedded.confluence.login-page.login-button': "Confluence\uC5D0 \uB85C\uADF8\uC778",
    'embedded.confluence.login-page.login-button.aria-label': "\uB85C\uADF8\uC778 \uBC84\uD2BC",
    'embedded.confluence.login-page.login-text': "\uC774 \uD398\uC774\uC9C0\uB97C \uBCF4\uB824\uBA74 \uB85C\uADF8\uC778\uD574\uC57C \uD569\uB2C8\uB2E4",
    'embedded.confluence.login-page.refresh-page-banner': "\uB85C\uADF8\uC778\uD558\uBA74 \uC774 \uD398\uC774\uC9C0\uAC00 \uC790\uB3D9\uC73C\uB85C \uC0C8\uB85C \uACE0\uCCD0\uC9D1\uB2C8\uB2E4. \uADF8\uB807\uC9C0 \uC54A\uC740 \uACBD\uC6B0 \uC5EC\uAE30\uB97C \uD074\uB9AD\uD558\uC5EC \uC0C8\uB85C \uACE0\uCE60 \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\uD398\uC774\uC9C0 \uC0C8\uB85C \uACE0\uCE58\uAE30",
    'embedded.confluence.need-to-log-in-paragraph': "\uC774 \uD398\uC774\uC9C0\uB97C \uBCF4\uB824\uBA74 \uB85C\uADF8\uC778\uD574\uC57C \uD569\uB2C8\uB2E4",
    'embedded.confluence.still-having-trouble-paragraph': "\uC544\uC9C1 \uBB38\uC81C\uAC00 \uC788\uC2B5\uB2C8\uAE4C? \uD0C0\uC0AC \uCFE0\uD0A4\uB97C \uC0AC\uC6A9\uC73C\uB85C \uC124\uC815\uD588\uB294\uC9C0 \uD655\uC778\uD558\uAC70\uB098 {link}",
    'embedded.confluence.troubleshooting-link-text': "\uBB38\uC81C \uD574\uACB0 \uAC00\uC774\uB4DC\uB97C \uCC38\uC870\uD558\uC138\uC694.",
    'embedded.confluence.troubleshooting-link.aria-label': "\uBB38\uC81C \uD574\uACB0 \uAC00\uC774\uB4DC \uB9C1\uD06C"
};


var $868a4c9b763bf2ad$export$2e2bcd8739ae039 = (0, $22cd7a5c67ee6762$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Norwegian (Bokmål)
var $4dc2b6099fd0ce77$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Vi har sett overalt, men dette innholdet eksisterer ikke. Det kan ha blitt slettet. Med mindre nettadressen har en skrivefeil \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Vi finner ikke det du leter etter',
    'embedded.confluence.already-logged-in-paragraph': "Er du allerede logget p\xe5? Pr\xf8v \xe5 oppdatere.",
    'embedded.confluence.connect-to-confluence.button': 'Koble til Confluence',
    'embedded.confluence.connect-to-confluence.button.aria-label': "Knapp for \xe5 koble til Confluence",
    'embedded.confluence.connect-to-confluence.description': "Lagre id\xe9er, spor elementer fra dagsordenen og ta notater sammen som et team.",
    'embedded.confluence.connect-to-confluence.heading': 'Koble til Confluence',
    'embedded.confluence.footer.hover.text': 'Vis i Confluence',
    'embedded.confluence.footer.prefix': 'Levert av',
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Logg p\xe5 Confluence",
    'embedded.confluence.login-page.login-button': "Logg p\xe5 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "P\xe5loggingsknapp",
    'embedded.confluence.login-page.login-text': "Du m\xe5 v\xe6re logget p\xe5 for \xe5 se denne siden",
    'embedded.confluence.login-page.refresh-page-banner': "Etter p\xe5logging skal denne siden oppdateres automatisk. Hvis ikke, kan du klikke her for \xe5 oppdatere",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Oppdater siden',
    'embedded.confluence.need-to-log-in-paragraph': "Du m\xe5 v\xe6re logget p\xe5 for \xe5 se denne siden",
    'embedded.confluence.still-having-trouble-paragraph': 'Har du fortsatt problemer? Kontroller at tredjeparts informasjonskapsler er aktivert, eller {link}',
    'embedded.confluence.troubleshooting-link-text': "se denne feils\xf8kingsveiledningen.",
    'embedded.confluence.troubleshooting-link.aria-label': "kobling til feils\xf8kingsveiledning"
};


var $4d7c9006deba4c39$export$2e2bcd8739ae039 = (0, $4dc2b6099fd0ce77$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $c705c4b91c52e7ab$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "We hebben overal gezocht, maar de pagina bestaat niet. Het kan zijn dat deze verwijderd is. Tenzij de URL een typefout bevat \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'We konden niet vinden wat je zocht',
    'embedded.confluence.already-logged-in-paragraph': 'Al ingelogd? Probeer te vernieuwen.',
    'embedded.confluence.connect-to-confluence.button': 'Confluence koppelen',
    'embedded.confluence.connect-to-confluence.button.aria-label': 'Knop Confluence koppelen',
    'embedded.confluence.connect-to-confluence.description': "Bewaar idee\xebn, houd agenda-items bij en maak samen aantekeningen als team.",
    'embedded.confluence.connect-to-confluence.heading': 'Koppelen aan Confluence',
    'embedded.confluence.footer.hover.text': 'Weergeven in Confluence',
    'embedded.confluence.footer.prefix': 'Mogelijk gemaakt door',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Inloggen bij Confluence',
    'embedded.confluence.login-page.login-button': 'Inloggen bij Confluence',
    'embedded.confluence.login-page.login-button.aria-label': 'Login-knop',
    'embedded.confluence.login-page.login-text': 'Je moet ingelogd zijn om deze pagina te bekijken',
    'embedded.confluence.login-page.refresh-page-banner': 'Nadat je bent ingelogd, moet deze pagina automatisch vernieuwen. Als dit niet gebeurt, kun je hier klikken om te vernieuwen',
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Pagina vernieuwen',
    'embedded.confluence.need-to-log-in-paragraph': 'Je moet ingelogd zijn om deze pagina te bekijken',
    'embedded.confluence.still-having-trouble-paragraph': 'Nog steeds niet gelukt? Zorg ervoor dat cookies van derden zijn ingeschakeld of {link}',
    'embedded.confluence.troubleshooting-link-text': 'raadpleeg deze handleiding voor probleemoplossing.',
    'embedded.confluence.troubleshooting-link.aria-label': 'link naar handleiding voor probleemoplossing'
};


var $521991fea9a662cf$export$2e2bcd8739ae039 = (0, $c705c4b91c52e7ab$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Polish (Poland)
var $5b0fe9bee1144bdb$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Szukali\u015Bmy tej strony wsz\u0119dzie, ale nigdzie jej nie ma. Mo\u017Cliwe, \u017Ce\xa0zosta\u0142a usuni\u0119ta. O\xa0ile, oczywi\u015Bcie, do\xa0adresu URL nie wkrad\u0142a si\u0119 liter\xf3wka \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Nie mo\u017Cna znale\u017A\u0107 tego, czego szukasz",
    'embedded.confluence.already-logged-in-paragraph': "Ju\u017C przeprowadzono logowanie? Spr\xf3buj od\u015Bwie\u017Cy\u0107.",
    'embedded.confluence.connect-to-confluence.button': "Po\u0142\u0105cz Confluence",
    'embedded.confluence.connect-to-confluence.button.aria-label': "Przycisk Po\u0142\u0105cz Confluence",
    'embedded.confluence.connect-to-confluence.description': "Zapisuj pomys\u0142y, \u015Bled\u017A elementy agendy i\xa0r\xf3b notatki wsp\xf3lnie jako zesp\xf3\u0142.",
    'embedded.confluence.connect-to-confluence.heading': "\u0141\u0105czenie z\xa0Confluence",
    'embedded.confluence.footer.hover.text': "Wy\u015Bwietl w Confluence",
    'embedded.confluence.footer.prefix': "Obs\u0142ugiwane przez",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Zaloguj si\u0119 w Confluence",
    'embedded.confluence.login-page.login-button': "Zaloguj si\u0119 w systemie Confluence",
    'embedded.confluence.login-page.login-button.aria-label': 'Przycisk logowania',
    'embedded.confluence.login-page.login-text': "Musisz si\u0119 zalogowa\u0107, aby wy\u015Bwietli\u0107 t\u0119 stron\u0119.",
    'embedded.confluence.login-page.refresh-page-banner': "Po zalogowaniu ta strona powinna od\u015Bwie\u017Cy\u0107 si\u0119 automatycznie. Je\u015Bli tak si\u0119 nie stanie, kliknij tutaj, aby od\u015Bwie\u017Cy\u0107.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Od\u015Bwie\u017C stron\u0119",
    'embedded.confluence.need-to-log-in-paragraph': "Musisz si\u0119 zalogowa\u0107, aby wy\u015Bwietli\u0107 t\u0119 stron\u0119.",
    'embedded.confluence.still-having-trouble-paragraph': "Nadal masz problem? Upewnij si\u0119, \u017Ce obs\u0142uga plik\xf3w cookie innych firm jest w\u0142\u0105czona lub {link}.",
    'embedded.confluence.troubleshooting-link-text': "zapoznaj si\u0119 z tym przewodnikiem rozwi\u0105zywania problem\xf3w",
    'embedded.confluence.troubleshooting-link.aria-label': "\u0142\u0105cze do przewodnika rozwi\u0105zywania problem\xf3w"
};


var $7bbbb92191457c96$export$2e2bcd8739ae039 = (0, $5b0fe9bee1144bdb$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $c92f8c294067992a$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "A gente procurou em todo lugar, mas ela n\xe3o existe. Talvez tenha sido exclu\xedda. A menos, \xe9 claro, que o URL contenha um erro de digita\xe7\xe3o \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "N\xe3o foi poss\xedvel encontrar o que voc\xea est\xe1 procurando",
    'embedded.confluence.already-logged-in-paragraph': "J\xe1 entrou? Experimente atualizar.",
    'embedded.confluence.connect-to-confluence.button': 'Conectar ao Confluence',
    'embedded.confluence.connect-to-confluence.button.aria-label': "Bot\xe3o de conectar ao Confluence",
    'embedded.confluence.connect-to-confluence.description': "Salve ideias, acompanhe itens da agenda e fa\xe7a anota\xe7\xf5es em equipe.",
    'embedded.confluence.connect-to-confluence.heading': 'Conectar ao Confluence',
    'embedded.confluence.footer.hover.text': 'Visualizar no Confluence',
    'embedded.confluence.footer.prefix': "Distribu\xeddo por",
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Entrar no Confluence',
    'embedded.confluence.login-page.login-button': 'Entrar no Confluence',
    'embedded.confluence.login-page.login-button.aria-label': "Bot\xe3o Entrar",
    'embedded.confluence.login-page.login-text': "Voc\xea precisa entrar para ver esta p\xe1gina",
    'embedded.confluence.login-page.refresh-page-banner': "Depois do login, a atualiza\xe7\xe3o da p\xe1gina \xe9 autom\xe1tica. Se isso n\xe3o acontecer, voc\xea pode clicar aqui para atualizar",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Atualizar p\xe1gina",
    'embedded.confluence.need-to-log-in-paragraph': "Voc\xea precisa entrar para ver esta p\xe1gina",
    'embedded.confluence.still-having-trouble-paragraph': "Ainda est\xe1 tendo problemas? Verifique se os cookies de terceiros est\xe3o habilitados ou {link}",
    'embedded.confluence.troubleshooting-link-text': "consulte este guia de solu\xe7\xe3o de problemas.",
    'embedded.confluence.troubleshooting-link.aria-label': "link do guia de solu\xe7\xe3o de problemas"
};


var $0c66aef1185c0863$export$2e2bcd8739ae039 = (0, $c92f8c294067992a$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $d9571ed0daaca321$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u041C\u044B \u0438\u0441\u043A\u0430\u043B\u0438 \u043F\u043E\u0432\u0441\u044E\u0434\u0443, \u043D\u043E \u0442\u0430\u043A\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442. \u0412\u043E\u0437\u043C\u043E\u0436\u043D\u043E, \u043E\u043D\u0430 \u0431\u044B\u043B\u0430 \u0443\u0434\u0430\u043B\u0435\u043D\u0430. \u0415\u0441\u043B\u0438, \u043A\u043E\u043D\u0435\u0447\u043D\u043E, URL-\u0430\u0434\u0440\u0435\u0441 \u0443\u043A\u0430\u0437\u0430\u043D \u0432\u0435\u0440\u043D\u043E \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043D\u0430\u0439\u0442\u0438 \u0442\u043E, \u0447\u0442\u043E \u0432\u044B \u0438\u0449\u0435\u0442\u0435",
    'embedded.confluence.already-logged-in-paragraph': "\u0412\u044B \u0443\u0436\u0435 \u0432\u043E\u0448\u043B\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443? \u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443.",
    'embedded.confluence.connect-to-confluence.button': "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043A Confluence",
    'embedded.confluence.connect-to-confluence.button.aria-label': "\u041A\u043D\u043E\u043F\u043A\u0430 \xab\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043A Confluence\xbb",
    'embedded.confluence.connect-to-confluence.description': "\u0424\u0438\u043A\u0441\u0438\u0440\u0443\u0439\u0442\u0435 \u0438\u0434\u0435\u0438, \u043E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u0439\u0442\u0435 \u043F\u0443\u043D\u043A\u0442\u044B \u043F\u043E\u0432\u0435\u0441\u0442\u043A\u0438 \u0434\u043D\u044F \u0438 \u0434\u0435\u043B\u0430\u0439\u0442\u0435 \u0437\u0430\u043C\u0435\u0442\u043A\u0438 \u0432\u0441\u0435\u0439 \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u0439.",
    'embedded.confluence.connect-to-confluence.heading': "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u0441\u044C \u043A Confluence",
    'embedded.confluence.footer.hover.text': "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0432 Confluence",
    'embedded.confluence.footer.prefix': "\u041F\u0440\u0438 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0435",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u0412\u043E\u0439\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.login-page.login-button': "\u0412\u043E\u0439\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u041A\u043D\u043E\u043F\u043A\u0430 \u0432\u0445\u043E\u0434\u0430",
    'embedded.confluence.login-page.login-text': "\u0414\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u044D\u0442\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
    'embedded.confluence.login-page.refresh-page-banner': "\u041F\u043E\u0441\u043B\u0435 \u0432\u0445\u043E\u0434\u0430 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C\u0441\u044F. \u0415\u0441\u043B\u0438 \u044D\u0442\u043E\u0433\u043E \u043D\u0435 \u043F\u0440\u043E\u0438\u0437\u043E\u0439\u0434\u0435\u0442, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u0437\u0434\u0435\u0441\u044C, \u0447\u0442\u043E\u0431\u044B \u0435\u0435 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443",
    'embedded.confluence.need-to-log-in-paragraph': "\u0414\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u044D\u0442\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
    'embedded.confluence.still-having-trouble-paragraph': "\u041F\u0440\u043E\u0431\u043B\u0435\u043C\u0430 \u043D\u0435 \u0438\u0441\u0447\u0435\u0437\u043B\u0430? \u0423\u0431\u0435\u0434\u0438\u0442\u0435\u0441\u044C, \u0447\u0442\u043E \u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0438\u0435 \u0444\u0430\u0439\u043B\u044B cookie \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u044B, \u0438\u043B\u0438 {link}",
    'embedded.confluence.troubleshooting-link-text': "\u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u043A \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u0443 \u043F\u043E \u0443\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u044E \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A.",
    'embedded.confluence.troubleshooting-link.aria-label': "\u0441\u0441\u044B\u043B\u043A\u0430 \u043D\u0430 \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u043E \u043F\u043E \u0443\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u044E \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A"
};


var $b5d5e4944e9d807e$export$2e2bcd8739ae039 = (0, $d9571ed0daaca321$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $7b0f1a2d1981f277$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Vi tittade \xf6verallt, men den finns bara inte. Den kan ha raderats. S\xe5vida webbadressen inte inneh\xe5ller n\xe5got stavfel \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Vi hittar inte det du letar efter',
    'embedded.confluence.already-logged-in-paragraph': "\xc4r du redan inloggad? Uppdatera sidan.",
    'embedded.confluence.connect-to-confluence.button': 'Anslut till Confluence',
    'embedded.confluence.connect-to-confluence.button.aria-label': 'Knappen Anslut till Confluence',
    'embedded.confluence.connect-to-confluence.description': "Spara id\xe9er, sp\xe5ra dagordningspunkter och anteckna tillsammans som ett team.",
    'embedded.confluence.connect-to-confluence.heading': 'Anslut till Confluence',
    'embedded.confluence.footer.hover.text': 'Visa i Confluence',
    'embedded.confluence.footer.prefix': 'Drivs av',
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Logga in p\xe5 Confluence",
    'embedded.confluence.login-page.login-button': "Logga in p\xe5 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': 'Inloggningsknapp',
    'embedded.confluence.login-page.login-text': "Du m\xe5ste vara inloggad f\xf6r att visa den h\xe4r sidan",
    'embedded.confluence.login-page.refresh-page-banner': "Den h\xe4r sidan b\xf6r uppdateras automatiskt efter inloggningen. Annars kan du klicka h\xe4r f\xf6r att uppdatera den",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Uppdatera sidan',
    'embedded.confluence.need-to-log-in-paragraph': "Du m\xe5ste vara inloggad f\xf6r att visa den h\xe4r sidan",
    'embedded.confluence.still-having-trouble-paragraph': "Har du fortfarande problem? Se till att cookies f\xf6r tredje parter \xe4r aktiverade, eller {link}",
    'embedded.confluence.troubleshooting-link-text': "kolla in den h\xe4r fels\xf6kningsguiden.",
    'embedded.confluence.troubleshooting-link.aria-label': "l\xe4nk till fels\xf6kningsguide"
};


var $be6223e8fd3f47b0$export$2e2bcd8739ae039 = (0, $7b0f1a2d1981f277$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Thai (Thailand)
var $89fd4f00dd98f102$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u0E40\u0E23\u0E32\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E17\u0E38\u0E01\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27 \u0E41\u0E15\u0E48\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23 \u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2D\u0E32\u0E08\u0E16\u0E39\u0E01\u0E25\u0E1A\u0E2D\u0E2D\u0E01\u0E44\u0E1B\u0E41\u0E25\u0E49\u0E27 \u0E2B\u0E23\u0E37\u0E2D\u0E2D\u0E32\u0E08\u0E21\u0E35\u0E01\u0E32\u0E23\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E1C\u0E34\u0E14\u0E43\u0E19 URL \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E2A\u0E34\u0E48\u0E07\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E04\u0E49\u0E19\u0E2B\u0E32",
    'embedded.confluence.already-logged-in-paragraph': "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E41\u0E25\u0E49\u0E27\u0E43\u0E0A\u0E48\u0E44\u0E2B\u0E21 \u0E25\u0E2D\u0E07\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E2B\u0E19\u0E49\u0E32",
    'embedded.confluence.connect-to-confluence.button': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D Confluence",
    'embedded.confluence.connect-to-confluence.button.aria-label': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E1B\u0E38\u0E48\u0E21 Confluence",
    'embedded.confluence.connect-to-confluence.description': "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E44\u0E2D\u0E40\u0E14\u0E35\u0E22 \u0E15\u0E34\u0E14\u0E15\u0E32\u0E21\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E27\u0E32\u0E23\u0E30\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E0A\u0E38\u0E21 \u0E41\u0E25\u0E30\u0E08\u0E14\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E14\u0E49\u0E27\u0E22\u0E01\u0E31\u0E19\u0E40\u0E1B\u0E47\u0E19\u0E17\u0E35\u0E21",
    'embedded.confluence.connect-to-confluence.heading': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D Confluence",
    'embedded.confluence.footer.hover.text': "\u0E14\u0E39\u0E43\u0E19 Confluence",
    'embedded.confluence.footer.prefix': "\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19\u0E42\u0E14\u0E22",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A Confluence",
    'embedded.confluence.login-page.login-button': "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u0E1B\u0E38\u0E48\u0E21\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A",
    'embedded.confluence.login-page.login-text': "\u0E04\u0E38\u0E13\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E39\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49",
    'embedded.confluence.login-page.refresh-page-banner': "\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E41\u0E25\u0E49\u0E27 \u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E19\u0E35\u0E49\u0E04\u0E27\u0E23\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34 \u0E2B\u0E32\u0E01\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34 \u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E04\u0E25\u0E34\u0E01\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
    'embedded.confluence.need-to-log-in-paragraph': "\u0E04\u0E38\u0E13\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E39\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49",
    'embedded.confluence.still-having-trouble-paragraph': "\u0E22\u0E31\u0E07\u0E04\u0E07\u0E21\u0E35\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E43\u0E0A\u0E48\u0E44\u0E2B\u0E21 \u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E04\u0E38\u0E01\u0E01\u0E35\u0E49\u0E02\u0E2D\u0E07\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21\u0E2D\u0E22\u0E39\u0E48 \u0E2B\u0E23\u0E37\u0E2D {link}",
    'embedded.confluence.troubleshooting-link-text': "\u0E14\u0E39\u0E17\u0E35\u0E48\u0E04\u0E39\u0E48\u0E21\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E19\u0E35\u0E49",
    'embedded.confluence.troubleshooting-link.aria-label': "\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E04\u0E39\u0E48\u0E21\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32"
};


var $13ca0cbccf0c03f5$export$2e2bcd8739ae039 = (0, $89fd4f00dd98f102$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Turkish (Turkey)
var $39650a99a995727b$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Her yere bakt\u0131k fakat bulamad\u0131k. Silinmi\u015F olabilir. Tabii e\u011Fer URL'de bir yaz\u0131m hatas\u0131 yoksa \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Arad\u0131\u011F\u0131n\u0131z bulunamad\u0131",
    'embedded.confluence.already-logged-in-paragraph': "Oturumunuz zaten a\xe7\u0131k m\u0131? Sayfay\u0131 yenilemeyi deneyin.",
    'embedded.confluence.connect-to-confluence.button': "Confluence'\u0131 Ba\u011Fla",
    'embedded.confluence.connect-to-confluence.button.aria-label': "Confluence'\u0131 Ba\u011Fla D\xfc\u011Fmesi",
    'embedded.confluence.connect-to-confluence.description': "Fikirleri kaydedin, g\xfcndem \xf6\u011Felerini takip edin ve tak\u0131m olarak birlikte not al\u0131n.",
    'embedded.confluence.connect-to-confluence.heading': "Confluence'a ba\u011Flan",
    'embedded.confluence.footer.hover.text': "Confluence'ta g\xf6r\xfcnt\xfcleyin",
    'embedded.confluence.footer.prefix': "Sa\u011Flayan:",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Confluence'ta oturum a\xe7",
    'embedded.confluence.login-page.login-button': "Confluence'ta oturum a\xe7",
    'embedded.confluence.login-page.login-button.aria-label': "Oturum A\xe7ma D\xfc\u011Fmesi",
    'embedded.confluence.login-page.login-text': "Bu sayfay\u0131 g\xf6r\xfcnt\xfclemek i\xe7in oturum a\xe7man\u0131z gerekir",
    'embedded.confluence.login-page.refresh-page-banner': "Oturum a\xe7t\u0131ktan sonra bu sayfa otomatik olarak yenilenmelidir. Yenilenmezse buraya t\u0131klayarak yenileyebilirsiniz",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Sayfay\u0131 yenile",
    'embedded.confluence.need-to-log-in-paragraph': "Bu sayfay\u0131 g\xf6r\xfcnt\xfclemek i\xe7in oturum a\xe7man\u0131z gerekir",
    'embedded.confluence.still-having-trouble-paragraph': "Sorun ya\u015Famaya devam m\u0131 ediyorsunuz? \xdc\xe7\xfcnc\xfc taraf \xe7erezlerinin etkinle\u015Ftirildi\u011Finden emin olun ya da {link}",
    'embedded.confluence.troubleshooting-link-text': "bu sorun giderme k\u0131lavuzuna ba\u015Fvurun",
    'embedded.confluence.troubleshooting-link.aria-label': "sorun giderme k\u0131lavuzu ba\u011Flant\u0131s\u0131"
};


var $83538994e0c01482$export$2e2bcd8739ae039 = (0, $39650a99a995727b$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Ukrainian (Ukraine)
var $3f06ccd9ea2decf9$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u041D\u0430 \u0436\u0430\u043B\u044C, \u043D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E. \u041C\u043E\u0436\u043B\u0438\u0432\u043E, \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0431\u0443\u043B\u043E \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E. \u042F\u043A\u0449\u043E, \u0437\u0432\u0456\u0441\u043D\u043E, \u0432 URL-\u0430\u0434\u0440\u0435\u0441\u0456 \u043D\u0435\u043C\u0430\u0454 \u043F\u043E\u043C\u0438\u043B\u043A\u0438 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u041D\u0430 \u0436\u0430\u043B\u044C, \u0437\u0430 \u0432\u0430\u0448\u0438\u043C \u0437\u0430\u043F\u0438\u0442\u043E\u043C \u043D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    'embedded.confluence.already-logged-in-paragraph': "\u0423\u0436\u0435 \u0432\u0432\u0456\u0439\u0448\u043B\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443? \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043E\u043D\u043E\u0432\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443.",
    'embedded.confluence.connect-to-confluence.button': "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438 Confluence",
    'embedded.confluence.connect-to-confluence.button.aria-label': "\u041A\u043D\u043E\u043F\u043A\u0430 \xab\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438 Confluence\xbb",
    'embedded.confluence.connect-to-confluence.description': "\u0420\u0430\u0437\u043E\u043C \u0456\u0437 \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u044E \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u0439\u0442\u0435 \u0456\u0434\u0435\u0457, \u0432\u0456\u0434\u0441\u0442\u0435\u0436\u0443\u0439\u0442\u0435 \u043F\u0443\u043D\u043A\u0442\u0438 \u043F\u043E\u0440\u044F\u0434\u043A\u0443 \u0434\u0435\u043D\u043D\u043E\u0433\u043E \u0439 \u0440\u043E\u0431\u0456\u0442\u044C \u043F\u0440\u0438\u043C\u0456\u0442\u043A\u0438.",
    'embedded.confluence.connect-to-confluence.heading': "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F \u0434\u043E Confluence",
    'embedded.confluence.footer.hover.text': "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.footer.prefix': "\u041D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0456",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u0423\u0432\u0456\u0439\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.login-page.login-button': "\u0423\u0432\u0456\u0439\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u041A\u043D\u043E\u043F\u043A\u0430 \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0443",
    'embedded.confluence.login-page.login-text': "\u0429\u043E\u0431 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0446\u044E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443, \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0432\u0456\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
    'embedded.confluence.login-page.refresh-page-banner': "\u041F\u0456\u0441\u043B\u044F \u0432\u0445\u043E\u0434\u0443 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443 \u0446\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430 \u043E\u043D\u043E\u0432\u043B\u044E\u0432\u0430\u0442\u0438\u043C\u0435\u0442\u044C\u0441\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E. \u042F\u043A\u0449\u043E \u043D\u0456, \u0432\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u043D\u0430\u0442\u0438\u0441\u043D\u0443\u0442\u0438 \u0442\u0443\u0442, \u0449\u043E\u0431 \u043E\u043D\u043E\u0432\u0438\u0442\u0438 \u0457\u0457",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u041E\u043D\u043E\u0432\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443",
    'embedded.confluence.need-to-log-in-paragraph': "\u0429\u043E\u0431 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0446\u044E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443, \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0432\u0456\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
    'embedded.confluence.still-having-trouble-paragraph': "\u0414\u043E\u0441\u0456 \u0432\u0438\u043D\u0438\u043A\u0430\u044E\u0442\u044C \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0438? \u041F\u0435\u0440\u0435\u043A\u043E\u043D\u0430\u0439\u0442\u0435\u0441\u044F, \u0449\u043E \u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0456 \u0444\u0430\u0439\u043B\u0438 cookie \u0432\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u043E, \u0430\u0431\u043E {link}.",
    'embedded.confluence.troubleshooting-link-text': "\u0441\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u0439\u0442\u0435\u0441\u044F \u0446\u0438\u043C \u043F\u043E\u0441\u0456\u0431\u043D\u0438\u043A\u043E\u043C \u0437 \u0443\u0441\u0443\u043D\u0435\u043D\u043D\u044F \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A",
    'embedded.confluence.troubleshooting-link.aria-label': "\u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043D\u0430 \u043F\u043E\u0441\u0456\u0431\u043D\u0438\u043A \u0437 \u0443\u0441\u0443\u043D\u0435\u043D\u043D\u044F \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A"
};


var $18a1e8a31eadffa4$export$2e2bcd8739ae039 = (0, $3f06ccd9ea2decf9$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Vietnamese (Vietnam)
var $e984dc452758c2cc$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Ch\xfang t\xf4i \u0111\xe3 t\xecm kh\u1EAFp n\u01A1i nh\u01B0ng n\u1ED9i dung n\xe0y kh\xf4ng t\u1ED3n t\u1EA1i. N\u1ED9i dung n\xe0y c\xf3 th\u1EC3 \u0111\xe3 b\u1ECB x\xf3a. Tr\u1EEB phi c\xf3 l\u1ED7i \u0111\xe1nh m\xe1y trong URL \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Ch\xfang t\xf4i kh\xf4ng t\xecm \u0111\u01B0\u1EE3c nh\u1EEFng g\xec b\u1EA1n mu\u1ED1n",
    'embedded.confluence.already-logged-in-paragraph': "B\u1EA1n \u0111\xe3 \u0111\u0103ng nh\u1EADp? H\xe3y th\u1EED l\xe0m m\u1EDBi.",
    'embedded.confluence.connect-to-confluence.button': "K\u1EBFt n\u1ED1i Confluence",
    'embedded.confluence.connect-to-confluence.button.aria-label': "N\xfat K\u1EBFt n\u1ED1i Confluence",
    'embedded.confluence.connect-to-confluence.description': "L\u01B0u l\u1EA1i c\xe1c \xfd t\u01B0\u1EDFng, theo d\xf5i c\xe1c m\u1EE5c trong ch\u01B0\u01A1ng tr\xecnh ngh\u1ECB s\u1EF1 v\xe0 ghi ch\xfa chung v\u1EDBi c\u1EA3 \u0111\u1ED9i.",
    'embedded.confluence.connect-to-confluence.heading': "K\u1EBFt n\u1ED1i v\u1EDBi Confluence",
    'embedded.confluence.footer.hover.text': 'Xem trong Confluence',
    'embedded.confluence.footer.prefix': "\u0110\u01B0\u1EE3c h\u1ED7 tr\u1EE3 b\u1EDFi",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u0110\u0103ng nh\u1EADp v\xe0o Confluence",
    'embedded.confluence.login-page.login-button': "\u0110\u0103ng nh\u1EADp v\xe0o Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "N\xfat \u0110\u0103ng nh\u1EADp",
    'embedded.confluence.login-page.login-text': "B\u1EA1n c\u1EA7n \u0111\u0103ng nh\u1EADp \u0111\u1EC3 xem trang n\xe0y",
    'embedded.confluence.login-page.refresh-page-banner': "Sau khi \u0111\u0103ng nh\u1EADp, trang n\xe0y s\u1EBD t\u1EF1 \u0111\u1ED9ng l\xe0m m\u1EDBi. N\u1EBFu kh\xf4ng, b\u1EA1n c\xf3 th\u1EC3 b\u1EA5m v\xe0o \u0111\xe2y \u0111\u1EC3 l\xe0m m\u1EDBi",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "L\xe0m m\u1EDBi trang",
    'embedded.confluence.need-to-log-in-paragraph': "B\u1EA1n c\u1EA7n \u0111\u0103ng nh\u1EADp \u0111\u1EC3 xem trang n\xe0y",
    'embedded.confluence.still-having-trouble-paragraph': "B\u1EA1n v\u1EABn g\u1EB7p s\u1EF1 c\u1ED1? \u0110\u1EA3m b\u1EA3o b\u1EA1n \u0111\xe3 b\u1EADt c\xe1c cookie c\u1EE7a b\xean th\u1EE9 3 ho\u1EB7c {link}",
    'embedded.confluence.troubleshooting-link-text': "tham kh\u1EA3o h\u01B0\u1EDBng d\u1EABn kh\u1EAFc ph\u1EE5c s\u1EF1 c\u1ED1 n\xe0y.",
    'embedded.confluence.troubleshooting-link.aria-label': "li\xean k\u1EBFt h\u01B0\u1EDBng d\u1EABn kh\u1EAFc ph\u1EE5c s\u1EF1 c\u1ED1"
};


var $a478f75ee0d1acb9$export$2e2bcd8739ae039 = (0, $e984dc452758c2cc$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Simplified)
var $e712af7d9bcfb0ed$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u6211\u4EEC\u5DF2\u56DB\u5904\u5BFB\u627E\uFF0C\u4F46\u5B83\u5E76\u4E0D\u5B58\u5728\u3002\u5B83\u53EF\u80FD\u5DF2\u88AB\u5220\u9664\u3002\u9664\u975E\u60A8\u7684 URL \u5305\u542B\u9519\u522B\u5B57 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u672A\u627E\u5230\u60A8\u8981\u67E5\u627E\u7684\u9875\u9762",
    'embedded.confluence.already-logged-in-paragraph': "\u5DF2\u767B\u5F55\uFF1F\u8BF7\u5C1D\u8BD5\u5237\u65B0\u3002",
    'embedded.confluence.connect-to-confluence.button': "\u8FDE\u63A5 Confluence",
    'embedded.confluence.connect-to-confluence.button.aria-label': "\u201C\u8FDE\u63A5 Confluence\u201D\u6309\u94AE",
    'embedded.confluence.connect-to-confluence.description': "\u4EE5\u56E2\u961F\u5F62\u5F0F\u5171\u540C\u4FDD\u5B58\u60F3\u6CD5\u3001\u8DDF\u8E2A\u8BAE\u7A0B\u9879\u76EE\u4EE5\u53CA\u505A\u7B14\u8BB0\u3002",
    'embedded.confluence.connect-to-confluence.heading': "\u8FDE\u63A5\u5230 Confluence",
    'embedded.confluence.footer.hover.text': "\u5728 Confluence \u4E2D\u67E5\u770B",
    'embedded.confluence.footer.prefix': "\u6280\u672F\u652F\u6301\uFF1A",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u767B\u5F55\u5230 Confluence",
    'embedded.confluence.login-page.login-button': "\u767B\u5F55 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u767B\u5F55\u6309\u94AE",
    'embedded.confluence.login-page.login-text': "\u60A8\u9700\u8981\u767B\u5F55\u624D\u80FD\u67E5\u770B\u6B64\u9875\u9762",
    'embedded.confluence.login-page.refresh-page-banner': "\u767B\u5F55\u540E\uFF0C\u6B64\u9875\u9762\u5E94\u4F1A\u81EA\u52A8\u5237\u65B0\u3002\u5982\u679C\u672A\u5237\u65B0\uFF0C\u60A8\u53EF\u4EE5\u70B9\u51FB\u6B64\u5904\u8FDB\u884C\u5237\u65B0",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u5237\u65B0\u9875\u9762",
    'embedded.confluence.need-to-log-in-paragraph': "\u60A8\u9700\u8981\u767B\u5F55\u624D\u80FD\u67E5\u770B\u6B64\u9875\u9762",
    'embedded.confluence.still-having-trouble-paragraph': "\u4ECD\u6709\u95EE\u9898\uFF1F\u8BF7\u786E\u4FDD\u5DF2\u542F\u7528\u7B2C\u4E09\u65B9 Cookie\uFF0C\u6216{link}",
    'embedded.confluence.troubleshooting-link-text': "\u53C2\u9605\u6B64\u6545\u969C\u6392\u9664\u6307\u5357\u3002",
    'embedded.confluence.troubleshooting-link.aria-label': "\u6545\u969C\u6392\u9664\u6307\u5357\u94FE\u63A5"
};


var $e8b215bc83900f05$export$2e2bcd8739ae039 = (0, $e712af7d9bcfb0ed$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $8af35d985f73e53c$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u6211\u5011\u5DF2\u627E\u904D\u56DB\u8655\uFF0C\u4F46\u8A72\u7DB2\u9801\u4F3C\u4E4E\u4E0D\u5B58\u5728\uFF0C\u53EF\u80FD\u5DF2\u906D\u5230\u522A\u9664\u3002\u7576\u7136\uFF0C\u9664\u975E URL \u4E2D\u6709\u932F\u5B57 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u6211\u5011\u627E\u4E0D\u5230\u60A8\u8981\u5C0B\u627E\u7684\u5167\u5BB9",
    'embedded.confluence.already-logged-in-paragraph': "\u5DF2\u7D93\u767B\u5165\u4E86\u55CE\uFF1F\u8ACB\u5617\u8A66\u91CD\u65B0\u6574\u7406\u3002",
    'embedded.confluence.connect-to-confluence.button': "\u9023\u63A5 Confluence",
    'embedded.confluence.connect-to-confluence.button.aria-label': "\u9023\u63A5 Confluence \u6309\u9215",
    'embedded.confluence.connect-to-confluence.description': "\u4EE5\u5718\u968A\u5F62\u5F0F\u4E00\u8D77\u5132\u5B58\u69CB\u60F3\u3001\u8FFD\u8E64\u8B70\u7A0B\u9805\u76EE\u4EE5\u53CA\u505A\u7B46\u8A18\u3002",
    'embedded.confluence.connect-to-confluence.heading': "\u9023\u7D50\u81F3 Confluence",
    'embedded.confluence.footer.hover.text': "\u5728 Confluence \u4E2D\u6AA2\u8996",
    'embedded.confluence.footer.prefix': "\u7531\u4EE5\u4E0B\u6280\u8853\u652F\u63F4\uFF1A",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u767B\u5165 Confluence",
    'embedded.confluence.login-page.login-button': "\u767B\u5165 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u767B\u5165\u6309\u9215",
    'embedded.confluence.login-page.login-text': "\u60A8\u9700\u8981\u767B\u5165\u624D\u80FD\u6AA2\u8996\u6B64\u9801\u9762",
    'embedded.confluence.login-page.refresh-page-banner': "\u767B\u5165\u5F8C\uFF0C\u6B64\u9801\u9762\u61C9\u8A72\u6703\u81EA\u52D5\u91CD\u65B0\u6574\u7406\u3002\u5982\u679C\u6C92\u6709\uFF0C\u60A8\u53EF\u4EE5\u6309\u4E00\u4E0B\u9019\u88E1\u9032\u884C\u91CD\u65B0\u6574\u7406",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u91CD\u65B0\u6574\u7406\u9801\u9762",
    'embedded.confluence.need-to-log-in-paragraph': "\u60A8\u9700\u8981\u767B\u5165\u624D\u80FD\u6AA2\u8996\u6B64\u9801\u9762",
    'embedded.confluence.still-having-trouble-paragraph': "\u4ECD\u7136\u6709\u554F\u984C\u55CE\uFF1F\u8ACB\u78BA\u5B9A\u60A8\u5DF2\u555F\u7528\u7B2C\u4E09\u65B9 Cookie\uFF0C\u6216{link}",
    'embedded.confluence.troubleshooting-link-text': "\u53C3\u95B1\u6B64\u7591\u96E3\u6392\u89E3\u6307\u5357\u3002",
    'embedded.confluence.troubleshooting-link.aria-label': "\u7591\u96E3\u6392\u89E3\u6307\u5357\u9023\u7D50"
};


var $b81b5edce9425351$export$2e2bcd8739ae039 = (0, $8af35d985f73e53c$export$2e2bcd8739ae039);


const $6b4fb032e5c69754$var$localeToTranslations = {
    'cs-CZ': $db096865ea597f4f$export$2e2bcd8739ae039,
    'da-DK': $1d0fc6597744fadd$export$2e2bcd8739ae039,
    'de-DE': $b6ae0df92217897d$export$2e2bcd8739ae039,
    'en-US': $8f2e4db5faa20bce$export$2e2bcd8739ae039,
    'en-GB': $33ea8e64ca8668d2$export$2e2bcd8739ae039,
    'en-ZZ': $d507afa8475356fa$export$2e2bcd8739ae039,
    'es-ES': $385e67f32021aa6d$export$2e2bcd8739ae039,
    'fi-FI': $1b2d05444ac1591b$export$2e2bcd8739ae039,
    'fr-FR': $94b830b71455238d$export$2e2bcd8739ae039,
    'hu-HU': $4b30be4ed3b30b71$export$2e2bcd8739ae039,
    'it-IT': $b50005aafa8cdb37$export$2e2bcd8739ae039,
    'ja-JP': $f077125da86827d1$export$2e2bcd8739ae039,
    'ko-KR': $868a4c9b763bf2ad$export$2e2bcd8739ae039,
    'no-NO': $4d7c9006deba4c39$export$2e2bcd8739ae039,
    'nl-NL': $521991fea9a662cf$export$2e2bcd8739ae039,
    'pl-PL': $7bbbb92191457c96$export$2e2bcd8739ae039,
    'pt-BR': $0c66aef1185c0863$export$2e2bcd8739ae039,
    'ru-RU': $b5d5e4944e9d807e$export$2e2bcd8739ae039,
    'sv-SE': $be6223e8fd3f47b0$export$2e2bcd8739ae039,
    'tr-TR': $83538994e0c01482$export$2e2bcd8739ae039,
    'th-TH': $13ca0cbccf0c03f5$export$2e2bcd8739ae039,
    'uk-UA': $18a1e8a31eadffa4$export$2e2bcd8739ae039,
    'vi-VN': $a478f75ee0d1acb9$export$2e2bcd8739ae039,
    'zh-TW': $b81b5edce9425351$export$2e2bcd8739ae039,
    'zh-CN': $e8b215bc83900f05$export$2e2bcd8739ae039
};
const $6b4fb032e5c69754$var$fetchTranslations = async (locale)=>$6b4fb032e5c69754$var$localeToTranslations[locale] ?? $8f2e4db5faa20bce$export$2e2bcd8739ae039;
var $6b4fb032e5c69754$export$2e2bcd8739ae039 = $6b4fb032e5c69754$var$fetchTranslations;
module.exports["default"] = $6b4fb032e5c69754$export$2e2bcd8739ae039;

});

parcelRegister("50kEc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");








var $hekY6 = parcelRequire("hekY6");





var $5csBp = parcelRequire("5csBp");


var $kTPbu = parcelRequire("kTPbu");

var $bVevd = parcelRequire("bVevd");

var $ioJku = parcelRequire("ioJku");


var $liHlj = parcelRequire("liHlj");


var $1H7qn = parcelRequire("1H7qn");


var $hMKdq = parcelRequire("hMKdq");

const $32b02ee7a2a2c380$var$embeddedPageContainerSytles = null;
const $32b02ee7a2a2c380$var$StyledEmbeddedPageContainer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, containerHeight: containerHeight } = t0;
    let t1;
    if ($[0] !== containerHeight) {
        t1 = {
            height: containerHeight
        };
        $[0] = containerHeight;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w"
        ]);
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== children || $[4] !== t1) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testId": "styled-embedded-page-container-id",
            style: t1,
            className: t2
        }, children);
        $[3] = children;
        $[4] = t1;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ children: children, containerHeight: containerHeight })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testId": "styled-embedded-page-container-id",
        style: {
            height: containerHeight
        },
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w"
        ])
    }, children);
};
const $32b02ee7a2a2c380$export$767e3006bdbb424a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(12);
    const { hasFooterLogo: shouldShowFooter, isHeightSetFromContent: isHeightSetFromContent, showFooter: t0 } = props;
    const showFooter = t0 === undefined ? true : t0;
    const { uniqueKey: uniqueKey } = (0, $hMKdq.useUniqueKey)();
    const { height: height } = (0, $ioJku.useContentSize)(uniqueKey);
    (0, $1H7qn.useGetCurrentScrollPosition)(isHeightSetFromContent);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            experience: (0, $5csBp.ExperienceNames).VIEW_PAGE,
            ccExperience: (0, $5csBp.ExperienceNames).CC_VIEW_PAGE
        };
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== height || $[2] !== isHeightSetFromContent) {
        t2 = (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($32b02ee7a2a2c380$var$StyledEmbeddedPageContainer, {
                containerHeight: isHeightSetFromContent ? `${height}px` : "100%"
            }, children);
        $[1] = height;
        $[2] = isHeightSetFromContent;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== showFooter || $[5] !== t2) {
        t3 = {
            experiences: t1,
            getWrapperElement: t2,
            hasFooter: showFooter
        };
        $[4] = showFooter;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    const contentConfiguration = t3;
    let t4;
    if ($[7] !== contentConfiguration || $[8] !== isHeightSetFromContent || $[9] !== props || $[10] !== shouldShowFooter) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $liHlj.Content), {
            ...props,
            contentType: (0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE,
            mode: (0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
            contentConfiguration: contentConfiguration,
            isHeightSetFromContent: isHeightSetFromContent,
            shouldShowFooter: shouldShowFooter
        });
        $[7] = contentConfiguration;
        $[8] = isHeightSetFromContent;
        $[9] = props;
        $[10] = shouldShowFooter;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : (props)=>{
    const { hasFooterLogo: shouldShowFooter, isHeightSetFromContent: isHeightSetFromContent, showFooter: showFooter = true } = props;
    const { uniqueKey: uniqueKey } = (0, $hMKdq.useUniqueKey)();
    const { height: height } = (0, $ioJku.useContentSize)(uniqueKey);
    (0, $1H7qn.useGetCurrentScrollPosition)(isHeightSetFromContent);
    const contentConfiguration = (0, $cozmU.useMemo)(()=>({
            experiences: {
                experience: (0, $5csBp.ExperienceNames).VIEW_PAGE,
                ccExperience: (0, $5csBp.ExperienceNames).CC_VIEW_PAGE
            },
            getWrapperElement: (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($32b02ee7a2a2c380$var$StyledEmbeddedPageContainer, {
                    containerHeight: isHeightSetFromContent ? `${height}px` : '100%'
                }, children),
            hasFooter: showFooter
        }), [
        isHeightSetFromContent,
        height,
        showFooter
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $liHlj.Content), {
        ...props,
        contentType: (0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE,
        mode: (0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        contentConfiguration: contentConfiguration,
        isHeightSetFromContent: isHeightSetFromContent,
        shouldShowFooter: shouldShowFooter
    });
};



var $eRLgK = parcelRequire("eRLgK");


var $cuq2s = parcelRequire("cuq2s");


var $eBMyn = parcelRequire("eBMyn");


var $lWz4S = parcelRequire("lWz4S");




const $3bc85cd5f76f1308$export$767e3006bdbb424a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(9);
    const { markIframeLoadMetrics: markIframeLoadMetrics } = (0, $lWz4S.usePerformanceMetrics)();
    let t0;
    let t1;
    if ($[0] !== markIframeLoadMetrics) {
        t0 = ()=>{
            markIframeLoadMetrics("lazy-load-end");
            markIframeLoadMetrics("common-load-start");
        };
        t1 = [
            markIframeLoadMetrics
        ];
        $[0] = markIframeLoadMetrics;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useLayoutEffect)(t0, t1);
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eRLgK.PageNotFoundEmptyState), null);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== props) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMKdq.UniqueKeyProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: t2
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $32b02ee7a2a2c380$export$767e3006bdbb424a), props)));
        $[4] = props;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== props.locale || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cuq2s.I18nProvider), {
            locale: props.locale,
            fetchTranslations: (0, $eBMyn.default)
        }, t3);
        $[6] = props.locale;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : (props)=>{
    const { markIframeLoadMetrics: markIframeLoadMetrics } = (0, $lWz4S.usePerformanceMetrics)();
    (0, $cozmU.useLayoutEffect)(()=>{
        markIframeLoadMetrics('lazy-load-end');
        markIframeLoadMetrics('common-load-start');
    }, [
        markIframeLoadMetrics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cuq2s.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $eBMyn.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMKdq.UniqueKeyProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eRLgK.PageNotFoundEmptyState), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $32b02ee7a2a2c380$export$767e3006bdbb424a), props))));
};
module.exports["ViewPage"] = $3bc85cd5f76f1308$export$767e3006bdbb424a;

});

parcelRegister("ioJku", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hcmVI = parcelRequire("hcmVI");










const $d6c879cb69300130$var$MESSAGE_TYPE = 'embeddedConfluenceVisibleHeight';
const $d6c879cb69300130$export$4b9c38587bbe6e8b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (uniqueKey)=>{
    const $ = (0, $bDgLe.c)(5);
    const [visibleHeight, setVisibleHeight] = (0, $cozmU.useState)(1000);
    let t0;
    let t1;
    if ($[0] !== uniqueKey) {
        t0 = ()=>{
            const contentSizeHandler = (postMessage)=>{
                const data = postMessage.data;
                if (data?.type === $d6c879cb69300130$var$MESSAGE_TYPE && data?.value && (uniqueKey ? data?.uniqueKey === uniqueKey : true)) setVisibleHeight(data.value);
            };
            window.addEventListener("message", contentSizeHandler);
            return ()=>{
                window.removeEventListener("message", contentSizeHandler);
            };
        };
        t1 = [
            uniqueKey
        ];
        $[0] = uniqueKey;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[3] !== visibleHeight) {
        t2 = {
            visibleHeight: visibleHeight
        };
        $[3] = visibleHeight;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : (uniqueKey)=>{
    // The initial height is arbitrarily set to 1000
    const [visibleHeight, setVisibleHeight] = (0, $cozmU.useState)(1000);
    (0, $cozmU.useEffect)(()=>{
        const contentSizeHandler = (postMessage)=>{
            const data = postMessage.data;
            if (data?.type === $d6c879cb69300130$var$MESSAGE_TYPE && data?.value && // If uniqueKey is provided, check if the message is for the correct uniqueKey; if uniqueKey is undefined, fallback to existing logic to accept all messages
            (uniqueKey ? data?.uniqueKey === uniqueKey : true)) setVisibleHeight(data.value);
        };
        window.addEventListener('message', contentSizeHandler);
        return ()=>{
            window.removeEventListener('message', contentSizeHandler);
        };
    }, [
        uniqueKey
    ]);
    return {
        visibleHeight: visibleHeight
    };
};


const $bf24e7417b97f31d$var$MESSAGE_TYPE = 'contentSize';
const $bf24e7417b97f31d$export$7e7123f55b1139c9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (uniqueKey)=>{
    const $ = (0, $bDgLe.c)(5);
    const [height, setHeight] = (0, $cozmU.useState)(1000);
    const { isMediaOpen: isMediaOpen } = (0, $hcmVI.useMediaViewerListener)();
    const { visibleHeight: visibleHeight } = (0, $d6c879cb69300130$export$4b9c38587bbe6e8b)(uniqueKey);
    let t0;
    let t1;
    if ($[0] !== uniqueKey) {
        t0 = ()=>{
            const contentSizeHandler = (postMessage)=>{
                const data = postMessage.data;
                if (data?.type === $bf24e7417b97f31d$var$MESSAGE_TYPE && data?.height && (uniqueKey ? data?.uniqueKey === uniqueKey : true)) setHeight(data.height);
            };
            window.addEventListener("message", contentSizeHandler);
            return ()=>{
                window.removeEventListener("message", contentSizeHandler);
            };
        };
        t1 = [
            uniqueKey
        ];
        $[0] = uniqueKey;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    const t2 = isMediaOpen ? visibleHeight : height;
    let t3;
    if ($[3] !== t2) {
        t3 = {
            height: t2
        };
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : (uniqueKey)=>{
    // The initial height is arbitrarily set to 1000
    const [height, setHeight] = (0, $cozmU.useState)(1000);
    /* This visible height refers to the portion of the confluence page that is visible within the iframe without having to scroll.
  	When isHeightSetFromContent is true, the embedded page container height toggles between the visible height and the content height
  	depending on whether media viewer is open or close.
  	This updated was added as a resolution to the bug explained in this ticket: https://hello.jira.atlassian.cloud/browse/CBT-3636
  */ const { isMediaOpen: isMediaOpen } = (0, $hcmVI.useMediaViewerListener)();
    const { visibleHeight: visibleHeight } = (0, $d6c879cb69300130$export$4b9c38587bbe6e8b)(uniqueKey);
    (0, $cozmU.useEffect)(()=>{
        const contentSizeHandler = (postMessage)=>{
            const data = postMessage.data;
            if (data?.type === $bf24e7417b97f31d$var$MESSAGE_TYPE && data?.height && // If uniqueKey is provided, check if the message is for the correct uniqueKey; if uniqueKey is undefined, fallback to existing logic to accept all messages
            (uniqueKey ? data?.uniqueKey === uniqueKey : true)) setHeight(data.height);
        };
        window.addEventListener('message', contentSizeHandler);
        return ()=>{
            window.removeEventListener('message', contentSizeHandler);
        };
    }, [
        uniqueKey
    ]);
    return {
        height: isMediaOpen ? visibleHeight : height
    };
};
module.exports["useContentSize"] = $bf24e7417b97f31d$export$7e7123f55b1139c9;

});

parcelRegister("liHlj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cXtTj = parcelRequire("cXtTj");













const $272f5351b9fa6538$var$defaultExperienceContextValue = undefined;
const $272f5351b9fa6538$export$fb99266658f5da06 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($272f5351b9fa6538$var$defaultExperienceContextValue);


const $5a28ee97dda09b19$export$c90b54e658fc4d7c = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Experience(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children, name: name } = t0;
    let t1;
    if ($[0] !== children || $[1] !== name) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $272f5351b9fa6538$export$fb99266658f5da06).Provider, {
            value: name
        }, children);
        $[0] = children;
        $[1] = name;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function Experience({ children: children, name: name }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $272f5351b9fa6538$export$fb99266658f5da06).Provider, {
        value: name
    }, children);
};


var $fULE8 = parcelRequire("fULE8");


var $hOFc9 = parcelRequire("hOFc9");




var $cqtVU = parcelRequire("cqtVU");

const $0ccaa3c1fbaccc4f$export$48d5d434479c259e = ({ experienceTracker: experienceTracker, contentId: contentId, spaceKey: spaceKey, experience: experience, ccExperience: ccExperience })=>{
    const idRef = (0, $cozmU.useRef)();
    const ccExperienceStartedRef = (0, $cozmU.useRef)(false);
    const id = `${spaceKey}-${contentId}`;
    /**
   * Start experience as close to the user action as possible.
   * Our approximation is component's first render.
   *
   * Addition to starting experience on first render, embedding products may do SPA transition e.g. view different contents without remounting component.
   * We need to re-start experience if `contentId` or `spaceKey` has changed.
   * In this case, experience will abort the current ongoing one and start a new experience (by checking experience id)
   */ if (idRef.current !== id) {
        experienceTracker.start({
            name: experience,
            id: id,
            collect (events, experience_0) {
                if (events.find((event)=>event.action === 'taskStart' && event.name === ccExperience && event.id === contentId)) ccExperienceStartedRef.current = true;
                /**
         * We have experience forwarding from confluence-frontend
         * With the forwarding experience set up, EP experience will be concluded following CC experience, either "succeed", "fail" or "abort"
         */ experience_0.stopOn(events.find((event_0)=>(0, $cqtVU.isStop)(event_0) && event_0.name === ccExperience && event_0.id === contentId));
            }
        });
        idRef.current = id;
    }
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            /**
       * User can navigates away (EP component unmount) before CC experience started
       * In this case, we want to abort EP experience as the conclusion.
       */ if (idRef.current && !ccExperienceStartedRef.current) experienceTracker.abort({
                name: experience,
                reason: 'User navigated away before starting to load'
            });
        };
    }, [
        experienceTracker,
        experience
    ]);
};









var $hekY6 = parcelRequire("hekY6");











var $ctzvi = parcelRequire("ctzvi");


var $hMKdq = parcelRequire("hMKdq");

let $e083990ecae8b248$var$host = null;

// simple-xdm relies on window object. It is not available in SSR.
if (typeof window !== 'undefined') {
    // @atlaskit/simple-xdm/plugin is an ES-module default export, so when loaded via require(), we need to read `.default` (otherwise we get the module namespace object)
    const requiredHost = (parcelRequire("3L4J0"));
    $e083990ecae8b248$var$host = requiredHost?.default ?? requiredHost;
}
function $e083990ecae8b248$var$defineModule(name, module) {
    $e083990ecae8b248$var$host.defineModule(name, module);
}
const $e083990ecae8b248$var$useExperienceForwardingModule = ()=>{
    const experienceTrackerRef = (0, $cozmU.useRef)();
    const { uniqueKey: uniqueKey } = (0, $hMKdq.useUniqueKey)();
    const experienceTracker = (0, $cozmU.useContext)((0, $fULE8.ExperienceTrackerContext));
    if (experienceTrackerRef.current !== experienceTracker) {
        $e083990ecae8b248$var$defineModule(uniqueKey ? `${0, $ctzvi.EXPERIENCE_FORWARDING_MODULE_NAME}_${uniqueKey}` : (0, $ctzvi.EXPERIENCE_FORWARDING_MODULE_NAME), {
            start (options) {
                experienceTracker.start(options);
            },
            abort (options_0) {
                experienceTracker.abort(options_0);
            },
            succeed (options_1) {
                experienceTracker.succeed(options_1);
            },
            fail (options_2) {
                experienceTracker.fail(options_2);
            }
        });
        experienceTrackerRef.current = experienceTracker;
    }
};
const $e083990ecae8b248$var$usePassThroughPropsModule = (props)=>{
    const { onContentLoadStarted: onContentLoadStarted, ...passThroughProps } = props;
    // HOT-303389: dedupe by content, not by reference. Hosts that pass inline
    // `{}` / `[]` literals (e.g. `style`, `navigationPolicy`, `allowedFeatures`)
    // produce a new value reference each render but the same content, which
    // previously caused a fresh dispatch on every parent render.
    let serialisedProps;
    try {
        serialisedProps = JSON.stringify(passThroughProps);
    } catch  {
        // Cyclic refs would have crashed the dispatch path anyway. Use a
        // render-unique string so the callback identity changes every render
        // (same as the previous behaviour) without re-attempting stringify.
        serialisedProps = `__unstable__:${Math.random()}`;
    }
    const dispatchPropsUpdated = (0, $cozmU.useCallback)(()=>{
        $e083990ecae8b248$var$host.dispatch((0, $ctzvi.PROPS_UPDATED), {
            addon_key: passThroughProps.uniqueKey ?? (0, $ctzvi.CHANNEL_NAME),
            key: passThroughProps.uniqueKey ?? (0, $ctzvi.CHANNEL_NAME)
        }, {
            message: serialisedProps
        });
    // passThroughProps is read via the serialised content key.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        serialisedProps
    ]);
    const dispatchPropsUpdatedRef = (0, $cozmU.useRef)();
    if (dispatchPropsUpdatedRef.current !== dispatchPropsUpdated) {
        $e083990ecae8b248$var$defineModule(passThroughProps.uniqueKey ? `${0, $ctzvi.PASSTHROUGH_PROPS_MODULE_NAME}_${passThroughProps.uniqueKey}` : (0, $ctzvi.PASSTHROUGH_PROPS_MODULE_NAME), {
            getProps: ()=>{
                onContentLoadStarted?.();
                dispatchPropsUpdated();
            },
            navigationPolicyNavigate: passThroughProps.navigationPolicy?.navigate,
            onPublish: passThroughProps?.onPublish
        });
        dispatchPropsUpdatedRef.current = dispatchPropsUpdated;
    }
    (0, $cozmU.useEffect)(dispatchPropsUpdated, [
        dispatchPropsUpdated
    ]);
};
function $e083990ecae8b248$export$c745b3af35ea8585(iframeSrc, passThroughProps) {
    const channelRef = (0, $cozmU.useRef)();
    const uniqueKey = passThroughProps.uniqueKey ?? (0, $ctzvi.CHANNEL_NAME);
    $e083990ecae8b248$var$useExperienceForwardingModule();
    $e083990ecae8b248$var$usePassThroughPropsModule(passThroughProps);
    if (channelRef.current?.src !== iframeSrc) channelRef.current = $e083990ecae8b248$var$host.create({
        addon_key: uniqueKey,
        key: uniqueKey,
        url: iframeSrc,
        options: {
            globalOptions: {},
            // `hostFrameOffset` - Offset number specified to find iframe's host frame, it will be `window.top` if not specified.
            // Since EP frame can be embedded by middle layer frame(s), we set `hostFrameOffset` to 1 to ensure EP iframe's direct parent is the host frame.
            hostFrameOffset: 1,
            hostOrigin: window.location.origin
        }
    });
    return channelRef.current;
}











function $4a5f5550ffb0549b$var$isSameOrigin(targetWindow, currentWindow = window) {
    let isSameOrigin1;
    try {
        isSameOrigin1 = targetWindow?.location.origin === currentWindow?.location.origin;
    } catch (e) {
        // catch the DOM exception, mark the resolution to "false"
        isSameOrigin1 = false;
    }
    return isSameOrigin1;
}
const $4a5f5550ffb0549b$export$28f1b4bd74242643 = (hostWindow, offset = 0)=>{
    let currentWindow = hostWindow;
    let hostFrameOffset = 0;
    while(currentWindow && currentWindow !== window.top){
        hostFrameOffset += 1;
        currentWindow = currentWindow.parent;
    }
    return hostFrameOffset - offset;
};
const $4a5f5550ffb0549b$var$attachHostOffsetOverride = (window1)=>{
    if (window1.top) {
        if ($4a5f5550ffb0549b$var$isSameOrigin(window1.top)) {
            const containerDepth = $4a5f5550ffb0549b$export$28f1b4bd74242643(window1);
            // @ts-ignore https://hello.atlassian.net/browse/TYPEF-946
            window1.top.getHostOffsetFunctionOverride = (hostWindow)=>$4a5f5550ffb0549b$export$28f1b4bd74242643(hostWindow, containerDepth + 1);
        }
    }
};
const $4a5f5550ffb0549b$var$detachHostOffsetOverride = ()=>{
    if (window.top) {
        if ($4a5f5550ffb0549b$var$isSameOrigin(window.top)) // @ts-ignore https://hello.atlassian.net/browse/TYPEF-946
        delete window.top.getHostOffsetFunctionOverride;
    }
};
const $4a5f5550ffb0549b$export$db5957f3934e2c38 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useHostOffsetOverride() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    (0, $cozmU.useEffect)($4a5f5550ffb0549b$var$_temp2, t0);
} : function useHostOffsetOverride() {
    (0, $cozmU.useEffect)(()=>{
        $4a5f5550ffb0549b$var$attachHostOffsetOverride(window);
        return ()=>{
            $4a5f5550ffb0549b$var$detachHostOffsetOverride();
        };
    }, []);
};
function $4a5f5550ffb0549b$var$_temp2() {
    $4a5f5550ffb0549b$var$attachHostOffsetOverride(window);
    return $4a5f5550ffb0549b$var$_temp;
}
function $4a5f5550ffb0549b$var$_temp() {
    $4a5f5550ffb0549b$var$detachHostOffsetOverride();
}



var $lWz4S = parcelRequire("lWz4S");




const $f5f432f3cddb52d8$var$iframeStyles = null;
const $f5f432f3cddb52d8$export$5137ec99f248330b = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(27);
    let onContentLoadStarted;
    let onLoad;
    let onUnload;
    let passThroughProps;
    let src;
    if ($[0] !== t0) {
        ({ src: src, onLoad: onLoad, onUnload: onUnload, onContentLoadStarted: onContentLoadStarted, ...passThroughProps } = t0);
        $[0] = t0;
        $[1] = onContentLoadStarted;
        $[2] = onLoad;
        $[3] = onUnload;
        $[4] = passThroughProps;
        $[5] = src;
    } else {
        onContentLoadStarted = $[1];
        onLoad = $[2];
        onUnload = $[3];
        passThroughProps = $[4];
        src = $[5];
    }
    let iframeDomProps;
    if ($[6] !== passThroughProps) {
        const { spaceKey: _spaceKey, ...t1 } = passThroughProps;
        iframeDomProps = t1;
        $[6] = passThroughProps;
        $[7] = iframeDomProps;
    } else iframeDomProps = $[7];
    const { markIframeLoadMetrics: markIframeLoadMetrics } = (0, $lWz4S.usePerformanceMetrics)();
    let t1;
    let t2;
    if ($[8] !== markIframeLoadMetrics) {
        t1 = ()=>{
            markIframeLoadMetrics("common-load-end");
            markIframeLoadMetrics("iframe-content-initialized-start");
        };
        t2 = [
            markIframeLoadMetrics
        ];
        $[8] = markIframeLoadMetrics;
        $[9] = t1;
        $[10] = t2;
    } else {
        t1 = $[9];
        t2 = $[10];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    if ($[11] !== onLoad) {
        t3 = (event)=>{
            onLoad && onLoad(event);
        };
        $[11] = onLoad;
        $[12] = t3;
    } else t3 = $[12];
    const iframeOnLoad = t3;
    const { uniqueKey: uniqueKey } = (0, $hMKdq.useUniqueKey)();
    let t4;
    let t5;
    if ($[13] !== onUnload || $[14] !== uniqueKey) {
        t4 = ()=>{
            const handler = (e)=>{
                const uniqueKeyMatch = !uniqueKey || !e.data?.uniqueKey || e.data.uniqueKey === uniqueKey;
                if (e.data.type === "windowUnload" && uniqueKeyMatch) onUnload?.();
            };
            window.addEventListener("message", handler);
            return ()=>{
                window.removeEventListener("message", handler);
            };
        };
        t5 = [
            onUnload,
            uniqueKey
        ];
        $[13] = onUnload;
        $[14] = uniqueKey;
        $[15] = t4;
        $[16] = t5;
    } else {
        t4 = $[15];
        t5 = $[16];
    }
    (0, $cozmU.useEffect)(t4, t5);
    (0, $4a5f5550ffb0549b$export$db5957f3934e2c38)();
    let t6;
    if ($[17] !== onContentLoadStarted || $[18] !== passThroughProps) {
        t6 = {
            ...passThroughProps,
            onContentLoadStarted: onContentLoadStarted
        };
        $[17] = onContentLoadStarted;
        $[18] = passThroughProps;
        $[19] = t6;
    } else t6 = $[19];
    const channel = (0, $e083990ecae8b248$export$c745b3af35ea8585)(src, t6);
    const t7 = channel.name;
    let t8;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (0, $hekY6.default)([
            "_30huDKYbGa _39xV02N91d _0jFU0VN91d"
        ]);
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== channel.name || $[22] !== iframeDomProps || $[23] !== iframeOnLoad || $[24] !== ref || $[25] !== src) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("iframe", {
            ref: ref,
            title: "confluence-article-iframe",
            "data-testid": "confluence-page-iframe",
            name: t7,
            src: src,
            onLoad: iframeOnLoad,
            allow: "autoplay; fullscreen; encrypted-media; clipboard-write",
            allowFullScreen: true,
            ...iframeDomProps,
            className: t8
        });
        $[21] = channel.name;
        $[22] = iframeDomProps;
        $[23] = iframeOnLoad;
        $[24] = ref;
        $[25] = src;
        $[26] = t9;
    } else t9 = $[26];
    return t9;
} : ({ src: src, onLoad: onLoad, onUnload: onUnload, onContentLoadStarted: onContentLoadStarted, ...passThroughProps }, ref)=>{
    // `spaceKey` is broadcast via the channel but is not a valid HTML attr.
    const { spaceKey: _spaceKey, ...iframeDomProps } = passThroughProps;
    const { markIframeLoadMetrics: markIframeLoadMetrics } = (0, $lWz4S.usePerformanceMetrics)();
    (0, $cozmU.useLayoutEffect)(()=>{
        markIframeLoadMetrics('common-load-end');
        markIframeLoadMetrics('iframe-content-initialized-start');
    }, [
        markIframeLoadMetrics
    ]);
    const iframeOnLoad = (0, $cozmU.useCallback)((event)=>{
        onLoad && onLoad(event);
    }, [
        onLoad
    ]);
    const { uniqueKey: uniqueKey } = (0, $hMKdq.useUniqueKey)();
    (0, $cozmU.useEffect)(()=>{
        const handler = (e)=>{
            // only fire onUnload handler if uniqueKey (if it exists) matches
            const uniqueKeyMatch = !uniqueKey || !e.data?.uniqueKey || e.data.uniqueKey === uniqueKey;
            if (e.data.type === 'windowUnload' && uniqueKeyMatch) onUnload?.();
        };
        window.addEventListener('message', handler);
        return ()=>{
            window.removeEventListener('message', handler);
        };
    }, [
        onUnload,
        uniqueKey
    ]);
    (0, $4a5f5550ffb0549b$export$db5957f3934e2c38)();
    const channel = (0, $e083990ecae8b248$export$c745b3af35ea8585)(src, {
        ...passThroughProps,
        onContentLoadStarted: onContentLoadStarted
    }); // implementation because cleaner index export is not possible with forwardRef
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("iframe", {
        ref: ref,
        title: "confluence-article-iframe",
        "data-testid": "confluence-page-iframe",
        name: channel.name,
        src: src,
        onLoad: iframeOnLoad,
        allow: "autoplay; fullscreen; encrypted-media; clipboard-write",
        // Need it in case the browser doesn't support "fullscreen" feature policy.
        allowFullScreen: true,
        ...iframeDomProps,
        className: (0, $hekY6.default)([
            "_30huDKYbGa _39xV02N91d _0jFU0VN91d"
        ])
    });
});















var $9DHhW = parcelRequire("9DHhW");


var $bltJZ = parcelRequire("bltJZ");


var $lpNn5 = parcelRequire("lpNn5");


var $63MMY = parcelRequire("63MMY");

const $920d185a4b71f988$var$FOOTER_CONTENT_HEIGHT = 52;
const $920d185a4b71f988$var$FOOTER_BORDER_PX = 2;
const $920d185a4b71f988$export$a2dd5f25b5a4e5d2 = $920d185a4b71f988$var$FOOTER_CONTENT_HEIGHT + $920d185a4b71f988$var$FOOTER_BORDER_PX;
const $920d185a4b71f988$var$containerStyles = null;
const $920d185a4b71f988$var$contentWrapperStyles = null;
const $920d185a4b71f988$var$logoWrapperSyles = null;
const $920d185a4b71f988$var$linkStyles = null;
const $920d185a4b71f988$export$a06f1c675e846f6f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { url: url, linkTooltip: linkTooltip, label: label } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_2sNsIg7NXe _2O5VijdnbC _3YEZNOdnbC _1bHrqEmpvA _2bqfgdcChY _0jFU0VmpvA _1UtDYzZpcK _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== label || $[2] !== linkTooltip || $[3] !== url) {
        t2 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "footer-container",
            className: t1
        }, url ? /*#__PURE__*/ $cozmU.createElement($920d185a4b71f988$var$ContentAction, {
            tooltipText: linkTooltip,
            href: url
        }, (t3)=>{
            const { isHovered: isHovered } = t3;
            return /*#__PURE__*/ $cozmU.createElement($920d185a4b71f988$var$Content, {
                isHovered: isHovered,
                label: label
            });
        }) : /*#__PURE__*/ $cozmU.createElement($920d185a4b71f988$var$Content, {
            label: label
        }));
        $[1] = label;
        $[2] = linkTooltip;
        $[3] = url;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ url: url, linkTooltip: linkTooltip, label: label })=>/*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "footer-container",
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _2O5VijdnbC _3YEZNOdnbC _1bHrqEmpvA _2bqfgdcChY _0jFU0VmpvA _1UtDYzZpcK _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
        ])
    }, url ? /*#__PURE__*/ $cozmU.createElement($920d185a4b71f988$var$ContentAction, {
        tooltipText: linkTooltip,
        href: url
    }, ({ isHovered: isHovered })=>/*#__PURE__*/ $cozmU.createElement($920d185a4b71f988$var$Content, {
            isHovered: isHovered,
            label: label
        })) : /*#__PURE__*/ $cozmU.createElement($920d185a4b71f988$var$Content, {
        label: label
    }));
const $920d185a4b71f988$var$Content = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { isHovered: isHovered, label: label } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_0jFU0Vey7F _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLz9WS"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFM2ADO"
        ]);
        $[1] = t2;
    } else t2 = $[1];
    const t3 = isHovered ? "brand" : "neutral";
    let t4;
    if ($[2] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t2
        }, /*#__PURE__*/ $cozmU.createElement((0, $bltJZ.ConfluenceLogo), {
            appearance: t3,
            size: "xxsmall"
        }));
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== label || $[5] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t1
        }, label, t4);
        $[4] = label;
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    return t5;
} : ({ isHovered: isHovered, label: label })=>/*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_0jFU0Vey7F _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLz9WS"
        ])
    }, label, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFM2ADO"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $bltJZ.ConfluenceLogo), {
        appearance: isHovered ? 'brand' : 'neutral',
        size: "xxsmall"
    })));
const $920d185a4b71f988$var$ContentAction = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { children: children, tooltipText: tooltipText, href: href } = t0;
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent) {
        t1 = ()=>{
            createAnalyticsEvent({
                action: "clicked",
                actionSubject: "link",
                actionSubjectId: "confluenceFooter",
                source: "embeddedConfluenceViewPageScreen",
                eventType: "ui"
            }).fire((0, $63MMY.ANALYTICS_CHANNEL));
        };
        $[0] = createAnalyticsEvent;
        $[1] = t1;
    } else t1 = $[1];
    const handleClick = t1;
    let t2;
    let t3;
    let t4;
    let t5;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            setIsHovered(true);
        };
        t3 = ()=>{
            setIsHovered(false);
        };
        t4 = ()=>{
            setIsHovered(true);
        };
        t5 = ()=>{
            setIsHovered(false);
        };
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
    } else {
        t2 = $[2];
        t3 = $[3];
        t4 = $[4];
        t5 = $[5];
    }
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $hekY6.default)([
            "_2xIroY98eZ _497WNwYbGa _2zndICT6kp _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1UtDYzOLYo _2OUyjtYbGa _46mZcB98eZ _1zr6Dc98eZ _3gEqZj98eZ _3ZzesmYbGa _0htemXYbGa _1n6iAyYbGa _4aVDVJT6kp _067LceT6kp _0ipxF5T6kp _3WzCGi98eZ _32C2rk98eZ _0DCa9D98eZ _0NqVRtYbGa _0i9AWAYbGa _3932vvYbGa _3BKYwu6wH8 _0mm6KQ6wH8 _02cRtH6wH8 _0CMRbkOLYo _10n1R5OLYo _0clgaMOLYo _2U5WHpYbGa _0ui43CYbGa _3fSdSTYbGa"
        ]);
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] !== children || $[8] !== isHovered) {
        t7 = children({
            isHovered: isHovered
        });
        $[7] = children;
        $[8] = isHovered;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== handleClick || $[11] !== href || $[12] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement("a", {
            href: href,
            target: "_blank",
            onMouseEnter: t2,
            onMouseLeave: t3,
            onFocus: t4,
            onBlur: t5,
            onClick: handleClick,
            "data-testid": "link",
            className: t6
        }, t7);
        $[10] = handleClick;
        $[11] = href;
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== t8 || $[15] !== tooltipText) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
            content: tooltipText
        }, t8);
        $[14] = t8;
        $[15] = tooltipText;
        $[16] = t9;
    } else t9 = $[16];
    return t9;
} : ({ children: children, tooltipText: tooltipText, href: href })=>{
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'confluenceFooter',
            source: 'embeddedConfluenceViewPageScreen',
            eventType: 'ui'
        }).fire((0, $63MMY.ANALYTICS_CHANNEL));
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        content: tooltipText
    }, /*#__PURE__*/ $cozmU.createElement("a", {
        href: href,
        target: "_blank",
        onMouseEnter: ()=>{
            setIsHovered(true);
        },
        onMouseLeave: ()=>{
            setIsHovered(false);
        },
        onFocus: ()=>{
            setIsHovered(true);
        },
        onBlur: ()=>{
            setIsHovered(false);
        },
        onClick: handleClick,
        "data-testid": "link",
        className: (0, $hekY6.default)([
            "_2xIroY98eZ _497WNwYbGa _2zndICT6kp _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1UtDYzOLYo _2OUyjtYbGa _46mZcB98eZ _1zr6Dc98eZ _3gEqZj98eZ _3ZzesmYbGa _0htemXYbGa _1n6iAyYbGa _4aVDVJT6kp _067LceT6kp _0ipxF5T6kp _3WzCGi98eZ _32C2rk98eZ _0DCa9D98eZ _0NqVRtYbGa _0i9AWAYbGa _3932vvYbGa _3BKYwu6wH8 _0mm6KQ6wH8 _02cRtH6wH8 _0CMRbkOLYo _10n1R5OLYo _0clgaMOLYo _2U5WHpYbGa _0ui43CYbGa _3fSdSTYbGa"
        ])
    }, children({
        isHovered: isHovered
    })));
};

















var $kSwu1 = parcelRequire("kSwu1");


var $eKMV3 = parcelRequire("eKMV3");


var $I7hWB = parcelRequire("I7hWB");


var $i1t43 = parcelRequire("i1t43");





var $V3JOP = parcelRequire("V3JOP");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");





var $5csBp = parcelRequire("5csBp");

var $bb856b3679f6611a$exports = {};
$bb856b3679f6611a$exports = new URL("LoginPageIconSVG.f5d1b132.svg", import.meta.url).toString();





const $ffa6a1a504e41a8e$var$messages = (0, $kSwu1.defineMessages)({
    connectToConfluenceHeading: {
        id: "embedded.confluence.connect-to-confluence.heading",
        defaultMessage: "Connect to Confluence"
    },
    connectToConfluenceDescription: {
        id: "embedded.confluence.connect-to-confluence.description",
        defaultMessage: "Save ideas, track agenda items, and take notes together as a team."
    },
    connectConfluenceButton: {
        id: "embedded.confluence.connect-to-confluence.button",
        defaultMessage: "Connect Confluence"
    },
    connectLoomToConfluenceImageAriaLabel: {
        id: "embedded.confluence.connect-loom-to-confluence.image.aria-label",
        defaultMessage: "Connect Loom to Confluence"
    },
    loginToConfluenceIconAriaLabel: {
        id: "embedded.confluence.login-to-confluence.icon.aria-label",
        defaultMessage: "Login to Confluence"
    },
    connectConfluenceButtonAriaLabel: {
        id: "embedded.confluence.connect-to-confluence.button.aria-label",
        defaultMessage: "Connect Confluence Button"
    },
    buttonLoginToConfluenceNewTab: {
        id: "embedded.confluence.generic-error-page.login-to-confluence-button",
        defaultMessage: "Log in to Confluence"
    },
    paragraphLogin: {
        id: "embedded.confluence.need-to-log-in-paragraph",
        defaultMessage: "You need to be logged in to view this page"
    },
    paragraphAlreadyLoggedIn: {
        id: "embedded.confluence.already-logged-in-paragraph",
        defaultMessage: "Already logged in? Try refreshing."
    },
    paragraphStillHavingTrouble: {
        id: "embedded.confluence.still-having-trouble-paragraph",
        defaultMessage: "Still having trouble? Make sure 3rd party cookies are enabled, or {link}"
    },
    linkTroubleshootingText: {
        id: "embedded.confluence.troubleshooting-link-text",
        defaultMessage: "refer to this troubleshooting guide."
    },
    linkAriaLabel: {
        id: "embedded.confluence.troubleshooting-link.aria-label",
        defaultMessage: "troubleshooting guide link"
    },
    loginAriaLabel: {
        id: "embedded.confluence.login-page.login-button.aria-label",
        defaultMessage: "Login Button"
    },
    loginText: {
        id: "embedded.confluence.login-page.login-text",
        defaultMessage: "You need to be logged in to view this page"
    },
    loginButton: {
        id: "embedded.confluence.login-page.login-button",
        defaultMessage: "Log in to Confluence"
    },
    refreshBanner: {
        id: "embedded.confluence.login-page.refresh-page-banner",
        defaultMessage: "After logging in, this page should refresh automatically. If not, you can click here to refresh"
    },
    refreshBannerLink: {
        id: "embedded.confluence.login-page.refresh-page-banner-refresh-link",
        defaultMessage: "Refresh page"
    }
});
var $ffa6a1a504e41a8e$export$2e2bcd8739ae039 = $ffa6a1a504e41a8e$var$messages;





const $cdca1b264d076e97$var$LOGIN_ISSUES_RELATED_TO_BROWSER_COOKIES = 'https://support.atlassian.com/atlassian-account/docs/login-issues-related-to-browser-cookies/';
const $cdca1b264d076e97$var$styles = {
    loginButtonWrapper: "_313842Va5s _1DCdHi5zaO",
    mainWrapper: "_3iDTPbkfkE _0hPCNLDIqT _0pI6nMDIqT _2fwxA5DIqT"
};
const $cdca1b264d076e97$export$42f84e610f279c31 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(51);
    const { standaloneConfluenceUrl: standaloneConfluenceUrl } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $fULE8.ExperienceTrackerContext));
    const experience = (0, $cozmU.useContext)((0, $272f5351b9fa6538$export$fb99266658f5da06));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { cancelIframeLoadMetrics: cancelIframeLoadMetrics } = (0, $lWz4S.usePerformanceMetrics)();
    let t1;
    let t2;
    if ($[0] !== cancelIframeLoadMetrics) {
        t1 = ()=>{
            cancelIframeLoadMetrics();
        };
        t2 = [
            cancelIframeLoadMetrics
        ];
        $[0] = cancelIframeLoadMetrics;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[3] !== experience || $[4] !== experienceTracker) {
        t3 = ()=>{
            experienceTracker.abort({
                name: experience,
                reason: (0, $5csBp.ExperienceReasons).UNABLE_TO_DISPLAY_CONTENT
            });
        };
        t4 = [
            experience,
            experienceTracker
        ];
        $[3] = experience;
        $[4] = experienceTracker;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $hekY6.default)([
            $cdca1b264d076e97$var$styles.mainWrapper
        ]);
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $bltJZ.ConfluenceLogo), {
            size: "large",
            appearance: "brand"
        });
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== formatMessage) {
        t7 = formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).loginToConfluenceIconAriaLabel);
        $[9] = formatMessage;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($bb856b3679f6611a$exports))),
            alt: t7,
            width: "148",
            height: "160"
        });
        $[11] = t7;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== formatMessage) {
        t9 = formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).paragraphLogin);
        $[13] = formatMessage;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            as: "h2",
            size: "large"
        }, t9);
        $[15] = t9;
        $[16] = t10;
    } else t10 = $[16];
    let t11;
    if ($[17] !== t10 || $[18] !== t8) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.250",
            alignInline: "center"
        }, t6, t8, t10);
        $[17] = t10;
        $[18] = t8;
        $[19] = t11;
    } else t11 = $[19];
    let t12;
    if ($[20] !== formatMessage) {
        t12 = formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).buttonLoginToConfluenceNewTab);
        $[20] = formatMessage;
        $[21] = t12;
    } else t12 = $[21];
    const t13 = standaloneConfluenceUrl ?? "";
    let t14;
    if ($[22] !== formatMessage) {
        t14 = formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).buttonLoginToConfluenceNewTab);
        $[22] = formatMessage;
        $[23] = t14;
    } else t14 = $[23];
    let t15;
    if ($[24] !== t12 || $[25] !== t13 || $[26] !== t14) {
        t15 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $cdca1b264d076e97$var$styles.loginButtonWrapper,
            "data-embedded-confluence-no-global-styles-link-button": "true"
        }, /*#__PURE__*/ $cozmU.createElement((0, $eKMV3.default), {
            appearance: "primary",
            "aria-label": t12,
            iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
            href: t13,
            target: "_blank"
        }, t14));
        $[24] = t12;
        $[25] = t13;
        $[26] = t14;
        $[27] = t15;
    } else t15 = $[27];
    let t16;
    if ($[28] !== formatMessage) {
        t16 = formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).paragraphAlreadyLoggedIn);
        $[28] = formatMessage;
        $[29] = t16;
    } else t16 = $[29];
    let t17;
    if ($[30] !== t16) {
        t17 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            as: "p"
        }, t16);
        $[30] = t16;
        $[31] = t17;
    } else t17 = $[31];
    let t18;
    if ($[32] !== formatMessage) {
        t18 = formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).linkAriaLabel);
        $[32] = formatMessage;
        $[33] = t18;
    } else t18 = $[33];
    let t19;
    if ($[34] !== formatMessage) {
        t19 = formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).linkTroubleshootingText);
        $[34] = formatMessage;
        $[35] = t19;
    } else t19 = $[35];
    let t20;
    if ($[36] !== t18 || $[37] !== t19) {
        t20 = /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
            href: $cdca1b264d076e97$var$LOGIN_ISSUES_RELATED_TO_BROWSER_COOKIES,
            target: "_blank",
            "aria-label": t18
        }, t19);
        $[36] = t18;
        $[37] = t19;
        $[38] = t20;
    } else t20 = $[38];
    let t21;
    if ($[39] !== formatMessage || $[40] !== t20) {
        t21 = formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).paragraphStillHavingTrouble, {
            link: t20
        });
        $[39] = formatMessage;
        $[40] = t20;
        $[41] = t21;
    } else t21 = $[41];
    let t22;
    if ($[42] !== t21) {
        t22 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            as: "p"
        }, t21);
        $[42] = t21;
        $[43] = t22;
    } else t22 = $[43];
    let t23;
    if ($[44] !== t17 || $[45] !== t22) {
        t23 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.150"
        }, t17, t22);
        $[44] = t17;
        $[45] = t22;
        $[46] = t23;
    } else t23 = $[46];
    let t24;
    if ($[47] !== t11 || $[48] !== t15 || $[49] !== t23) {
        t24 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "error-screen-container",
            className: t5
        }, t11, t15, t23);
        $[47] = t11;
        $[48] = t15;
        $[49] = t23;
        $[50] = t24;
    } else t24 = $[50];
    return t24;
} : ({ standaloneConfluenceUrl: standaloneConfluenceUrl })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $fULE8.ExperienceTrackerContext));
    const experience = (0, $cozmU.useContext)((0, $272f5351b9fa6538$export$fb99266658f5da06));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { cancelIframeLoadMetrics: cancelIframeLoadMetrics } = (0, $lWz4S.usePerformanceMetrics)();
    (0, $cozmU.useEffect)(()=>{
        cancelIframeLoadMetrics();
    }, [
        cancelIframeLoadMetrics
    ]);
    (0, $cozmU.useEffect)(()=>{
        experienceTracker.abort({
            name: experience,
            reason: (0, $5csBp.ExperienceReasons).UNABLE_TO_DISPLAY_CONTENT
        });
    }, [
        experience,
        experienceTracker
    ]);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "error-screen-container",
        className: (0, $hekY6.default)([
            $cdca1b264d076e97$var$styles.mainWrapper
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.250",
        alignInline: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $bltJZ.ConfluenceLogo), {
        size: "large",
        appearance: "brand"
    }), /*#__PURE__*/ $cozmU.createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bb856b3679f6611a$exports))),
        alt: formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).loginToConfluenceIconAriaLabel),
        width: "148",
        height: "160"
    }), /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        as: "h2",
        size: "large"
    }, formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).paragraphLogin))), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $cdca1b264d076e97$var$styles.loginButtonWrapper,
        // used instead of className as the className prop is not allowed
        // suggested by #help-design-system https://atlassian.slack.com/archives/CFJ9DU39U/p1746963980938489
        "data-embedded-confluence-no-global-styles-link-button": "true"
    }, /*#__PURE__*/ $cozmU.createElement((0, $eKMV3.default), {
        appearance: "primary",
        "aria-label": formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).buttonLoginToConfluenceNewTab),
        iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
        href: standaloneConfluenceUrl ?? '',
        target: "_blank"
    }, formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).buttonLoginToConfluenceNewTab))), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        as: "p"
    }, formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).paragraphAlreadyLoggedIn)), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        as: "p"
    }, formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).paragraphStillHavingTrouble, {
        link: /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
            href: $cdca1b264d076e97$var$LOGIN_ISSUES_RELATED_TO_BROWSER_COOKIES,
            target: "_blank",
            "aria-label": formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).linkAriaLabel)
        }, formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).linkTroubleshootingText))
    }))));
};

















var $hBYtq = parcelRequire("hBYtq");










var $ad7Ou = parcelRequire("ad7Ou");





var $7w1PB = parcelRequire("7w1PB");


















var $FKQbh = parcelRequire("FKQbh");


var $chu6R = parcelRequire("chu6R");

const $65fb2001ad40932d$var$RefreshBanner = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { reloadEP: reloadEP, title: title, actionLabel: actionLabel } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
            spacing: "spacious",
            color: "var(--ds-icon-information, #357DE8)",
            label: "Info"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== actionLabel || $[2] !== reloadEP) {
        t2 = [
            {
                content: actionLabel,
                onClick: reloadEP
            }
        ];
        $[1] = actionLabel;
        $[2] = reloadEP;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t2 || $[5] !== title) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $FKQbh.default), {
            icon: t1,
            id: "refreshBanner",
            title: title,
            actions: t2
        });
        $[4] = t2;
        $[5] = title;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ reloadEP: reloadEP, title: title, actionLabel: actionLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $FKQbh.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
            spacing: "spacious",
            color: "var(--ds-icon-information, #357DE8)",
            label: "Info"
        }),
        id: "refreshBanner",
        title: title,
        actions: [
            {
                content: actionLabel,
                onClick: reloadEP
            }
        ]
    });
var $65fb2001ad40932d$export$2e2bcd8739ae039 = $65fb2001ad40932d$var$RefreshBanner;






var $ff814b3b7be15ff9$exports = {};
$ff814b3b7be15ff9$exports = new URL("ConnectLoomToConfluenceSVG.8db7b17b.svg", import.meta.url).toString();



var $6Pqow = parcelRequire("6Pqow");

const $11228e21e42de1c8$var$fadeIn = null;
const $11228e21e42de1c8$var$styles = {
    loginButtonWrapper: "_313842Va5s",
    parentDiv: "_3iDTPbkfkE _0hPCNLDIqT _0pI6nMDIqT",
    refreshBannerFade: "_0Of8r2kG2W _1ZnuxbkG2W _1wydGWkG2W _2Zuz6QkG2W _1gBibyZMPz _0nFVCGM9iZ",
    loomHeading: "_2sNsIgxzFw _1kk5Tk7GSX _1UtDYzy7kJ",
    loomLoginButton: "_0bjKvDuMRm _2sNsIg20Hp _23rrnHb6HL _39xV02cofO _0jFU0VmdCj _0KLXruDM2k _1UtDYze5R3 _1kk5Tk7GSX _1B4rbIb6HL _1eOmH6hmrj _3gzVzLczkD"
};
const $11228e21e42de1c8$var$SUCCESS_URL_SUFFIX = '/wiki/embed/login-confirmation';
const $11228e21e42de1c8$export$f14c0e3f98d164c0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { contentId: contentId, parentProduct: parentProduct, reloadEP: reloadEP, spaceKey: spaceKey, url: url } = t0;
    const { locale: locale, formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { uniqueKey: uniqueKey } = (0, $hMKdq.useUniqueKey)();
    const { cancelIframeLoadMetrics: cancelIframeLoadMetrics } = (0, $lWz4S.usePerformanceMetrics)();
    let t1;
    let t2;
    if ($[0] !== cancelIframeLoadMetrics) {
        t1 = ()=>{
            cancelIframeLoadMetrics();
        };
        t2 = [
            cancelIframeLoadMetrics
        ];
        $[0] = cancelIframeLoadMetrics;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] !== url) {
        t3 = url ? new URL(url).origin : window?.location?.origin;
        $[3] = url;
        $[4] = t3;
    } else t3 = $[4];
    const origin = t3;
    const uniqueKeyParam = uniqueKey ? `&uniqueKey=${uniqueKey}` : "";
    const loginUrl = `${origin}/login?application=confluence&dest-url=${encodeURIComponent(`${$11228e21e42de1c8$var$SUCCESS_URL_SUFFIX}?locale=${locale}`)}${uniqueKeyParam}`;
    const isLoomParentProduct = parentProduct === "loom";
    const handleClick = ()=>{
        $11228e21e42de1c8$var$openLoginPopup(loginUrl);
        setDisplayRefreshBanner(!displayRefreshBanner);
    };
    const [t4, t5] = (0, $cozmU.useState)(false);
    const displayRefreshBanner = t4;
    const setDisplayRefreshBanner = t5;
    let t6;
    if ($[5] !== contentId || $[6] !== displayRefreshBanner || $[7] !== formatMessage || $[8] !== handleClick || $[9] !== isLoomParentProduct || $[10] !== reloadEP || $[11] !== spaceKey) {
        t6 = isLoomParentProduct ? /*#__PURE__*/ $cozmU.createElement($11228e21e42de1c8$export$e65dcd3f2d7567ae, {
            contentId: contentId,
            formatMessage: formatMessage,
            handleClick: handleClick,
            displayRefreshBanner: displayRefreshBanner,
            reloadEP: reloadEP,
            spaceKey: spaceKey
        }) : /*#__PURE__*/ $cozmU.createElement($11228e21e42de1c8$export$50083a1d14fa7d72, {
            contentId: contentId,
            formatMessage: formatMessage,
            handleClick: handleClick,
            displayRefreshBanner: displayRefreshBanner,
            reloadEP: reloadEP,
            spaceKey: spaceKey
        });
        $[5] = contentId;
        $[6] = displayRefreshBanner;
        $[7] = formatMessage;
        $[8] = handleClick;
        $[9] = isLoomParentProduct;
        $[10] = reloadEP;
        $[11] = spaceKey;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ contentId: contentId, parentProduct: parentProduct, reloadEP: reloadEP, spaceKey: spaceKey, url: url })=>{
    const { locale: locale, formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { uniqueKey: uniqueKey } = (0, $hMKdq.useUniqueKey)();
    const { cancelIframeLoadMetrics: cancelIframeLoadMetrics } = (0, $lWz4S.usePerformanceMetrics)();
    (0, $cozmU.useEffect)(()=>{
        cancelIframeLoadMetrics();
    }, [
        cancelIframeLoadMetrics
    ]);
    const loginUrl = (0, $cozmU.useMemo)(()=>{
        const origin = url ? new URL(url).origin : window?.location?.origin;
        const uniqueKeyParam = uniqueKey ? `&uniqueKey=${uniqueKey}` : '';
        return `${origin}/login?application=confluence&dest-url=${encodeURIComponent(`${$11228e21e42de1c8$var$SUCCESS_URL_SUFFIX}?locale=${locale}`)}${uniqueKeyParam}`;
    }, [
        url,
        locale,
        uniqueKey
    ]);
    const isLoomParentProduct = parentProduct === 'loom';
    const handleClick = ()=>{
        $11228e21e42de1c8$var$openLoginPopup(loginUrl);
        setDisplayRefreshBanner(!displayRefreshBanner);
    };
    const [displayRefreshBanner, setDisplayRefreshBanner] = (0, $cozmU.useState)(false);
    return isLoomParentProduct ? /*#__PURE__*/ $cozmU.createElement($11228e21e42de1c8$export$e65dcd3f2d7567ae, {
        contentId: contentId,
        formatMessage: formatMessage,
        handleClick: handleClick,
        displayRefreshBanner: displayRefreshBanner,
        reloadEP: reloadEP,
        spaceKey: spaceKey
    }) : /*#__PURE__*/ $cozmU.createElement($11228e21e42de1c8$export$50083a1d14fa7d72, {
        contentId: contentId,
        formatMessage: formatMessage,
        handleClick: handleClick,
        displayRefreshBanner: displayRefreshBanner,
        reloadEP: reloadEP,
        spaceKey: spaceKey
    });
};
const $11228e21e42de1c8$export$e65dcd3f2d7567ae = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(40);
    const { contentId: contentId, displayRefreshBanner: displayRefreshBanner, formatMessage: formatMessage, handleClick: handleClick, reloadEP: reloadEP, spaceKey: spaceKey } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $11228e21e42de1c8$var$styles.parentDiv
        ]);
        $[0] = t1;
    } else t1 = $[0];
    const t2 = `${spaceKey}-${contentId}-loom`;
    let t3;
    if ($[1] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $7w1PB.ExperienceStart), {
            name: (0, $5csBp.ExperienceNames).LOGIN_PAGE,
            id: t2
        });
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== formatMessage) {
        t4 = formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).connectLoomToConfluenceImageAriaLabel);
        $[3] = formatMessage;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($ff814b3b7be15ff9$exports))),
            alt: t4,
            width: "167",
            height: "110"
        });
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== formatMessage) {
        t6 = formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).connectToConfluenceHeading);
        $[7] = formatMessage;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            as: "h2",
            size: "large"
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $11228e21e42de1c8$var$styles.loomHeading
        }, t6));
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== formatMessage) {
        t8 = formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).connectToConfluenceDescription);
        $[11] = formatMessage;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $6Pqow.default), {
            color: "color.text.subtlest",
            size: "medium"
        }, t8);
        $[13] = t8;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== t7 || $[16] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.100",
            alignInline: "center"
        }, t7, t9);
        $[15] = t7;
        $[16] = t9;
        $[17] = t10;
    } else t10 = $[17];
    let t11;
    if ($[18] !== t10 || $[19] !== t5) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.200",
            alignInline: "center"
        }, t5, t10);
        $[18] = t10;
        $[19] = t5;
        $[20] = t11;
    } else t11 = $[20];
    let t12;
    if ($[21] !== formatMessage) {
        t12 = formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).connectConfluenceButtonAriaLabel);
        $[21] = formatMessage;
        $[22] = t12;
    } else t12 = $[22];
    let t13;
    if ($[23] !== formatMessage) {
        t13 = formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).connectConfluenceButton);
        $[23] = formatMessage;
        $[24] = t13;
    } else t13 = $[24];
    let t14;
    if ($[25] !== handleClick || $[26] !== t12 || $[27] !== t13) {
        t14 = /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            xcss: $11228e21e42de1c8$var$styles.loomLoginButton,
            onClick: handleClick,
            testId: "connect-confluence-button",
            "aria-label": t12
        }, t13);
        $[25] = handleClick;
        $[26] = t12;
        $[27] = t13;
        $[28] = t14;
    } else t14 = $[28];
    let t15;
    if ($[29] !== t11 || $[30] !== t14) {
        t15 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.400",
            alignInline: "center"
        }, t11, t14);
        $[29] = t11;
        $[30] = t14;
        $[31] = t15;
    } else t15 = $[31];
    let t16;
    if ($[32] !== displayRefreshBanner || $[33] !== formatMessage || $[34] !== reloadEP) {
        t16 = displayRefreshBanner && /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $11228e21e42de1c8$var$styles.refreshBannerFade
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $65fb2001ad40932d$export$2e2bcd8739ae039), {
            reloadEP: reloadEP,
            title: formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).refreshBanner),
            actionLabel: formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).refreshBannerLink)
        }));
        $[32] = displayRefreshBanner;
        $[33] = formatMessage;
        $[34] = reloadEP;
        $[35] = t16;
    } else t16 = $[35];
    let t17;
    if ($[36] !== t15 || $[37] !== t16 || $[38] !== t3) {
        t17 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "login-page-test-id",
            className: t1
        }, t3, t15, t16);
        $[36] = t15;
        $[37] = t16;
        $[38] = t3;
        $[39] = t17;
    } else t17 = $[39];
    return t17;
} : ({ contentId: contentId, displayRefreshBanner: displayRefreshBanner, formatMessage: formatMessage, handleClick: handleClick, reloadEP: reloadEP, spaceKey: spaceKey })=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "login-page-test-id",
        className: (0, $hekY6.default)([
            $11228e21e42de1c8$var$styles.parentDiv
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $7w1PB.ExperienceStart), {
        name: (0, $5csBp.ExperienceNames).LOGIN_PAGE,
        id: `${spaceKey}-${contentId}-loom`
    }), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.400",
        alignInline: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.200",
        alignInline: "center"
    }, /*#__PURE__*/ $cozmU.createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ff814b3b7be15ff9$exports))),
        alt: formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).connectLoomToConfluenceImageAriaLabel),
        width: "167",
        height: "110"
    }), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100",
        alignInline: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        as: "h2",
        size: "large"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $11228e21e42de1c8$var$styles.loomHeading
    }, formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).connectToConfluenceHeading))), /*#__PURE__*/ $cozmU.createElement((0, $6Pqow.default), {
        color: "color.text.subtlest",
        size: "medium"
    }, formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).connectToConfluenceDescription)))), /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        xcss: $11228e21e42de1c8$var$styles.loomLoginButton,
        onClick: handleClick,
        testId: "connect-confluence-button",
        "aria-label": formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).connectConfluenceButtonAriaLabel)
    }, formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).connectConfluenceButton))), displayRefreshBanner && /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $11228e21e42de1c8$var$styles.refreshBannerFade
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $65fb2001ad40932d$export$2e2bcd8739ae039), {
        reloadEP: reloadEP,
        title: formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).refreshBanner),
        actionLabel: formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).refreshBannerLink)
    })));
};
const $11228e21e42de1c8$export$50083a1d14fa7d72 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { contentId: contentId, displayRefreshBanner: displayRefreshBanner, formatMessage: formatMessage, handleClick: handleClick, reloadEP: reloadEP, spaceKey: spaceKey } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $11228e21e42de1c8$var$styles.parentDiv
        ]);
        $[0] = t1;
    } else t1 = $[0];
    const t2 = `${spaceKey}-${contentId}`;
    let t3;
    if ($[1] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $7w1PB.ExperienceStart), {
            name: (0, $5csBp.ExperienceNames).LOGIN_PAGE,
            id: t2
        });
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $bltJZ.ConfluenceLogo), {
            size: "large",
            appearance: "brand"
        });
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== formatMessage) {
        t5 = formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).loginToConfluenceIconAriaLabel);
        $[4] = formatMessage;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($bb856b3679f6611a$exports))),
            alt: t5,
            width: "148",
            height: "160"
        });
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== formatMessage) {
        t7 = formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).loginText);
        $[8] = formatMessage;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            as: "h2",
            size: "large"
        }, t7);
        $[10] = t7;
        $[11] = t8;
    } else t8 = $[11];
    let t9;
    if ($[12] !== t6 || $[13] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.250",
            alignInline: "center"
        }, t4, t6, t8);
        $[12] = t6;
        $[13] = t8;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== formatMessage) {
        t10 = formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).loginAriaLabel);
        $[15] = formatMessage;
        $[16] = t10;
    } else t10 = $[16];
    let t11;
    if ($[17] !== formatMessage) {
        t11 = formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).loginButton);
        $[17] = formatMessage;
        $[18] = t11;
    } else t11 = $[18];
    let t12;
    if ($[19] !== handleClick || $[20] !== t10 || $[21] !== t11) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $11228e21e42de1c8$var$styles.loginButtonWrapper
        }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            testId: "login-button",
            "aria-label": t10,
            appearance: "primary",
            onClick: handleClick
        }, t11));
        $[19] = handleClick;
        $[20] = t10;
        $[21] = t11;
        $[22] = t12;
    } else t12 = $[22];
    let t13;
    if ($[23] !== displayRefreshBanner || $[24] !== formatMessage || $[25] !== reloadEP) {
        t13 = displayRefreshBanner && /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $11228e21e42de1c8$var$styles.refreshBannerFade
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $65fb2001ad40932d$export$2e2bcd8739ae039), {
            reloadEP: reloadEP,
            title: formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).refreshBanner),
            actionLabel: formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).refreshBannerLink)
        }));
        $[23] = displayRefreshBanner;
        $[24] = formatMessage;
        $[25] = reloadEP;
        $[26] = t13;
    } else t13 = $[26];
    let t14;
    if ($[27] !== t12 || $[28] !== t13 || $[29] !== t3 || $[30] !== t9) {
        t14 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "login-page-test-id",
            className: t1
        }, t3, t9, t12, t13);
        $[27] = t12;
        $[28] = t13;
        $[29] = t3;
        $[30] = t9;
        $[31] = t14;
    } else t14 = $[31];
    return t14;
} : ({ contentId: contentId, displayRefreshBanner: displayRefreshBanner, formatMessage: formatMessage, handleClick: handleClick, reloadEP: reloadEP, spaceKey: spaceKey })=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "login-page-test-id",
        className: (0, $hekY6.default)([
            $11228e21e42de1c8$var$styles.parentDiv
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $7w1PB.ExperienceStart), {
        name: (0, $5csBp.ExperienceNames).LOGIN_PAGE,
        id: `${spaceKey}-${contentId}`
    }), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.250",
        alignInline: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $bltJZ.ConfluenceLogo), {
        size: "large",
        appearance: "brand"
    }), /*#__PURE__*/ $cozmU.createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bb856b3679f6611a$exports))),
        alt: formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).loginToConfluenceIconAriaLabel),
        width: "148",
        height: "160"
    }), /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        as: "h2",
        size: "large"
    }, formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).loginText))), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $11228e21e42de1c8$var$styles.loginButtonWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        testId: "login-button",
        "aria-label": formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).loginAriaLabel),
        appearance: "primary",
        onClick: handleClick
    }, formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).loginButton))), displayRefreshBanner && /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $11228e21e42de1c8$var$styles.refreshBannerFade
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $65fb2001ad40932d$export$2e2bcd8739ae039), {
        reloadEP: reloadEP,
        title: formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).refreshBanner),
        actionLabel: formatMessage((0, $ffa6a1a504e41a8e$export$2e2bcd8739ae039).refreshBannerLink)
    })));
};
function $11228e21e42de1c8$var$openLoginPopup(loginUrl) {
    const windowFeatures = 'popup=yes,left=100,top=100,width=640,height=640';
    window.open(loginUrl, '_blank', windowFeatures);
}





























const $73a77f075a1c565a$var$iframeStyles = null;
const $73a77f075a1c565a$export$64a8a56a2c35628c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { contentId: contentId, spaceKey: spaceKey, url: url, parentProduct: parentProduct } = t0;
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const iframeRef = (0, $cozmU.useRef)(null);
    const { uniqueKey: uniqueKey } = (0, $hMKdq.useUniqueKey)();
    const { cancelIframeLoadMetrics: cancelIframeLoadMetrics } = (0, $lWz4S.usePerformanceMetrics)();
    let t1;
    let t2;
    if ($[0] !== cancelIframeLoadMetrics) {
        t1 = ()=>{
            cancelIframeLoadMetrics();
        };
        t2 = [
            cancelIframeLoadMetrics
        ];
        $[0] = cancelIframeLoadMetrics;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    const uniqueKeyParam = uniqueKey ? `&uniqueKey=${uniqueKey}` : "";
    const path = `/wiki/embed/storage-access?parentProduct=${parentProduct}&locale=${locale}${uniqueKeyParam}`;
    let t3;
    if ($[3] !== url) {
        t3 = url ? new URL(url).origin : window.location.origin;
        $[3] = url;
        $[4] = t3;
    } else t3 = $[4];
    const origin = t3;
    let t4;
    if ($[5] !== origin || $[6] !== path) {
        t4 = [
            origin,
            path
        ];
        $[5] = origin;
        $[6] = path;
        $[7] = t4;
    } else t4 = $[7];
    const src = t4.join("");
    const t5 = `${spaceKey}-${contentId}`;
    let t6;
    if ($[8] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7w1PB.ExperienceStart), {
            name: (0, $5csBp.ExperienceNames).STORAGE_ACCESS_PAGE,
            id: t5
        });
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $hekY6.default)([
            "_30huDKYbGa _39xV02N91d _0jFU0VN91d"
        ]);
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== src) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("iframe", {
            "data-testid": "storage-access-page-iframe",
            title: "storage-access-iframe",
            src: src,
            ref: iframeRef,
            className: t7
        });
        $[11] = src;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== t6 || $[14] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t6, t8);
        $[13] = t6;
        $[14] = t8;
        $[15] = t9;
    } else t9 = $[15];
    return t9;
} : ({ contentId: contentId, spaceKey: spaceKey, url: url, parentProduct: parentProduct })=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const iframeRef = (0, $cozmU.useRef)(null);
    const { uniqueKey: uniqueKey } = (0, $hMKdq.useUniqueKey)();
    const { cancelIframeLoadMetrics: cancelIframeLoadMetrics } = (0, $lWz4S.usePerformanceMetrics)();
    (0, $cozmU.useEffect)(()=>{
        cancelIframeLoadMetrics();
    }, [
        cancelIframeLoadMetrics
    ]);
    const src = (0, $cozmU.useMemo)(()=>{
        const uniqueKeyParam = uniqueKey ? `&uniqueKey=${uniqueKey}` : '';
        const path = `/wiki/embed/storage-access?parentProduct=${parentProduct}&locale=${locale}${uniqueKeyParam}`;
        const origin = url ? new URL(url).origin : window.location.origin;
        return [
            origin,
            path
        ].join('');
    }, [
        locale,
        parentProduct,
        url,
        uniqueKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7w1PB.ExperienceStart), {
        name: (0, $5csBp.ExperienceNames).STORAGE_ACCESS_PAGE,
        id: `${spaceKey}-${contentId}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("iframe", {
        "data-testid": "storage-access-page-iframe",
        title: "storage-access-iframe",
        src: src,
        ref: iframeRef,
        className: (0, $hekY6.default)([
            "_30huDKYbGa _39xV02N91d _0jFU0VN91d"
        ])
    }));
};



var $ij75C = parcelRequire("ij75C");



















var $b849bfe51747a0a2$export$29953e2fb702813a = /*#__PURE__*/ function(Subjects) {
    Subjects["STORAGE_ACCESS"] = "storage-access";
    Subjects["LOGIN_CONFIRMATION"] = "login-confirmation";
    Subjects["CONTENT_LOAD"] = "content-load";
    return Subjects;
}({});
var $b849bfe51747a0a2$export$19d37de7e9a4af59 = /*#__PURE__*/ function(LoadingStatus) {
    LoadingStatus["IFRAME_LOADED"] = "iframe-loaded";
    LoadingStatus["IFRAME_UNLOADED"] = "iframe-unloaded";
    LoadingStatus["CONTENT_LOAD_STARTED"] = "content-load-started";
    LoadingStatus["REDIRECTED_TO_LOGIN"] = "redirected-to-login";
    LoadingStatus["RELOAD_EP"] = "reload-ep";
    return LoadingStatus;
}({});
var $b849bfe51747a0a2$export$12bf62de6f1fdb01 = /*#__PURE__*/ function(StorageAccessStatus) {
    StorageAccessStatus["GRANTED"] = "granted";
    StorageAccessStatus["REJECTED"] = "rejected";
    StorageAccessStatus["NOT_SUPPORTED"] = "not-supported";
    StorageAccessStatus["ERROR"] = "error";
    return StorageAccessStatus;
}({});
var $b849bfe51747a0a2$export$889a6bd688f4360e = /*#__PURE__*/ function(UserLoginStatus) {
    UserLoginStatus["SUCCESS"] = "success";
    return UserLoginStatus;
}({});
/* NOTE: (Refer this table for understanding the behavior
  on different browsers: https://hello.atlassian.net/wiki/spaces/~288141084/pages/2154391293/Conditions+to+load+EP)
*/ function $b849bfe51747a0a2$var$pageLoadValidationReducer(state, action) {
    //NOTE: We assume that storage access and user login is required at the load of the PageLoadValidation component
    switch(action.subject){
        case "storage-access":
            switch(action.status){
                case "granted":
                    /*If storage access is granted, refresh app, if user is logged in, try to load EP. If not, load Login CTA
           */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskStorageAccess: false
                    };
                case "rejected":
                    /*If storage access is reject, it could mean either of the two things:
               1. (For Safari): User has storage access but may not be logged in, Try loggin user in
               2. (For Firefox, Edge): User may be logged in but storage access is not yet granted by the browser
               In both these case, ask user to login.
               */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskStorageAccess: false,
                        shouldAskToLogin: true
                    };
                case "not-supported":
                    /* This case is specific for Chrome where storage access is not supported.
               So we can skip asking for storage access and direct user to the Login CTA.
               */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskToLogin: true,
                        shouldAskStorageAccess: false
                    };
                case "error":
                    /** To catch any other errors while requesting storage access */ return {
                        ...state
                    };
            }
            break;
        case "login-confirmation":
            switch(action.status){
                case "success":
                    /*
               If user has logged in, it means that storage access is granted. Refresh app, Try loading EP
               */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskToLogin: false,
                        iframeUnloaded: false,
                        redirectedToLogin: false
                    };
            }
            break;
        case "content-load":
            //These states are set only when the user has navigated throught the storage access and login flows. So try to load EP
            switch(action.status){
                case "iframe-loaded":
                    return {
                        ...state,
                        iframeLoaded: true
                    };
                case "content-load-started":
                    return {
                        ...state,
                        contentLoadStarted: true
                    };
                case "iframe-unloaded":
                    return {
                        ...state,
                        iframeUnloaded: true
                    };
                case "redirected-to-login":
                    return {
                        ...state,
                        redirectedToLogin: true
                    };
                case "reload-ep":
                    return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false
                    };
            }
            break;
    }
}
const $b849bfe51747a0a2$export$1faa35b5a06780c0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(9);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            iframeLoaded: false,
            contentLoadStarted: false,
            shouldAskStorageAccess: true,
            shouldAskToLogin: true,
            redirectedToLogin: false,
            iframeUnloaded: false
        };
        $[0] = t0;
    } else t0 = $[0];
    const initialState = t0;
    const [state, dispatch] = (0, $cozmU.useReducer)($b849bfe51747a0a2$var$pageLoadValidationReducer, initialState);
    const experienceTracker = (0, $cozmU.useContext)((0, $fULE8.ExperienceTrackerContext));
    const { uniqueKey: uniqueKey } = (0, $hMKdq.useUniqueKey)();
    let t1;
    if ($[1] !== experienceTracker || $[2] !== uniqueKey) {
        t1 = (messageEvent)=>{
            const { subject: subject, result: result, embeddedConfluenceUrl: embeddedConfluenceUrl } = messageEvent.data ?? {};
            const messageKey = embeddedConfluenceUrl ? new URL(embeddedConfluenceUrl).searchParams.get("uniqueKey") : null;
            if (!subject || !result || messageKey && uniqueKey && messageKey !== uniqueKey) return;
            bb29: switch(subject){
                case "storage-access":
                    bb36: switch(result){
                        case "granted":
                            experienceTracker.succeed({
                                name: (0, $5csBp.ExperienceNames).STORAGE_ACCESS_PAGE
                            });
                            dispatch({
                                subject: "storage-access",
                                status: "granted"
                            });
                            break bb36;
                        case "rejected":
                            experienceTracker.abort({
                                name: (0, $5csBp.ExperienceNames).STORAGE_ACCESS_PAGE,
                                reason: (0, $5csBp.ExperienceReasons).STORAGE_ACCESS_REJECTED
                            });
                            dispatch({
                                subject: "storage-access",
                                status: "rejected"
                            });
                            break bb36;
                        case "not-supported":
                            experienceTracker.abort({
                                name: (0, $5csBp.ExperienceNames).STORAGE_ACCESS_PAGE,
                                reason: (0, $5csBp.ExperienceReasons).STORAGE_ACCESS_NOT_SUPPORTED
                            });
                            dispatch({
                                subject: "storage-access",
                                status: "not-supported"
                            });
                            break bb36;
                        case "error":
                            experienceTracker.fail({
                                name: (0, $5csBp.ExperienceNames).STORAGE_ACCESS_PAGE,
                                error: new Error((0, $5csBp.ExperienceReasons).STORAGE_ACCESS_ERROR)
                            });
                            dispatch({
                                subject: "storage-access",
                                status: "error"
                            });
                    }
                    break bb29;
                case "login-confirmation":
                    switch(result){
                        case "success":
                            experienceTracker.succeed({
                                name: (0, $5csBp.ExperienceNames).LOGIN_PAGE
                            });
                            dispatch({
                                subject: "login-confirmation",
                                status: "success"
                            });
                    }
            }
        };
        $[1] = experienceTracker;
        $[2] = uniqueKey;
        $[3] = t1;
    } else t1 = $[3];
    const messageListener = t1;
    let t2;
    let t3;
    if ($[4] !== messageListener) {
        t2 = ()=>{
            window.addEventListener("message", messageListener);
            return ()=>window.removeEventListener("message", messageListener);
        };
        t3 = [
            messageListener
        ];
        $[4] = messageListener;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[7] !== state) {
        t4 = {
            state: state,
            dispatch: dispatch
        };
        $[7] = state;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : ()=>{
    const initialState = {
        iframeLoaded: false,
        contentLoadStarted: false,
        shouldAskStorageAccess: true,
        shouldAskToLogin: true,
        redirectedToLogin: false,
        iframeUnloaded: false
    };
    const [state, dispatch] = (0, $cozmU.useReducer)($b849bfe51747a0a2$var$pageLoadValidationReducer, initialState);
    const experienceTracker = (0, $cozmU.useContext)((0, $fULE8.ExperienceTrackerContext));
    const { uniqueKey: uniqueKey } = (0, $hMKdq.useUniqueKey)();
    const messageListener = (0, $cozmU.useCallback)((messageEvent)=>{
        const { subject: subject, result: result, embeddedConfluenceUrl: embeddedConfluenceUrl } = messageEvent.data ?? {};
        const messageKey = embeddedConfluenceUrl ? new URL(embeddedConfluenceUrl).searchParams.get('uniqueKey') : null;
        if (!subject || !result || messageKey && uniqueKey && messageKey !== uniqueKey) return;
        switch(subject){
            case "storage-access":
                switch(result){
                    case "granted":
                        experienceTracker.succeed({
                            name: (0, $5csBp.ExperienceNames).STORAGE_ACCESS_PAGE
                        });
                        dispatch({
                            subject: "storage-access",
                            status: "granted"
                        });
                        break;
                    case "rejected":
                        experienceTracker.abort({
                            name: (0, $5csBp.ExperienceNames).STORAGE_ACCESS_PAGE,
                            reason: (0, $5csBp.ExperienceReasons).STORAGE_ACCESS_REJECTED
                        });
                        dispatch({
                            subject: "storage-access",
                            status: "rejected"
                        });
                        break;
                    case "not-supported":
                        experienceTracker.abort({
                            name: (0, $5csBp.ExperienceNames).STORAGE_ACCESS_PAGE,
                            reason: (0, $5csBp.ExperienceReasons).STORAGE_ACCESS_NOT_SUPPORTED
                        });
                        dispatch({
                            subject: "storage-access",
                            status: "not-supported"
                        });
                        break;
                    case "error":
                        experienceTracker.fail({
                            name: (0, $5csBp.ExperienceNames).STORAGE_ACCESS_PAGE,
                            error: new Error((0, $5csBp.ExperienceReasons).STORAGE_ACCESS_ERROR)
                        });
                        dispatch({
                            subject: "storage-access",
                            status: "error"
                        });
                        break;
                }
                break;
            case "login-confirmation":
                switch(result){
                    case "success":
                        experienceTracker.succeed({
                            name: (0, $5csBp.ExperienceNames).LOGIN_PAGE
                        });
                        dispatch({
                            subject: "login-confirmation",
                            status: "success"
                        });
                        break;
                }
                break;
        }
    }, [
        experienceTracker,
        uniqueKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        window.addEventListener('message', messageListener);
        return ()=>window.removeEventListener('message', messageListener);
    }, [
        messageListener
    ]);
    return {
        state: state,
        dispatch: dispatch
    };
};


const $1394cf2f62255656$var$noop = ()=>{};
const $1394cf2f62255656$var$IFRAME_LOAD_TIMEOUT_MS = 2000;
const $1394cf2f62255656$export$3b0759108d92fe77 = (props)=>{
    const { standaloneConfluenceUrl: standaloneConfluenceUrl, embeddedConfluenceUrl: embeddedConfluenceUrl } = (0, $ij75C.useUrl)(props);
    const { state: { contentLoadStarted: contentLoadStarted, iframeLoaded: iframeLoaded } } = (0, $b849bfe51747a0a2$export$1faa35b5a06780c0)();
    const isEmbeddedUrlOnSameDomain = embeddedConfluenceUrl ? window.location.origin === new URL(embeddedConfluenceUrl).origin : false;
    const unusedIframeRef = (0, $cozmU.useRef)(null);
    return isEmbeddedUrlOnSameDomain ? props.children({
        isLoading: contentLoadStarted && !iframeLoaded || false,
        // if same domain, we bypass loading screen in favor of internal iframe loading experience
        iframeLoaded: iframeLoaded || true,
        // if same domain, set to true so iframe can handle loading experience
        iframeRef: unusedIframeRef,
        handleIframeOnLoad: $1394cf2f62255656$var$noop,
        handleContentLoadStarted: $1394cf2f62255656$var$noop,
        handleIframeUnload: $1394cf2f62255656$var$noop,
        navigationPolicy: props.navigationPolicy
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1394cf2f62255656$var$CrossDomainErrorValidation, {
        key: embeddedConfluenceUrl || props.contentId,
        standaloneConfluenceUrl: standaloneConfluenceUrl,
        embeddedConfluenceUrl: embeddedConfluenceUrl,
        allowedFeatures: props.allowedFeatures,
        ...props
    });
};
const $1394cf2f62255656$var$CrossDomainErrorValidation = ({ allowedFeatures: allowedFeatures, children: children, contentId: contentId, embeddedConfluenceUrl: embeddedConfluenceUrl, navigationPolicy: navigationPolicy, parentProduct: parentProduct, spaceKey: spaceKey, standaloneConfluenceUrl: standaloneConfluenceUrl })=>{
    const { state: state, dispatch: dispatch } = (0, $b849bfe51747a0a2$export$1faa35b5a06780c0)();
    const { iframeLoaded: iframeLoaded, contentLoadStarted: contentLoadStarted, shouldAskStorageAccess: shouldAskStorageAccess, shouldAskToLogin: shouldAskToLogin, redirectedToLogin: redirectedToLogin, iframeUnloaded: iframeUnloaded } = state;
    const iframeRef = (0, $cozmU.useRef)(null);
    const iframeOnLoadFiredRef = (0, $cozmU.useRef)(false);
    const iframeOnLoadSrcRef = (0, $cozmU.useRef)(null);
    const timeoutIdRef = (0, $cozmU.useRef)(null);
    const dispatchIframeLoaded = (0, $cozmU.useCallback)(()=>{
        dispatch({
            subject: (0, $b849bfe51747a0a2$export$29953e2fb702813a).CONTENT_LOAD,
            status: (0, $b849bfe51747a0a2$export$19d37de7e9a4af59).IFRAME_LOADED
        });
    }, [
        dispatch
    ]);
    const clearPendingIframeLoadTimeout = (0, $cozmU.useCallback)(()=>{
        if (timeoutIdRef.current) {
            clearTimeout(timeoutIdRef.current);
            timeoutIdRef.current = null;
        }
    }, []);
    const resetIframeLoadTracking = (0, $cozmU.useCallback)(()=>{
        iframeOnLoadFiredRef.current = false;
        iframeOnLoadSrcRef.current = null;
        clearPendingIframeLoadTimeout();
    }, [
        clearPendingIframeLoadTimeout
    ]);
    const handleIframeOnLoad = (0, $cozmU.useCallback)(()=>{
        /* Record that the iframe onLoad event has fired and store the current src.
       We verify the iframe src to ensure we only handle the correct iframe,
       as the same Iframe component is also used by the StorageAccessPage component,
       and the src may change during transitions between view/edit modes or other redirects.
    */ if (!iframeRef.current) return;
        iframeOnLoadFiredRef.current = true;
        iframeOnLoadSrcRef.current = iframeRef.current.src;
        // If content has already started loading, dispatch immediately
        if (contentLoadStarted && !iframeLoaded) {
            dispatchIframeLoaded();
            return;
        }
        // If content hasn't started loading yet, set a timeout to dispatch after a delay
        // This handles the case where content fails to load or never sends the start message
        if (!contentLoadStarted && !iframeLoaded) {
            clearPendingIframeLoadTimeout();
            timeoutIdRef.current = setTimeout(()=>{
                // Verify the iframe hasn't changed before dispatching
                if (iframeOnLoadFiredRef.current && iframeRef.current?.src === iframeOnLoadSrcRef.current && !iframeLoaded) dispatchIframeLoaded();
            }, $1394cf2f62255656$var$IFRAME_LOAD_TIMEOUT_MS);
        }
    }, [
        contentLoadStarted,
        iframeLoaded,
        dispatchIframeLoaded,
        clearPendingIframeLoadTimeout
    ]);
    // As soon as both the iframe onLoad has fired AND content has started loading, dispatch the IFRAME_LOADED action.
    (0, $cozmU.useEffect)(()=>{
        if (iframeOnLoadFiredRef.current && contentLoadStarted && iframeRef.current?.src === iframeOnLoadSrcRef.current && !iframeLoaded) {
            clearPendingIframeLoadTimeout();
            dispatchIframeLoaded();
        }
    }, [
        clearPendingIframeLoadTimeout,
        contentLoadStarted,
        dispatchIframeLoaded,
        iframeLoaded
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!contentLoadStarted && !iframeLoaded) resetIframeLoadTracking();
    }, [
        contentLoadStarted,
        iframeLoaded,
        resetIframeLoadTracking
    ]);
    (0, $cozmU.useEffect)(()=>()=>{
            clearPendingIframeLoadTimeout();
        }, [
        clearPendingIframeLoadTimeout
    ]);
    const handleContentLoadStarted = (0, $cozmU.useCallback)(()=>{
        dispatch({
            subject: (0, $b849bfe51747a0a2$export$29953e2fb702813a).CONTENT_LOAD,
            status: (0, $b849bfe51747a0a2$export$19d37de7e9a4af59).CONTENT_LOAD_STARTED
        });
    }, [
        dispatch
    ]);
    const handleIframeUnload = (0, $cozmU.useCallback)(()=>{
        dispatch({
            subject: (0, $b849bfe51747a0a2$export$29953e2fb702813a).CONTENT_LOAD,
            status: (0, $b849bfe51747a0a2$export$19d37de7e9a4af59).IFRAME_UNLOADED
        });
    }, [
        dispatch
    ]);
    const isLoginFlowDisabled = (0, $cozmU.useMemo)(()=>allowedFeatures?.includes('disable-login-flow') ?? false, [
        allowedFeatures
    ]);
    const reloadEP = (0, $cozmU.useCallback)(()=>{
        dispatch({
            subject: (0, $b849bfe51747a0a2$export$29953e2fb702813a).CONTENT_LOAD,
            status: (0, $b849bfe51747a0a2$export$19d37de7e9a4af59).RELOAD_EP
        });
    }, [
        dispatch
    ]);
    const failToLoad = (0, $cozmU.useMemo)(()=>iframeLoaded && !contentLoadStarted || /*
     If anonymous access is permitted globally but restricted on a content's parent space,
     the iframe will attempt a login redirect which we intercept.
     To avoid an error in the iframe, we need to wait for the iframe window to unload
     before unmouting the Iframe component.
   */ iframeUnloaded && redirectedToLogin, [
        contentLoadStarted,
        iframeLoaded,
        iframeUnloaded,
        redirectedToLogin
    ]);
    const pageNavigationPolicy = (0, $cozmU.useMemo)(()=>({
            navigate (url, modifiers, defaultNavigate) {
                if (url.includes('/login?application=confluence')) {
                    dispatch({
                        subject: (0, $b849bfe51747a0a2$export$29953e2fb702813a).CONTENT_LOAD,
                        status: (0, $b849bfe51747a0a2$export$19d37de7e9a4af59).REDIRECTED_TO_LOGIN
                    });
                    return;
                }
                return navigationPolicy?.navigate ? navigationPolicy.navigate(url, modifiers, defaultNavigate) : defaultNavigate(url, modifiers);
            },
            shimUrl: navigationPolicy?.shimUrl,
            domainNamesToReplace: navigationPolicy?.domainNamesToReplace,
            spaceKeyFilter: navigationPolicy?.spaceKeyFilter
        }), [
        navigationPolicy,
        dispatch
    ]);
    if (!failToLoad) return children({
        iframeRef: iframeRef,
        isLoading: contentLoadStarted && !iframeLoaded,
        iframeLoaded: iframeLoaded,
        handleIframeOnLoad: handleIframeOnLoad,
        handleContentLoadStarted: handleContentLoadStarted,
        handleIframeUnload: handleIframeUnload,
        navigationPolicy: pageNavigationPolicy,
        redirectedToLogin: redirectedToLogin
    });
    if (!isLoginFlowDisabled) {
        if (shouldAskStorageAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $73a77f075a1c565a$export$64a8a56a2c35628c), {
            url: embeddedConfluenceUrl,
            contentId: contentId,
            spaceKey: spaceKey,
            parentProduct: parentProduct
        });
        if (shouldAskToLogin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $11228e21e42de1c8$export$f14c0e3f98d164c0), {
            contentId: contentId,
            parentProduct: parentProduct,
            reloadEP: reloadEP,
            spaceKey: spaceKey,
            url: embeddedConfluenceUrl
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cdca1b264d076e97$export$42f84e610f279c31), {
        standaloneConfluenceUrl: standaloneConfluenceUrl
    });
};


var $ioJku = parcelRequire("ioJku");













var $b4pEE = parcelRequire("b4pEE");

const $148c06aca6ff7a3c$export$d07da6ac6fc160b0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { experienceTracker: experienceTracker, hasFooter: hasFooter, shouldShowFooter: shouldShowFooter, parentProduct: parentProduct, standaloneConfluenceUrl: standaloneConfluenceUrl } = t0;
    const [footerUrl, setFooterUrl] = (0, $cozmU.useState)(standaloneConfluenceUrl);
    let t1;
    let t2;
    if ($[0] !== standaloneConfluenceUrl) {
        t1 = ()=>{
            setFooterUrl(standaloneConfluenceUrl);
        };
        t2 = [
            standaloneConfluenceUrl
        ];
        $[0] = standaloneConfluenceUrl;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[3] !== experienceTracker || $[4] !== standaloneConfluenceUrl) {
        t3 = ()=>{
            const unsubscribe = experienceTracker.subscribe((event)=>{
                const { name: name, action: action } = event;
                if (name === (0, $5csBp.ExperienceNames).PAGE_NOT_FOUND && action === "taskStart") setFooterUrl(standaloneConfluenceUrl ? `${new URL(standaloneConfluenceUrl).origin}/wiki/home` : standaloneConfluenceUrl);
            });
            return ()=>unsubscribe();
        };
        t4 = [
            experienceTracker,
            standaloneConfluenceUrl
        ];
        $[3] = experienceTracker;
        $[4] = standaloneConfluenceUrl;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = [
            (0, $b4pEE.EMBEDDED_PARENT_PRODUCTS).JSM_PORTAL,
            (0, $b4pEE.EMBEDDED_PARENT_PRODUCTS).JSM,
            (0, $b4pEE.EMBEDDED_PARENT_PRODUCTS).JSW,
            (0, $b4pEE.EMBEDDED_PARENT_PRODUCTS).JWM
        ];
        $[7] = t5;
    } else t5 = $[7];
    const parentProducts = t5;
    const showFooter = !!hasFooter && !(parentProducts.includes(parentProduct) && !shouldShowFooter);
    let t6;
    if ($[8] !== footerUrl || $[9] !== showFooter) {
        t6 = {
            showFooter: showFooter,
            footerUrl: footerUrl
        };
        $[8] = footerUrl;
        $[9] = showFooter;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
} : ({ experienceTracker: experienceTracker, hasFooter: hasFooter, shouldShowFooter: shouldShowFooter, parentProduct: parentProduct, standaloneConfluenceUrl: standaloneConfluenceUrl })=>{
    const [footerUrl, setFooterUrl] = (0, $cozmU.useState)(standaloneConfluenceUrl);
    (0, $cozmU.useEffect)(()=>{
        setFooterUrl(standaloneConfluenceUrl);
    }, [
        standaloneConfluenceUrl
    ]);
    (0, $cozmU.useEffect)(()=>{
        const unsubscribe = experienceTracker.subscribe((event)=>{
            const { name: name, action: action } = event;
            if (name === (0, $5csBp.ExperienceNames).PAGE_NOT_FOUND && action === 'taskStart') setFooterUrl(standaloneConfluenceUrl ? `${new URL(standaloneConfluenceUrl).origin}/wiki/home` : standaloneConfluenceUrl);
        });
        return ()=>unsubscribe();
    }, [
        experienceTracker,
        standaloneConfluenceUrl
    ]);
    /**
   * Currently footer is hidden for the JSM Portal view which passes
   * shouldShowFooter (externally, showFooterLogo) prop as false and shown for all other views
   *
   * JSM portal view will provide "JSM-Portal" as the parent product eventually
   * However, team is still testing this product type for Atlassian and anonymous users so the "JSM-Portal" parentProduct is being feature-flagged
   * We need to support these two parent product keys to keep backward compatible for the time being.
   *
   * Clean-up task in backlog: https://hello.atlassian.net/browse/CBT-1278 to remove "JSM" from the logic
   *
   * EDIT 7/17: showFooterLogo has been renamed internally for clarity and is now aliased as shouldShowFooter when used internally.
   * External API remains unchanged.
   */ const showFooter = (0, $cozmU.useMemo)(()=>{
        const parentProducts = [
            (0, $b4pEE.EMBEDDED_PARENT_PRODUCTS).JSM_PORTAL,
            (0, $b4pEE.EMBEDDED_PARENT_PRODUCTS).JSM,
            (0, $b4pEE.EMBEDDED_PARENT_PRODUCTS).JSW,
            (0, $b4pEE.EMBEDDED_PARENT_PRODUCTS).JWM
        ];
        return !!hasFooter && !(parentProducts.includes(parentProduct) && !shouldShowFooter);
    }, [
        parentProduct,
        shouldShowFooter,
        hasFooter
    ]);
    return {
        showFooter: showFooter,
        footerUrl: footerUrl
    };
};











var $2RJCj = parcelRequire("2RJCj");

//Default parent scroll offset (in pixels) used by fallback window scrolling ; this offset keeps content visible below sticky headers
const $7f714e1c52a150d1$var$PARENT_SCROLL_OFFSET_PX = 80;
const $7f714e1c52a150d1$export$8c87e334b260af87 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (isHeightSetFromContent, uniqueKey, customScrollHandler)=>{
    const $ = (0, $bDgLe.c)(8);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = new WeakMap();
        $[0] = t0;
    } else t0 = $[0];
    const iframeBySourceRef = (0, $cozmU.useRef)(t0);
    const customScrollHandlerRef = (0, $cozmU.useRef)(customScrollHandler);
    let t1;
    let t2;
    if ($[1] !== customScrollHandler) {
        t1 = ()=>{
            customScrollHandlerRef.current = customScrollHandler;
        };
        t2 = [
            customScrollHandler
        ];
        $[1] = customScrollHandler;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[4] !== isHeightSetFromContent || $[5] !== uniqueKey) {
        t3 = ()=>{
            if (!isHeightSetFromContent) return;
            const handler = (event)=>{
                if (event.data?.type !== (0, $2RJCj.SCROLL_TO_HASH_MESSAGE_TYPE)) return;
                if (uniqueKey && event.data?.uniqueKey !== uniqueKey) return;
                const offsetTop = event.data?.offsetTop;
                if (typeof offsetTop !== "number") return;
                const source = event.source;
                if (!source || typeof source !== "object") return;
                let iframe = iframeBySourceRef.current.get(source);
                if (!iframe) {
                    iframe = Array.from(document.querySelectorAll("iframe")).find((f)=>f.contentWindow === source);
                    if (iframe) iframeBySourceRef.current.set(source, iframe);
                }
                if (!iframe) return;
                if (customScrollHandlerRef.current) customScrollHandlerRef.current(iframe, offsetTop);
                else {
                    const iframeRect = iframe.getBoundingClientRect();
                    const scrollTarget = iframeRect.top + window.scrollY + offsetTop - $7f714e1c52a150d1$var$PARENT_SCROLL_OFFSET_PX;
                    window.scrollTo({
                        top: Math.max(0, scrollTarget),
                        behavior: "smooth"
                    });
                }
            };
            window.addEventListener("message", handler);
            return ()=>window.removeEventListener("message", handler);
        };
        t4 = [
            isHeightSetFromContent,
            uniqueKey
        ];
        $[4] = isHeightSetFromContent;
        $[5] = uniqueKey;
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, $cozmU.useEffect)(t3, t4);
} : (isHeightSetFromContent, uniqueKey, customScrollHandler)=>{
    const iframeBySourceRef = (0, $cozmU.useRef)(new WeakMap());
    const customScrollHandlerRef = (0, $cozmU.useRef)(customScrollHandler);
    (0, $cozmU.useEffect)(()=>{
        customScrollHandlerRef.current = customScrollHandler;
    }, [
        customScrollHandler
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isHeightSetFromContent) return undefined;
        const handler = (event)=>{
            if (event.data?.type !== (0, $2RJCj.SCROLL_TO_HASH_MESSAGE_TYPE)) return;
            // Only accept messages sent by the same embed instance
            if (uniqueKey && event.data?.uniqueKey !== uniqueKey) return;
            const offsetTop = event.data?.offsetTop;
            if (typeof offsetTop !== 'number') return;
            const source = event.source;
            if (!source || typeof source !== 'object') return;
            let iframe = iframeBySourceRef.current.get(source);
            if (!iframe) {
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                iframe = Array.from(document.querySelectorAll('iframe')).find((f)=>f.contentWindow === source);
                if (iframe) iframeBySourceRef.current.set(source, iframe);
            }
            if (!iframe) return;
            // Use custom handler if provided, otherwise fall back to default scroll
            if (customScrollHandlerRef.current) customScrollHandlerRef.current(iframe, offsetTop);
            else {
                const iframeRect = iframe.getBoundingClientRect();
                const scrollTarget = iframeRect.top + window.scrollY + offsetTop - $7f714e1c52a150d1$var$PARENT_SCROLL_OFFSET_PX;
                window.scrollTo({
                    top: Math.max(0, scrollTarget),
                    behavior: 'smooth'
                });
            }
        };
        window.addEventListener('message', handler);
        return ()=>window.removeEventListener('message', handler);
    }, [
        isHeightSetFromContent,
        uniqueKey
    ]);
};








var $eRLgK = parcelRequire("eRLgK");




const $fadd871ba413d295$var$messages = (0, $kSwu1.defineMessages)({
    viewInConfluence: {
        id: "embedded.confluence.footer.hover.text",
        defaultMessage: "View in Confluence"
    },
    poweredBy: {
        id: "embedded.confluence.footer.prefix",
        defaultMessage: "Powered by"
    }
});
var $fadd871ba413d295$export$2e2bcd8739ae039 = $fadd871ba413d295$var$messages;

















var $3pCca = parcelRequire("3pCca");


var $a9aSv = parcelRequire("a9aSv");

const $284b45fa25b321b5$var$visibilityStyles = {
    hidden: "_3iDTPbYbGa",
    invisible: "_1YKVNsdnbC _0jFU0VN91d",
    visible: "_1YKVNs7dHp _0jFU0VN91d"
};
const $284b45fa25b321b5$var$overlayStyles = {
    default: "_1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _4ApkO2dnbC _0Bm75GdnbC _39xV02N91d _0jFU0VN91d _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyu7p2s _42Yu6BgtVO"
};
const $284b45fa25b321b5$var$containerStyles = {
    default: "_1mT5xdRAKS _39xV02N91d _0jFU0VN91d"
};
const $284b45fa25b321b5$export$666e684aed003bfe = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { children: children, iframeLoaded: iframeLoaded, isLoading: isLoading } = t0;
    const t1 = isLoading ? $284b45fa25b321b5$var$overlayStyles.default : $284b45fa25b321b5$var$visibilityStyles.hidden;
    const t2 = !isLoading;
    let t3;
    let t4;
    let t5;
    let t6;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "250px",
            isShimmering: true
        });
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "40px",
            isShimmering: true
        });
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "40px",
            isShimmering: true
        });
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "40px",
            isShimmering: true
        });
        $[0] = t3;
        $[1] = t4;
        $[2] = t5;
        $[3] = t6;
    } else {
        t3 = $[0];
        t4 = $[1];
        t5 = $[2];
        t6 = $[3];
    }
    let t7;
    if ($[4] !== t1 || $[5] !== t2) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3pCca.Grid), {
            gap: "space.400",
            alignItems: "start",
            xcss: t1,
            "aria-hidden": t2,
            role: "status"
        }, t3, t4, t5, t6);
        $[4] = t1;
        $[5] = t2;
        $[6] = t7;
    } else t7 = $[6];
    const t8 = !iframeLoaded ? $284b45fa25b321b5$var$visibilityStyles.invisible : $284b45fa25b321b5$var$visibilityStyles.visible;
    let t9;
    if ($[7] !== children || $[8] !== isLoading || $[9] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            padding: "space.0",
            "aria-hidden": isLoading,
            xcss: t8
        }, children);
        $[7] = children;
        $[8] = isLoading;
        $[9] = t8;
        $[10] = t9;
    } else t9 = $[10];
    let t10;
    if ($[11] !== isLoading || $[12] !== t7 || $[13] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $284b45fa25b321b5$var$containerStyles.default,
            "aria-busy": isLoading,
            "aria-live": "polite"
        }, t7, t9);
        $[11] = isLoading;
        $[12] = t7;
        $[13] = t9;
        $[14] = t10;
    } else t10 = $[14];
    return t10;
} : ({ children: children, iframeLoaded: iframeLoaded, isLoading: isLoading })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $284b45fa25b321b5$var$containerStyles.default,
        "aria-busy": isLoading,
        "aria-live": "polite"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3pCca.Grid), {
        gap: "space.400",
        alignItems: "start",
        xcss: isLoading ? $284b45fa25b321b5$var$overlayStyles.default : $284b45fa25b321b5$var$visibilityStyles.hidden,
        "aria-hidden": !isLoading,
        role: "status"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "250px",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "40px",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "40px",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "40px",
        isShimmering: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        padding: "space.0",
        "aria-hidden": isLoading,
        xcss: !iframeLoaded ? $284b45fa25b321b5$var$visibilityStyles.invisible : $284b45fa25b321b5$var$visibilityStyles.visible
    }, children));


const $b8a91cca36070e7c$var$IframeWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, wrapper: wrapper } = t0;
    let t1;
    if ($[0] !== children || $[1] !== wrapper) {
        t1 = wrapper?.(children) ?? children;
        $[0] = children;
        $[1] = wrapper;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1);
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ children: children, wrapper: wrapper })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, wrapper?.(children) ?? children);
// helper to merge iframe refs
function $b8a91cca36070e7c$var$mergeIframeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (!ref) return;
            if (typeof ref === 'function') ref(value);
            else ref.current = value;
        });
    };
}
const $b8a91cca36070e7c$export$7c6e2c02157bb7d2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(44);
    let contentConfiguration;
    let contentId;
    let embeddedConfluenceSource;
    let externalIframeRef;
    let onLoad;
    let rest;
    let spaceKey;
    if ($[0] !== props) {
        const { contentId: t0, contentConfiguration: t1, navigationPolicy: _navigationPolicy, iframeRef: t2, onLoad: t3, embeddedConfluenceSource: t4, queryParams: _queryParams, spaceKey: t5, ...t6 } = props;
        contentId = t0;
        contentConfiguration = t1;
        externalIframeRef = t2;
        onLoad = t3;
        embeddedConfluenceSource = t4;
        spaceKey = t5;
        rest = t6;
        $[0] = props;
        $[1] = contentConfiguration;
        $[2] = contentId;
        $[3] = embeddedConfluenceSource;
        $[4] = externalIframeRef;
        $[5] = onLoad;
        $[6] = rest;
        $[7] = spaceKey;
    } else {
        contentConfiguration = $[1];
        contentId = $[2];
        embeddedConfluenceSource = $[3];
        externalIframeRef = $[4];
        onLoad = $[5];
        rest = $[6];
        spaceKey = $[7];
    }
    let t0;
    if ($[8] !== rest || $[9] !== spaceKey) {
        t0 = (0, $cXtTj.default).getExperimentValue("embedded_confluence_send_space_key_to_iframe", "isEnabled", false) ? {
            ...rest,
            spaceKey: spaceKey
        } : rest;
        $[8] = rest;
        $[9] = spaceKey;
        $[10] = t0;
    } else t0 = $[10];
    const passThroughProps = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { uniqueKey: uniqueKey } = (0, $hMKdq.useUniqueKey)();
    const experienceTracker = (0, $hOFc9.useExperienceTracker)();
    const { experience: experience, ccExperience: ccExperience } = contentConfiguration.experiences;
    let t1;
    if ($[11] !== ccExperience || $[12] !== contentId || $[13] !== experience || $[14] !== experienceTracker || $[15] !== spaceKey) {
        t1 = {
            experienceTracker: experienceTracker,
            contentId: contentId,
            spaceKey: spaceKey,
            experience: experience,
            ccExperience: ccExperience
        };
        $[11] = ccExperience;
        $[12] = contentId;
        $[13] = experience;
        $[14] = experienceTracker;
        $[15] = spaceKey;
        $[16] = t1;
    } else t1 = $[16];
    (0, $0ccaa3c1fbaccc4f$export$48d5d434479c259e)(t1);
    const { embeddedConfluenceUrl: embeddedConfluenceUrl, standaloneConfluenceUrl: standaloneConfluenceUrl } = (0, $ij75C.useUrl)(props);
    const shouldShowFooter = props.hasFooterLogo ?? true;
    let t2;
    if ($[17] !== contentConfiguration.hasFooter || $[18] !== experienceTracker || $[19] !== props.parentProduct || $[20] !== shouldShowFooter || $[21] !== standaloneConfluenceUrl) {
        t2 = {
            experienceTracker: experienceTracker,
            hasFooter: contentConfiguration.hasFooter,
            shouldShowFooter: shouldShowFooter,
            parentProduct: props.parentProduct,
            standaloneConfluenceUrl: standaloneConfluenceUrl
        };
        $[17] = contentConfiguration.hasFooter;
        $[18] = experienceTracker;
        $[19] = props.parentProduct;
        $[20] = shouldShowFooter;
        $[21] = standaloneConfluenceUrl;
        $[22] = t2;
    } else t2 = $[22];
    const { showFooter: showFooter, footerUrl: footerUrl } = (0, $148c06aca6ff7a3c$export$d07da6ac6fc160b0)(t2);
    const { height: height } = (0, $ioJku.useContentSize)(uniqueKey);
    (0, $7f714e1c52a150d1$export$8c87e334b260af87)(passThroughProps.isHeightSetFromContent, uniqueKey, passThroughProps.scrollToHashHandler);
    let t3;
    if ($[23] !== contentConfiguration.getWrapperElement || $[24] !== embeddedConfluenceSource || $[25] !== embeddedConfluenceUrl || $[26] !== externalIframeRef || $[27] !== footerUrl || $[28] !== formatMessage || $[29] !== height || $[30] !== onLoad || $[31] !== passThroughProps || $[32] !== showFooter || $[33] !== uniqueKey) {
        t3 = (t4)=>{
            const { iframeRef: iframeRef, iframeLoaded: iframeLoaded, isLoading: isLoading, handleIframeOnLoad: handleIframeOnLoad, handleContentLoadStarted: handleContentLoadStarted, navigationPolicy: navigationPolicy, handleIframeUnload: handleIframeUnload, redirectedToLogin: redirectedToLogin } = t4;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b8a91cca36070e7c$var$IframeWrapper, {
                wrapper: contentConfiguration.getWrapperElement
            }, embeddedConfluenceUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $284b45fa25b321b5$export$666e684aed003bfe), {
                iframeLoaded: iframeLoaded,
                isLoading: isLoading
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f5f432f3cddb52d8$export$5137ec99f248330b), {
                ref: $b8a91cca36070e7c$var$mergeIframeRefs(iframeRef, externalIframeRef),
                src: redirectedToLogin ? "" : embeddedConfluenceUrl,
                ...passThroughProps,
                navigationPolicy: navigationPolicy,
                style: {
                    flex: passThroughProps.isHeightSetFromContent ? `1 0 ${height}px` : "0 1 100%"
                },
                uniqueKey: uniqueKey,
                onLoad: (e)=>{
                    handleIframeOnLoad();
                    onLoad?.(e);
                },
                onUnload: handleIframeUnload,
                onContentLoadStarted: handleContentLoadStarted
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eRLgK.PageNotFoundEmptyState), {
                embeddedConfluenceSource: embeddedConfluenceSource
            })), showFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $920d185a4b71f988$export$a06f1c675e846f6f), {
                url: footerUrl,
                linkTooltip: formatMessage((0, $fadd871ba413d295$export$2e2bcd8739ae039).viewInConfluence),
                label: formatMessage((0, $fadd871ba413d295$export$2e2bcd8739ae039).poweredBy)
            }));
        };
        $[23] = contentConfiguration.getWrapperElement;
        $[24] = embeddedConfluenceSource;
        $[25] = embeddedConfluenceUrl;
        $[26] = externalIframeRef;
        $[27] = footerUrl;
        $[28] = formatMessage;
        $[29] = height;
        $[30] = onLoad;
        $[31] = passThroughProps;
        $[32] = showFooter;
        $[33] = uniqueKey;
        $[34] = t3;
    } else t3 = $[34];
    let t4;
    if ($[35] !== props || $[36] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1394cf2f62255656$export$3b0759108d92fe77), props, t3);
        $[35] = props;
        $[36] = t3;
        $[37] = t4;
    } else t4 = $[37];
    let t5;
    if ($[38] !== experience || $[39] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5a28ee97dda09b19$export$c90b54e658fc4d7c), {
            name: experience
        }, t4);
        $[38] = experience;
        $[39] = t4;
        $[40] = t5;
    } else t5 = $[40];
    let t6;
    if ($[41] !== experienceTracker || $[42] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fULE8.ExperienceTrackerContext).Provider, {
            value: experienceTracker
        }, t5);
        $[41] = experienceTracker;
        $[42] = t5;
        $[43] = t6;
    } else t6 = $[43];
    return t6;
} : (props)=>{
    const { contentId: contentId, contentConfiguration: contentConfiguration, navigationPolicy: _navigationPolicy, iframeRef: externalIframeRef, onLoad: onLoad, embeddedConfluenceSource: embeddedConfluenceSource, queryParams: _queryParams, spaceKey: spaceKey, ...rest } = props;
    // Broadcast `spaceKey` so the iframe header prefers the parent prop over
    // the URL path, which can carry a stale space alias after a rename (JPNS-115645).
    const passThroughProps = (0, $cXtTj.default).getExperimentValue('embedded_confluence_send_space_key_to_iframe', 'isEnabled', false) ? {
        ...rest,
        spaceKey: spaceKey
    } : rest;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { uniqueKey: uniqueKey } = (0, $hMKdq.useUniqueKey)();
    const experienceTracker = (0, $hOFc9.useExperienceTracker)();
    const { experience: experience, ccExperience: ccExperience } = contentConfiguration.experiences;
    (0, $0ccaa3c1fbaccc4f$export$48d5d434479c259e)({
        experienceTracker: experienceTracker,
        contentId: contentId,
        spaceKey: spaceKey,
        experience: experience,
        ccExperience: ccExperience
    });
    const { embeddedConfluenceUrl: embeddedConfluenceUrl, standaloneConfluenceUrl: standaloneConfluenceUrl } = (0, $ij75C.useUrl)(props);
    /**
   * The difference between hasFooter and hasFooterLogo can be found here
   * https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/40212/cbt-2587-docs-changeset-ux-add-embedded#comment-428798112
   *
   * EDIT 7/17: hasFooterLogo property has been renamed internally for clarity as is now aliased as shouldShowFooter when used internally. Externally, the API remains unchanged.
   */ const shouldShowFooter = props.hasFooterLogo ?? true;
    const { showFooter: showFooter, footerUrl: footerUrl } = (0, $148c06aca6ff7a3c$export$d07da6ac6fc160b0)({
        experienceTracker: experienceTracker,
        hasFooter: contentConfiguration.hasFooter,
        shouldShowFooter: shouldShowFooter,
        parentProduct: props.parentProduct,
        standaloneConfluenceUrl: standaloneConfluenceUrl
    });
    const { height: height } = (0, $ioJku.useContentSize)(uniqueKey);
    (0, $7f714e1c52a150d1$export$8c87e334b260af87)(passThroughProps.isHeightSetFromContent, uniqueKey, passThroughProps.scrollToHashHandler);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fULE8.ExperienceTrackerContext).Provider, {
        value: experienceTracker
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5a28ee97dda09b19$export$c90b54e658fc4d7c), {
        name: experience
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1394cf2f62255656$export$3b0759108d92fe77), props, ({ iframeRef: iframeRef, iframeLoaded: iframeLoaded, isLoading: isLoading, handleIframeOnLoad: handleIframeOnLoad, handleContentLoadStarted: handleContentLoadStarted, navigationPolicy: navigationPolicy, handleIframeUnload: handleIframeUnload, redirectedToLogin: redirectedToLogin })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b8a91cca36070e7c$var$IframeWrapper, {
            wrapper: contentConfiguration.getWrapperElement
        }, embeddedConfluenceUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $284b45fa25b321b5$export$666e684aed003bfe), {
            iframeLoaded: iframeLoaded,
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f5f432f3cddb52d8$export$5137ec99f248330b), {
            ref: $b8a91cca36070e7c$var$mergeIframeRefs(iframeRef, externalIframeRef),
            // https://hello.atlassian.net/wiki/spaces/~142157567/pages/2224394268/Spike+on+CBT-1814
            src: redirectedToLogin ? '' : embeddedConfluenceUrl,
            ...passThroughProps,
            navigationPolicy: navigationPolicy,
            style: {
                flex: passThroughProps.isHeightSetFromContent ? `1 0 ${height}px` : '0 1 100%'
            },
            uniqueKey: uniqueKey,
            onLoad: (e)=>{
                handleIframeOnLoad();
                onLoad?.(e);
            },
            onUnload: handleIframeUnload,
            onContentLoadStarted: handleContentLoadStarted
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eRLgK.PageNotFoundEmptyState), {
            embeddedConfluenceSource: embeddedConfluenceSource
        })), showFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $920d185a4b71f988$export$a06f1c675e846f6f), {
            url: footerUrl,
            linkTooltip: formatMessage((0, $fadd871ba413d295$export$2e2bcd8739ae039).viewInConfluence),
            label: formatMessage((0, $fadd871ba413d295$export$2e2bcd8739ae039).poweredBy)
        })))));
};
module.exports["Content"] = $b8a91cca36070e7c$export$7c6e2c02157bb7d2;

});

parcelRegister("cqtVU", function(module, exports) {
const $9d5928b982aee057$export$16e3f1b03b231b35 = (event)=>event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail';
const $9d5928b982aee057$export$57069f5b2ecc9128 = (event, ...names)=>names.includes(event.name);
module.exports["isStop"] = $9d5928b982aee057$export$16e3f1b03b231b35;
module.exports["hasName"] = $9d5928b982aee057$export$57069f5b2ecc9128;

});

parcelRegister("3L4J0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
// @ts-nocheck
// @ts-nocheck

var $cyOhz = parcelRequire("cyOhz");

// @ts-nocheck
const $5d4b4283f20e5f2d$var$allowedPlatformFeatureFlags = [];
function $5d4b4283f20e5f2d$export$bd17c6970f4d989e() {
    const flags = {};
    if (window.connectHost && window.connectHost.getBooleanFeatureFlag) $5d4b4283f20e5f2d$var$allowedPlatformFeatureFlags.forEach((key)=>flags[key] = window.connectHost.getBooleanFeatureFlag(key));
    return flags;
}


// @ts-nocheck
/**
 * Postmessage format:
 *
 * Initialization
 * --------------
 * {
 *   type: 'init',
 *   eid: 'my-addon__my-module-xyz'  // the extension identifier, unique across iframes
 * }
 *
 * Request
 * -------
 * {
 *   type: 'req',
 *   eid: 'my-addon__my-module-xyz',  // the extension identifier, unique for iframe
 *   mid: 'xyz',  // a unique message identifier, required for callbacks
 *   mod: 'cookie',  // the module name
 *   fn: 'read',  // the method name
 *   args: [arguments]  // the method arguments
 * }
 *
 * Response
 * --------
 * {
 *   type: 'resp'
 *   eid: 'my-addon__my-module-xyz',  // the extension identifier, unique for iframe
 *   mid: 'xyz',  // a unique message identifier, obtained from the request
 *   args: [arguments]  // the callback arguments
 * }
 *
 * Event
 * -----
 * {
 *   type: 'evt',
 *   etyp: 'some-event',
 *   evnt: { ... }  // the event data
 *   mid: 'xyz', // a unique message identifier for the event
 * }
 **/ 
var $9dHm9 = parcelRequire("9dHm9");




let $ce3d2055e2368c28$var$VALID_EVENT_TIME_MS = 30000; //30 seconds
class $ce3d2055e2368c28$var$XDMRPC extends (0, $9dHm9.default) {
    _padUndefinedArguments(array, length) {
        return array.length >= length ? array : array.concat(new Array(length - array.length));
    }
    _verifyAPI(event, reg) {
        var untrustedTargets = event.data.targets;
        if (!untrustedTargets) return;
        var trustedSpec = this.getApiSpec();
        var tampered = false;
        function check(trusted, untrusted) {
            Object.getOwnPropertyNames(untrusted).forEach(function(name) {
                if (typeof untrusted[name] === 'object' && trusted[name]) check(trusted[name], untrusted[name]);
                else if (untrusted[name] === 'parent' && trusted[name]) tampered = true;
            });
        }
        check(trustedSpec, untrustedTargets);
        if (event.source && event.source.postMessage) // only post a message if the source of the event still exists
        event.source.postMessage({
            type: 'api_tamper',
            tampered: tampered
        }, reg.extension.url);
        else // eslint-disable-next-line no-console
        console.warn('_verifyAPI postMessage skipped as event source missing.');
    }
    _handleInit(event, reg) {
        if (event.source && event.source.postMessage) // only post a message if the source of the event still exists
        event.source.postMessage({
            type: 'init_received'
        }, reg.extension.url);
        else // eslint-disable-next-line no-console
        console.warn('_handleInit postMessage skipped as event source missing.');
        this._registeredExtensions[reg.extension_id].source = event.source;
        if (reg.initCallback) {
            reg.initCallback(event.data.eid);
            delete reg.initCallback;
        }
        if (event.data.targets) this._verifyAPI(event, reg);
    }
    _getHostOffset(event, _window) {
        var hostWindow = event.source;
        var hostFrameOffset = null;
        var windowReference = _window || window; // For testing
        if (windowReference === windowReference.top && typeof windowReference.getHostOffsetFunctionOverride === 'function') hostFrameOffset = windowReference.getHostOffsetFunctionOverride(hostWindow);
        if (typeof hostFrameOffset !== 'number') {
            hostFrameOffset = 0;
            // Find the closest frame that has the same origin as event source
            while(!this._hasSameOrigin(hostWindow)){
                // Climb up the iframe tree 1 layer
                hostFrameOffset++;
                hostWindow = hostWindow.parent;
            }
        }
        if (event.source && event.source.postMessage) // only post a message if the source of the event still exists
        event.source.postMessage({
            hostFrameOffset: hostFrameOffset
        }, event.origin);
        else // eslint-disable-next-line no-console
        console.warn('_getHostOffset postMessage skipped as event source missing.');
    }
    _hasSameOrigin(window1) {
        if (window1 === window1.top) return true;
        try {
            // Try set & read a variable on the given window
            // If we can successfully read the value then it means the given window has the same origin
            // as the window that is currently executing the script
            var testVariableName = 'test_var_' + Math.random().toString(16).substr(2);
            window1[testVariableName] = true;
            return window1[testVariableName];
        } catch (e) {
        // A exception will be thrown if the windows doesn't have the same origin
        }
        return false;
    }
    _handleResponse(event) {
        var data = event.data;
        var pendingCallback = this._pendingCallbacks[data.mid];
        if (pendingCallback) {
            delete this._pendingCallbacks[data.mid];
            pendingCallback.apply(window, data.args);
        }
    }
    registerRequestNotifier(cb) {
        this._registeredRequestNotifier = cb;
    }
    _handleRequest(event, reg) {
        function sendResponse() {
            var args = (0, $cyOhz.default).sanitizeStructuredClone((0, $cyOhz.default).argumentsToArray(arguments));
            if (event.source && event.source.postMessage) // only post a message if the source of the event still exists
            event.source.postMessage({
                mid: event.data.mid,
                type: 'resp',
                forPlugin: true,
                args: args
            }, reg.extension.url);
            else // eslint-disable-next-line no-console
            console.warn('_handleRequest postMessage skipped as event source missing.');
        }
        var data = event.data;
        var module = this._registeredAPIModules[data.mod];
        const extension = this.getRegisteredExtensions(reg.extension)[0];
        if (module) {
            let fnName = data.fn;
            if (data._cls) {
                const Cls = module[data._cls];
                const ns = data.mod + '-' + data._cls + '-';
                sendResponse._id = data._id;
                if (fnName === 'constructor') {
                    if (!Cls._construct) {
                        Cls.constructor.prototype._destroy = function() {
                            delete this._context._proxies[ns + this._id];
                        };
                        Cls._construct = function(...args) {
                            const inst = new Cls.constructor(...args);
                            const callback = args[args.length - 1];
                            inst._id = callback._id;
                            inst._context = callback._context;
                            inst._context._proxies[ns + inst._id] = inst;
                            return inst;
                        };
                    }
                    module = Cls;
                    fnName = '_construct';
                } else module = extension._proxies[ns + data._id];
            }
            let method = module[fnName];
            if (method) {
                var methodArgs = data.args;
                var padLength = method.length - 1;
                if (fnName === '_construct') padLength = module.constructor.length - 1;
                sendResponse._context = extension;
                methodArgs = this._padUndefinedArguments(methodArgs, padLength);
                methodArgs.push(sendResponse);
                const promiseResult = method.apply(module, methodArgs);
                if (method.returnsPromise) {
                    if (!(typeof promiseResult === 'object' || typeof promiseResult === 'function') || typeof promiseResult.then !== 'function') sendResponse('Defined module method did not return a promise.');
                    else promiseResult.then((result)=>{
                        sendResponse(undefined, result);
                    }).catch((err)=>{
                        err = err instanceof Error ? err.message : err;
                        sendResponse(err);
                    });
                }
                if (this._registeredRequestNotifier) this._registeredRequestNotifier.call(null, {
                    module: data.mod,
                    fn: data.fn,
                    type: data.type,
                    args: methodArgs,
                    addon_key: reg.extension.addon_key,
                    key: reg.extension.key,
                    extension_id: reg.extension_id
                });
            }
        }
    }
    _handleBroadcast(event, reg) {
        var event_data = event.data;
        var targetSpec = (r)=>r.extension.addon_key === reg.extension.addon_key && r.extension_id !== reg.extension_id;
        this.dispatch(event_data.etyp, targetSpec, event_data.evnt, null, null);
    }
    _handleKeyTriggered(event, reg) {
        var eventData = event.data;
        var keycodeEntry = this._keycodeKey(eventData.keycode, eventData.modifiers, reg.extension_id);
        var listeners = this._keycodeCallbacks[keycodeEntry];
        if (listeners) listeners.forEach((listener)=>{
            listener.call(null, {
                addon_key: reg.extension.addon_key,
                key: reg.extension.key,
                extension_id: reg.extension_id,
                keycode: eventData.keycode,
                modifiers: eventData.modifiers
            });
        }, this);
    }
    defineAPIModule(module, moduleName) {
        moduleName = moduleName || '_globals';
        this._registeredAPIModules[moduleName] = (0, $cyOhz.default).extend({}, this._registeredAPIModules[moduleName] || {}, module);
        return this._registeredAPIModules;
    }
    isAPIModuleDefined(moduleName) {
        return typeof this._registeredAPIModules[moduleName] !== 'undefined';
    }
    _pendingEventKey(targetSpec, time) {
        var key = targetSpec.addon_key || 'global';
        if (targetSpec.key) key = `${key}@@${targetSpec.key}`;
        key = `${key}@@${time}`;
        return key;
    }
    queueEvent(type, targetSpec, event, callback) {
        var loaded_frame, targets = this._findRegistrations(targetSpec);
        loaded_frame = targets.some((target)=>{
            return target.registered_events !== undefined;
        }, this);
        if (loaded_frame) this.dispatch(type, targetSpec, event, callback);
        else {
            this._cleanupInvalidEvents();
            var time = new Date().getTime();
            this._pendingEvents[this._pendingEventKey(targetSpec, time)] = {
                type: type,
                targetSpec: targetSpec,
                event: event,
                callback: callback,
                time: time,
                uid: (0, $cyOhz.default).randomString()
            };
        }
    }
    _cleanupInvalidEvents() {
        let now = new Date().getTime();
        let keys = Object.keys(this._pendingEvents);
        keys.forEach((index)=>{
            let element = this._pendingEvents[index];
            let eventIsValid = now - element.time <= $ce3d2055e2368c28$var$VALID_EVENT_TIME_MS;
            if (!eventIsValid) delete this._pendingEvents[index];
        });
    }
    _handleEventQuery(message, extension) {
        let executed = {};
        let now = new Date().getTime();
        let keys = Object.keys(this._pendingEvents);
        keys.forEach((index)=>{
            let element = this._pendingEvents[index];
            let eventIsValid = now - element.time <= $ce3d2055e2368c28$var$VALID_EVENT_TIME_MS;
            let isSameTarget = !element.targetSpec || this._findRegistrations(element.targetSpec).length !== 0;
            if (isSameTarget && element.targetSpec.key) isSameTarget = element.targetSpec.addon_key === extension.extension.addon_key && element.targetSpec.key === extension.extension.key;
            if (eventIsValid && isSameTarget) {
                executed[index] = element;
                element.targetSpec = element.targetSpec || {};
                this.dispatch(element.type, element.targetSpec, element.event, element.callback, message.source);
            } else if (!eventIsValid) delete this._pendingEvents[index];
        });
        this._registeredExtensions[extension.extension_id].registered_events = message.data.args;
        return executed;
    }
    _handleUnload(event, reg) {
        if (!reg) return;
        if (reg.extension_id && this._registeredExtensions[reg.extension_id]) delete this._registeredExtensions[reg.extension_id].source;
        if (reg.unloadCallback) reg.unloadCallback(event.data.eid);
    }
    dispatch(type, targetSpec, event, callback, source) {
        function sendEvent(reg, evnt) {
            if (reg.source && reg.source.postMessage) {
                var mid;
                if (callback) {
                    mid = (0, $cyOhz.default).randomString();
                    this._pendingCallbacks[mid] = callback;
                }
                reg.source.postMessage({
                    type: 'evt',
                    mid: mid,
                    etyp: type,
                    evnt: evnt
                }, reg.extension.url);
            }
        }
        var registrations = this._findRegistrations(targetSpec || {});
        registrations.forEach(function(reg) {
            if (source && !reg.source) reg.source = source;
            if (reg.source) (0, $cyOhz.default)._bind(this, sendEvent)(reg, event);
        }, this);
    }
    _findRegistrations(targetSpec) {
        if (this._registeredExtensions.length === 0) {
            (0, $cyOhz.default).error('no registered extensions', this._registeredExtensions);
            return [];
        }
        var keys = Object.getOwnPropertyNames(targetSpec);
        var registrations = Object.getOwnPropertyNames(this._registeredExtensions).map((key)=>{
            return this._registeredExtensions[key];
        });
        if (targetSpec instanceof Function) return registrations.filter(targetSpec);
        else return registrations.filter(function(reg) {
            return keys.every(function(key) {
                return reg.extension[key] === targetSpec[key];
            });
        });
    }
    registerExtension(extension_id, data) {
        data._proxies = {};
        data.extension_id = extension_id;
        this._registeredExtensions[extension_id] = data;
    }
    _keycodeKey(key, modifiers, extension_id) {
        var code = key;
        if (modifiers) {
            if (typeof modifiers === 'string') modifiers = [
                modifiers
            ];
            modifiers.sort();
            modifiers.forEach((modifier)=>{
                code += '$$' + modifier;
            }, this);
        }
        return code + '__' + extension_id;
    }
    registerKeyListener(extension_id, key, modifiers, callback) {
        if (typeof modifiers === 'string') modifiers = [
            modifiers
        ];
        var reg = this._registeredExtensions[extension_id];
        var keycodeEntry = this._keycodeKey(key, modifiers, extension_id);
        if (!this._keycodeCallbacks[keycodeEntry]) {
            this._keycodeCallbacks[keycodeEntry] = [];
            reg.source.postMessage({
                type: 'key_listen',
                keycode: key,
                modifiers: modifiers,
                action: 'add'
            }, reg.extension.url);
        }
        this._keycodeCallbacks[keycodeEntry].push(callback);
    }
    unregisterKeyListener(extension_id, key, modifiers, callback) {
        var keycodeEntry = this._keycodeKey(key, modifiers, extension_id);
        var potentialCallbacks = this._keycodeCallbacks[keycodeEntry];
        var reg = this._registeredExtensions[extension_id];
        if (potentialCallbacks) {
            if (callback) {
                var index = potentialCallbacks.indexOf(callback);
                this._keycodeCallbacks[keycodeEntry].splice(index, 1);
            } else delete this._keycodeCallbacks[keycodeEntry];
            if (reg.source && reg.source.postMessage) reg.source.postMessage({
                type: 'key_listen',
                keycode: key,
                modifiers: modifiers,
                action: 'remove'
            }, reg.extension.url);
        }
    }
    registerClickHandler(callback) {
        if (typeof callback !== 'function') throw new Error('callback must be a function');
        this._clickHandlers.push(callback);
    }
    _handleAddonClick(event, reg) {
        for(var i = 0; i < this._clickHandlers.length; i++)if (typeof this._clickHandlers[i] === 'function') this._clickHandlers[i]({
            addon_key: reg.extension.addon_key,
            key: reg.extension.key,
            extension_id: reg.extension_id
        });
    }
    unregisterClickHandler() {
        this._clickHandlers = [];
    }
    getApiSpec(addonKey) {
        function getModuleDefinition(mod) {
            return Object.getOwnPropertyNames(mod).reduce((accumulator, memberName)=>{
                const member = mod[memberName];
                switch(typeof member){
                    case 'function':
                        accumulator[memberName] = {
                            args: (0, $cyOhz.default).argumentNames(member),
                            returnsPromise: member.returnsPromise || false
                        };
                        break;
                    case 'object':
                        if (member.hasOwnProperty('constructor')) accumulator[memberName] = getModuleDefinition(member);
                        break;
                }
                return accumulator;
            }, {});
        }
        return Object.getOwnPropertyNames(this._registeredAPIModules).reduce((accumulator, moduleName)=>{
            var module = this._registeredAPIModules[moduleName];
            if (typeof module.addonKey === 'undefined' || module.addonKey === addonKey) accumulator[moduleName] = getModuleDefinition(module);
            return accumulator;
        }, {});
    }
    _originEqual(url, origin) {
        function strCheck(str) {
            return typeof str === 'string' && str.length > 0;
        }
        let urlOrigin = (0, $cyOhz.default).getOrigin(url);
        // check strings are strings and they contain something
        if (!strCheck(url) || !strCheck(origin) || !strCheck(urlOrigin)) return false;
        return origin === urlOrigin;
    }
    // validate origin of postMessage
    _checkOrigin(event, reg) {
        let no_source_types = [
            'init'
        ];
        let isNoSourceType = reg && no_source_types.includes(event.data.type);
        let sourceTypeMatches = reg && event.source === reg.source;
        let hasExtensionUrl = reg && this._originEqual(reg.extension.url, event.origin);
        let isValidOrigin = hasExtensionUrl && (isNoSourceType || sourceTypeMatches);
        // get_host_offset fires before init
        if (event.data.type === 'get_host_offset' && window === window.top) isValidOrigin = true;
        // check undefined for chromium (Issue 395010)
        if (event.data.type === 'unload' && (sourceTypeMatches || event.source === undefined)) isValidOrigin = true;
        return isValidOrigin;
    }
    getRegisteredExtensions(filter) {
        if (filter) return this._findRegistrations(filter);
        return this._registeredExtensions;
    }
    unregisterExtension(filter) {
        let registrations = this._findRegistrations(filter);
        if (registrations.length !== 0) registrations.forEach(function(registration) {
            let keys = Object.keys(this._pendingEvents);
            keys.forEach((index)=>{
                let element = this._pendingEvents[index];
                let targetSpec = element.targetSpec || {};
                if (targetSpec.addon_key === registration.extension.addon_key && targetSpec.key === registration.extension.key) delete this._pendingEvents[index];
            });
            delete this._registeredExtensions[registration.extension_id];
        }, this);
    }
    setFeatureFlagGetter(getBooleanFeatureFlag) {
        this._getBooleanFeatureFlag = getBooleanFeatureFlag;
    }
    constructor(config){
        config = config || {};
        super(config);
        this._registeredExtensions = config.extensions || {};
        this._registeredAPIModules = {};
        this._registeredAPIModules._globals = {};
        this._pendingCallbacks = {};
        this._keycodeCallbacks = {};
        this._clickHandlers = [];
        this._pendingEvents = {};
        this._messageHandlers = {
            init: this._handleInit,
            req: this._handleRequest,
            resp: this._handleResponse,
            broadcast: this._handleBroadcast,
            event_query: this._handleEventQuery,
            key_triggered: this._handleKeyTriggered,
            addon_clicked: this._handleAddonClick,
            get_host_offset: this._getHostOffset,
            unload: this._handleUnload
        };
    }
}
var $ce3d2055e2368c28$export$2e2bcd8739ae039 = $ce3d2055e2368c28$var$XDMRPC;


class $b41a369bca98b163$var$Connect {
    /**
   * Send a message to iframes matching the targetSpec. This message is added to
   *  a message queue for delivery to ensure the message is received if an iframe
   *  has not yet loaded
   *
   * @param type The name of the event type
   * @param targetSpec The spec to match against extensions when sending this event
   * @param event The event payload
   * @param callback A callback to be executed when the remote iframe calls its callback
   */ dispatch(type, targetSpec, event, callback) {
        this._xdm.queueEvent(type, targetSpec, event, callback);
        return this.getExtensions(targetSpec);
    }
    /**
   * Send a message to iframes matching the targetSpec immediately. This message will
   *  only be sent to iframes that are already open, and will not be delivered if none
   *  are currently open.
   *
   * @param type The name of the event type
   * @param targetSpec The spec to match against extensions when sending this event
   * @param event The event payload
   */ broadcast(type, targetSpec, event) {
        this._xdm.dispatch(type, targetSpec, event, null, null);
        return this.getExtensions(targetSpec);
    }
    _createId(extension) {
        if (!extension.addon_key || !extension.key) throw Error('Extensions require addon_key and key');
        return extension.addon_key + '__' + extension.key + '__' + (0, $cyOhz.default).randomString();
    }
    /**
   * Creates a new iframed module, without actually creating the DOM element.
   * The iframe attributes are passed to the 'setupCallback', which is responsible for creating
   * the DOM element and returning the window reference.
   *
   * @param extension The extension definition. Example:
   *   {
   *     addon_key: 'my-addon',
   *     key: 'my-module',
   *     url: 'https://example.com/my-module',
   *     options: {
   *         autoresize: false,
   *         hostOrigin: 'https://connect-host.example.com/'
   *     }
   *   }
   *
   * @param initCallback The optional initCallback is called when the bridge between host and iframe is established.
   **/ create(extension, initCallback, unloadCallback) {
        let extension_id = this.registerExtension(extension, initCallback, unloadCallback);
        let options = extension.options || {};
        options.platformFeatureFlags = (0, $5d4b4283f20e5f2d$export$bd17c6970f4d989e)();
        let data = {
            extension_id: extension_id,
            api: this._xdm.getApiSpec(extension.addon_key),
            origin: (0, $cyOhz.default).locationOrigin(),
            options: options
        };
        return {
            id: extension_id,
            name: JSON.stringify(data),
            src: extension.url
        };
    }
    // This is called from ACJS
    // noinspection JSUnusedGlobalSymbols
    registerRequestNotifier(callback) {
        this._xdm.registerRequestNotifier(callback);
    }
    registerExtension(extension, initCallback, unloadCallback) {
        let extension_id = this._createId(extension);
        this._xdm.registerExtension(extension_id, {
            extension: extension,
            initCallback: initCallback,
            unloadCallback: unloadCallback
        });
        return extension_id;
    }
    registerKeyListener(extension_id, key, modifiers, callback) {
        this._xdm.registerKeyListener(extension_id, key, modifiers, callback);
    }
    unregisterKeyListener(extension_id, key, modifiers, callback) {
        this._xdm.unregisterKeyListener(extension_id, key, modifiers, callback);
    }
    registerClickHandler(callback) {
        this._xdm.registerClickHandler(callback);
    }
    unregisterClickHandler() {
        this._xdm.unregisterClickHandler();
    }
    defineModule(moduleName, module, options) {
        this._xdm.defineAPIModule(module, moduleName, options);
    }
    isModuleDefined(moduleName) {
        return this._xdm.isAPIModuleDefined(moduleName);
    }
    defineGlobals(module) {
        this._xdm.defineAPIModule(module);
    }
    getExtensions(filter) {
        return this._xdm.getRegisteredExtensions(filter);
    }
    unregisterExtension(filter) {
        return this._xdm.unregisterExtension(filter);
    }
    returnsPromise(wrappedMethod) {
        wrappedMethod.returnsPromise = true;
    }
    setFeatureFlagGetter(getBooleanFeatureFlag) {
        this._xdm.setFeatureFlagGetter(getBooleanFeatureFlag);
    }
    registerExistingExtension(extension_id, data) {
        return this._xdm.registerExtension(extension_id, data);
    }
    constructor(){
        this._xdm = new (0, $ce3d2055e2368c28$export$2e2bcd8739ae039)();
    }
}
var $b41a369bca98b163$export$2e2bcd8739ae039 = $b41a369bca98b163$var$Connect;


const $7a6af5060cb6ebda$var$_default_1 = new (0, $b41a369bca98b163$export$2e2bcd8739ae039)();
var $7a6af5060cb6ebda$export$2e2bcd8739ae039 = $7a6af5060cb6ebda$var$_default_1;
module.exports["default"] = $7a6af5060cb6ebda$export$2e2bcd8739ae039;

});

parcelRegister("cyOhz", function(module, exports) {
// @ts-nocheck
const $92c2a6cceef867b5$var$LOG_PREFIX = '[Simple-XDM] ';
const $92c2a6cceef867b5$var$nativeBind = Function.prototype.bind;
const $92c2a6cceef867b5$var$util = {
    locationOrigin () {
        if (!window.location.origin) return window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
        else return window.location.origin;
    },
    randomString () {
        return Math.floor(Math.random() * 1000000000).toString(16);
    },
    isString (str) {
        return typeof str === 'string' || str instanceof String;
    },
    argumentsToArray (arrayLike) {
        return Array.prototype.slice.call(arrayLike);
    },
    argumentNames (fn) {
        return fn.toString().replace(/((\/\/.*$)|(\/\*[^]*?\*\/))/gm, '') // strip comments
        .replace(/[^(]+\(([^)]*)[^]+/, '$1') // get signature
        .match(/([^\s,]+)/g) || [];
    },
    hasCallback (args) {
        var length = args.length;
        return length > 0 && typeof args[length - 1] === 'function';
    },
    error (msg) {
        if (window.console && window.console.error) {
            var outputError = [];
            if (typeof msg === 'string') {
                outputError.push($92c2a6cceef867b5$var$LOG_PREFIX + msg);
                outputError = outputError.concat(Array.prototype.slice.call(arguments, 1));
            } else {
                outputError.push($92c2a6cceef867b5$var$LOG_PREFIX);
                outputError = outputError.concat(Array.prototype.slice.call(arguments));
            }
            window.console.error.apply(null, outputError);
        }
    },
    warn (msg) {
        if (window.console) // eslint-disable-next-line no-console
        console.warn($92c2a6cceef867b5$var$LOG_PREFIX + msg);
    },
    log (msg) {
        if (window.console) window.console.log($92c2a6cceef867b5$var$LOG_PREFIX + msg);
    },
    _bind (thisp, fn) {
        if ($92c2a6cceef867b5$var$nativeBind && fn.bind === $92c2a6cceef867b5$var$nativeBind) return fn.bind(thisp);
        return function() {
            return fn.apply(thisp, arguments);
        };
    },
    throttle (func, wait, context) {
        var previous = 0;
        return function() {
            var now = Date.now();
            if (now - previous > wait) {
                previous = now;
                func.apply(context, arguments);
            }
        };
    },
    each (list, iteratee) {
        var length;
        var key;
        if (list) {
            length = list.length;
            if (length != null && typeof list !== 'function') {
                key = 0;
                while(key < length){
                    if (iteratee.call(list[key], key, list[key]) === false) break;
                    key += 1;
                }
            } else {
                for(key in list)if (list.hasOwnProperty(key)) {
                    if (iteratee.call(list[key], key, list[key]) === false) break;
                }
            }
        }
    },
    extend (dest) {
        var args = arguments;
        var srcs = [].slice.call(args, 1, args.length);
        srcs.forEach(function(source) {
            if (typeof source === 'object') Object.getOwnPropertyNames(source).forEach(function(name) {
                dest[name] = source[name];
            });
        });
        return dest;
    },
    sanitizeStructuredClone (object) {
        const whiteList = [
            Boolean,
            String,
            Date,
            RegExp,
            Blob,
            File,
            FileList,
            ArrayBuffer
        ];
        const blackList = [
            Error,
            Node
        ];
        const warn = $92c2a6cceef867b5$var$util.warn;
        var visitedObjects = [];
        function _clone(value) {
            if (typeof value === 'function') {
                warn('A function was detected and removed from the message.');
                return null;
            }
            if (blackList.some((t)=>{
                if (value instanceof t) {
                    warn(`${t.name} object was detected and removed from the message.`);
                    return true;
                }
                return false;
            })) return {};
            if (value && typeof value === 'object' && whiteList.every((t)=>!(value instanceof t))) {
                let newValue;
                if (Array.isArray(value)) newValue = value.map(function(element) {
                    return _clone(element);
                });
                else {
                    if (visitedObjects.indexOf(value) > -1) {
                        warn('A circular reference was detected and removed from the message.');
                        return null;
                    }
                    visitedObjects.push(value);
                    newValue = {};
                    for(let name in value)if (value.hasOwnProperty(name)) {
                        let clonedValue = _clone(value[name]);
                        if (clonedValue !== null) newValue[name] = clonedValue;
                    }
                    visitedObjects.pop();
                }
                return newValue;
            }
            return value;
        }
        return _clone(object);
    },
    getOrigin (url, base) {
        // everything except IE11
        if (typeof URL === 'function') try {
            return new URL(url, base).origin;
        } catch (e) {}
        // ie11 + safari 10
        var doc = document.implementation.createHTMLDocument('');
        if (base) {
            var baseElement = doc.createElement('base');
            baseElement.href = base;
            doc.head.appendChild(baseElement);
        }
        var anchorElement = doc.createElement('a');
        anchorElement.href = url;
        doc.body.appendChild(anchorElement);
        var origin = anchorElement.protocol + '//' + anchorElement.hostname;
        //ie11, only include port if referenced in initial URL
        if (url.match(/\/\/[^/]+:[0-9]+\//)) origin += anchorElement.port ? ':' + anchorElement.port : '';
        return origin;
    }
};
var $92c2a6cceef867b5$export$2e2bcd8739ae039 = $92c2a6cceef867b5$var$util;
module.exports["default"] = $92c2a6cceef867b5$export$2e2bcd8739ae039;

});

parcelRegister("9dHm9", function(module, exports) {
// @ts-nocheck

var $cyOhz = parcelRequire("cyOhz");

class $7a396ef73c435958$var$PostMessage {
    _registerListener(listenOn) {
        if (!listenOn || !listenOn.addEventListener) listenOn = window;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        listenOn.addEventListener('message', (0, $cyOhz.default)._bind(this, this._receiveMessage), false);
    }
    _receiveMessage(event) {
        let handler = this._messageHandlers[event.data.type], extensionId = event.data.eid, reg;
        if (extensionId && this._registeredExtensions) reg = this._registeredExtensions[extensionId];
        if (!handler || !this._checkOrigin(event, reg)) return false;
        handler.call(this, event, reg);
    }
    constructor(data){
        let d = data || {};
        this._registerListener(d.listenOn);
    }
}
var $7a396ef73c435958$export$2e2bcd8739ae039 = $7a396ef73c435958$var$PostMessage;
module.exports["default"] = $7a396ef73c435958$export$2e2bcd8739ae039;

});

parcelRegister("7w1PB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fULE8 = parcelRequire("fULE8");

function $07f83d4d501f25be$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $cozmU.useContext)((0, $fULE8.ExperienceTrackerContext));
    const wasCalledRef = (0, $cozmU.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}
module.exports["ExperienceStart"] = $07f83d4d501f25be$export$f20b867e738a222c;

});

parcelRegister("2RJCj", function(module, exports) {
const $9d92911f738ac357$export$8c2f2e05ab832914 = 'embeddedConfluenceScrollToHash';
module.exports["SCROLL_TO_HASH_MESSAGE_TYPE"] = $9d92911f738ac357$export$8c2f2e05ab832914;

});

parcelRegister("1H7qn", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hcmVI = parcelRequire("hcmVI");

// Add debounce to the scroll handler to ensure that it is executed only once after X ms of delay
const $9c6dd39da598a140$var$handleScrollDeboubced = (scrollHandler, delay)=>{
    let timeoutId;
    return (...args)=>{
        if (timeoutId) clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
            scrollHandler(...args);
        }, delay);
    };
};
const $9c6dd39da598a140$export$4d8f561c32665bbe = (0, $gtMdU.isReactCompilerActivePlatform)() ? (isHeightSetFromContent)=>{
    const $ = (0, $bDgLe.c)(8);
    const [scrollPosition, setScrollPosition] = (0, $cozmU.useState)(0);
    const defaultScrollPosition = (0, $cozmU.useRef)(0);
    const prevScrollPosition = (0, $cozmU.useRef)(0);
    const { isMediaOpen: isMediaOpen } = (0, $hcmVI.useMediaViewerListener)();
    let t0;
    let t1;
    if ($[0] !== isMediaOpen || $[1] !== scrollPosition) {
        t0 = ()=>{
            const handleScroll = $9c6dd39da598a140$var$handleScrollDeboubced(()=>{
                if (!isMediaOpen) {
                    prevScrollPosition.current = scrollPosition;
                    setScrollPosition(window.scrollY);
                }
            }, 100);
            window.addEventListener("scroll", handleScroll);
            return ()=>{
                window.removeEventListener("scroll", handleScroll);
            };
        };
        t1 = [
            isMediaOpen,
            scrollPosition
        ];
        $[0] = isMediaOpen;
        $[1] = scrollPosition;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    let t3;
    if ($[4] !== isHeightSetFromContent || $[5] !== isMediaOpen) {
        t2 = ()=>{
            if (isHeightSetFromContent) window.scrollTo(0, isMediaOpen ? defaultScrollPosition.current : prevScrollPosition.current);
        };
        t3 = [
            isHeightSetFromContent,
            isMediaOpen
        ];
        $[4] = isHeightSetFromContent;
        $[5] = isMediaOpen;
        $[6] = t2;
        $[7] = t3;
    } else {
        t2 = $[6];
        t3 = $[7];
    }
    (0, $cozmU.useEffect)(t2, t3);
} : (isHeightSetFromContent)=>{
    const [scrollPosition, setScrollPosition] = (0, $cozmU.useState)(0);
    const defaultScrollPosition = (0, $cozmU.useRef)(0); // mutable ref to 0 - return this value when the media is open
    const prevScrollPosition = (0, $cozmU.useRef)(0);
    const { isMediaOpen: isMediaOpen } = (0, $hcmVI.useMediaViewerListener)();
    (0, $cozmU.useEffect)(()=>{
        const handleScroll = $9c6dd39da598a140$var$handleScrollDeboubced(()=>{
            if (!isMediaOpen) {
                /*
        	Saving the previous scroll position is essential because, by the time we receive the state of the media viewer,
        	it may already have been opened or closed, and we do not have control over the actions that occur
        	just before the media viewer is activated (which happens in a different package that we do not manage).
        	Consequently, it is possible for the variable isMediaOpen to be false even when the media viewer is indeed open.
        	This situation results in saving of an incorrect value for the scroll position when the media viewer is already active,
        	which is misleading since the container height will have been reduced at this point.
        	To mitigate this inaccuracy, we continuously track the scroll position when the media viewer is not open.
        	When the media is subsequently clicked to open, retrieving the previous scroll position helps to offset the
        	inaccuracies associated with saving the scroll position under the conditions of a condensed height.
        */ prevScrollPosition.current = scrollPosition;
                setScrollPosition(window.scrollY);
            }
        }, 100); // Call the handler only once scroll event has stopped firing for a delay of 100ms.
        window.addEventListener('scroll', handleScroll);
        return ()=>{
            window.removeEventListener('scroll', handleScroll);
        };
    }, [
        isMediaOpen,
        scrollPosition
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isHeightSetFromContent) // Restore the scroll position back to the value saved before any media file was open
        window.scrollTo(0, isMediaOpen ? defaultScrollPosition.current : prevScrollPosition.current);
    }, [
        isHeightSetFromContent,
        isMediaOpen
    ]);
};
module.exports["useGetCurrentScrollPosition"] = $9c6dd39da598a140$export$4d8f561c32665bbe;

});

parcelRegister("4nZvv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");











var $5csBp = parcelRequire("5csBp");


var $kTPbu = parcelRequire("kTPbu");

var $bVevd = parcelRequire("bVevd");


var $liHlj = parcelRequire("liHlj");


var $eAWIs = parcelRequire("eAWIs");

const $df4ceff7b322ff54$var$IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED = 'auto_closed';
const $df4ceff7b322ff54$export$1fea75498367c4ac = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(10);
    const { allowedFeatures: allowedFeatures } = props;
    let t0;
    if ($[0] !== allowedFeatures) {
        t0 = (0, $eAWIs.isInEditorTemplatesPanelEnabled)(allowedFeatures);
        $[0] = allowedFeatures;
        $[1] = t0;
    } else t0 = $[1];
    const isTemplateBrowserEnabled = t0;
    let t1;
    if ($[2] !== isTemplateBrowserEnabled) {
        t1 = isTemplateBrowserEnabled ? {
            inEditorTemplatesPanel: $df4ceff7b322ff54$var$IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED
        } : undefined;
        $[2] = isTemplateBrowserEnabled;
        $[3] = t1;
    } else t1 = $[3];
    const queryParams = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            experience: (0, $5csBp.ExperienceNames).EDIT_PAGE,
            ccExperience: (0, $5csBp.ExperienceNames).CC_EDIT_PAGE_EMBED
        };
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== queryParams) {
        t3 = {
            experiences: t2,
            queryParams: queryParams
        };
        $[5] = queryParams;
        $[6] = t3;
    } else t3 = $[6];
    const contentConfiguration = t3;
    let t4;
    if ($[7] !== contentConfiguration || $[8] !== props) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $liHlj.Content), {
            ...props,
            contentType: (0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE,
            mode: (0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE,
            contentConfiguration: contentConfiguration
        });
        $[7] = contentConfiguration;
        $[8] = props;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : (props)=>{
    const { allowedFeatures: allowedFeatures } = props;
    const contentConfiguration = (0, $cozmU.useMemo)(()=>{
        const isTemplateBrowserEnabled = (0, $eAWIs.isInEditorTemplatesPanelEnabled)(allowedFeatures);
        const queryParams = isTemplateBrowserEnabled ? {
            inEditorTemplatesPanel: $df4ceff7b322ff54$var$IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED
        } : undefined;
        return {
            experiences: {
                experience: (0, $5csBp.ExperienceNames).EDIT_PAGE,
                ccExperience: (0, $5csBp.ExperienceNames).CC_EDIT_PAGE_EMBED
            },
            queryParams: queryParams
        };
    }, [
        allowedFeatures
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $liHlj.Content), {
        ...props,
        contentType: (0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE,
        mode: (0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE,
        contentConfiguration: contentConfiguration
    });
};



var $eRLgK = parcelRequire("eRLgK");


var $cuq2s = parcelRequire("cuq2s");


var $eBMyn = parcelRequire("eBMyn");


var $lWz4S = parcelRequire("lWz4S");


var $hMKdq = parcelRequire("hMKdq");

const $56fbd0c6a9918866$export$1fea75498367c4ac = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(9);
    const { markIframeLoadMetrics: markIframeLoadMetrics } = (0, $lWz4S.usePerformanceMetrics)();
    let t0;
    let t1;
    if ($[0] !== markIframeLoadMetrics) {
        t0 = ()=>{
            markIframeLoadMetrics("lazy-load-end");
            markIframeLoadMetrics("common-load-start");
        };
        t1 = [
            markIframeLoadMetrics
        ];
        $[0] = markIframeLoadMetrics;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useLayoutEffect)(t0, t1);
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eRLgK.PageNotFoundEmptyState), null);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== props) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMKdq.UniqueKeyProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: t2
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $df4ceff7b322ff54$export$1fea75498367c4ac), props)));
        $[4] = props;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== props.locale || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cuq2s.I18nProvider), {
            locale: props.locale,
            fetchTranslations: (0, $eBMyn.default)
        }, t3);
        $[6] = props.locale;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : (props)=>{
    const { markIframeLoadMetrics: markIframeLoadMetrics } = (0, $lWz4S.usePerformanceMetrics)();
    (0, $cozmU.useLayoutEffect)(()=>{
        markIframeLoadMetrics('lazy-load-end');
        markIframeLoadMetrics('common-load-start');
    }, [
        markIframeLoadMetrics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cuq2s.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $eBMyn.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMKdq.UniqueKeyProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eRLgK.PageNotFoundEmptyState), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $df4ceff7b322ff54$export$1fea75498367c4ac), props))));
};
module.exports["EditPage"] = $56fbd0c6a9918866$export$1fea75498367c4ac;

});

parcelRegister("f4me1", function(module, exports) {
$parcel$export(module.exports, "Action", () => $af887831bc80f4a5$export$e19cd5f9376f8cee);
/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $af887831bc80f4a5$var$_extends() {
    $af887831bc80f4a5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $af887831bc80f4a5$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $af887831bc80f4a5$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($af887831bc80f4a5$export$e19cd5f9376f8cee || ($af887831bc80f4a5$export$e19cd5f9376f8cee = {}));
const $af887831bc80f4a5$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $af887831bc80f4a5$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $af887831bc80f4a5$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $af887831bc80f4a5$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $af887831bc80f4a5$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $af887831bc80f4a5$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $af887831bc80f4a5$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $af887831bc80f4a5$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $af887831bc80f4a5$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $af887831bc80f4a5$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $af887831bc80f4a5$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $af887831bc80f4a5$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $af887831bc80f4a5$export$fe53371bee54353d(to);
    }
    return $af887831bc80f4a5$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $af887831bc80f4a5$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $af887831bc80f4a5$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $af887831bc80f4a5$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $af887831bc80f4a5$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $af887831bc80f4a5$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $af887831bc80f4a5$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $af887831bc80f4a5$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $af887831bc80f4a5$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $af887831bc80f4a5$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $af887831bc80f4a5$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $af887831bc80f4a5$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $af887831bc80f4a5$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $af887831bc80f4a5$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $af887831bc80f4a5$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $af887831bc80f4a5$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $af887831bc80f4a5$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $af887831bc80f4a5$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $af887831bc80f4a5$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($af887831bc80f4a5$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $af887831bc80f4a5$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $af887831bc80f4a5$export$e19cd5f9376f8cee.Push;
        let location = $af887831bc80f4a5$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $af887831bc80f4a5$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $af887831bc80f4a5$export$e19cd5f9376f8cee.Replace;
        let location = $af887831bc80f4a5$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $af887831bc80f4a5$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $af887831bc80f4a5$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $af887831bc80f4a5$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($af887831bc80f4a5$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($af887831bc80f4a5$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $af887831bc80f4a5$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($af887831bc80f4a5$var$ResultType || ($af887831bc80f4a5$var$ResultType = {}));
const $af887831bc80f4a5$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $af887831bc80f4a5$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $af887831bc80f4a5$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $af887831bc80f4a5$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $af887831bc80f4a5$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($af887831bc80f4a5$var$isIndexRoute(route)) {
            let indexRoute = $af887831bc80f4a5$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $af887831bc80f4a5$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $af887831bc80f4a5$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $af887831bc80f4a5$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $af887831bc80f4a5$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $af887831bc80f4a5$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $af887831bc80f4a5$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $af887831bc80f4a5$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $af887831bc80f4a5$var$flattenRoutes(routes);
    $af887831bc80f4a5$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $af887831bc80f4a5$export$30d21fd6d7295f52(pathname);
        matches = $af887831bc80f4a5$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $af887831bc80f4a5$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $af887831bc80f4a5$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $af887831bc80f4a5$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $af887831bc80f4a5$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $af887831bc80f4a5$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $af887831bc80f4a5$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $af887831bc80f4a5$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $af887831bc80f4a5$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $af887831bc80f4a5$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $af887831bc80f4a5$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $af887831bc80f4a5$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $af887831bc80f4a5$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $af887831bc80f4a5$var$paramRe = /^:[\w-]+$/;
const $af887831bc80f4a5$var$dynamicSegmentValue = 3;
const $af887831bc80f4a5$var$indexRouteValue = 2;
const $af887831bc80f4a5$var$emptySegmentValue = 1;
const $af887831bc80f4a5$var$staticSegmentValue = 10;
const $af887831bc80f4a5$var$splatPenalty = -2;
const $af887831bc80f4a5$var$isSplat = (s)=>s === "*";
function $af887831bc80f4a5$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($af887831bc80f4a5$var$isSplat)) initialScore += $af887831bc80f4a5$var$splatPenalty;
    if (index) initialScore += $af887831bc80f4a5$var$indexRouteValue;
    return segments.filter((s)=>!$af887831bc80f4a5$var$isSplat(s)).reduce((score, segment)=>score + ($af887831bc80f4a5$var$paramRe.test(segment) ? $af887831bc80f4a5$var$dynamicSegmentValue : segment === "" ? $af887831bc80f4a5$var$emptySegmentValue : $af887831bc80f4a5$var$staticSegmentValue), initialScore);
}
function $af887831bc80f4a5$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $af887831bc80f4a5$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $af887831bc80f4a5$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $af887831bc80f4a5$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $af887831bc80f4a5$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $af887831bc80f4a5$export$a5c6d149b50c1d86($af887831bc80f4a5$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $af887831bc80f4a5$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $af887831bc80f4a5$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $af887831bc80f4a5$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $af887831bc80f4a5$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $af887831bc80f4a5$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $af887831bc80f4a5$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $af887831bc80f4a5$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $af887831bc80f4a5$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $af887831bc80f4a5$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $af887831bc80f4a5$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $af887831bc80f4a5$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $af887831bc80f4a5$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $af887831bc80f4a5$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $af887831bc80f4a5$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $af887831bc80f4a5$var$normalizeSearch(search),
        hash: $af887831bc80f4a5$var$normalizeHash(hash)
    };
}
function $af887831bc80f4a5$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $af887831bc80f4a5$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $af887831bc80f4a5$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $af887831bc80f4a5$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $af887831bc80f4a5$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $af887831bc80f4a5$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $af887831bc80f4a5$export$8ccf933b0513f8d0(toArg);
    else {
        to = $af887831bc80f4a5$var$_extends({}, toArg);
        $af887831bc80f4a5$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $af887831bc80f4a5$var$getInvalidPathError("?", "pathname", "search", to));
        $af887831bc80f4a5$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $af887831bc80f4a5$var$getInvalidPathError("#", "pathname", "hash", to));
        $af887831bc80f4a5$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $af887831bc80f4a5$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $af887831bc80f4a5$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $af887831bc80f4a5$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $af887831bc80f4a5$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $af887831bc80f4a5$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $af887831bc80f4a5$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $af887831bc80f4a5$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $af887831bc80f4a5$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $af887831bc80f4a5$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $af887831bc80f4a5$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $af887831bc80f4a5$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $af887831bc80f4a5$export$4051a07651545597(data, init) {
    return new $af887831bc80f4a5$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $af887831bc80f4a5$export$42a99a7a4bc0e76a extends Error {
}
class $af887831bc80f4a5$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $af887831bc80f4a5$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $af887831bc80f4a5$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $af887831bc80f4a5$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $af887831bc80f4a5$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $af887831bc80f4a5$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $af887831bc80f4a5$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $af887831bc80f4a5$var$unwrapTrackedPromise(value) {
    if (!$af887831bc80f4a5$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $af887831bc80f4a5$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $af887831bc80f4a5$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $af887831bc80f4a5$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $af887831bc80f4a5$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $af887831bc80f4a5$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $af887831bc80f4a5$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $af887831bc80f4a5$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $af887831bc80f4a5$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $af887831bc80f4a5$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $af887831bc80f4a5$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $af887831bc80f4a5$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $af887831bc80f4a5$var$validMutationMethods = new Set($af887831bc80f4a5$var$validMutationMethodsArr);
const $af887831bc80f4a5$var$validRequestMethodsArr = [
    "get",
    ...$af887831bc80f4a5$var$validMutationMethodsArr
];
const $af887831bc80f4a5$var$validRequestMethods = new Set($af887831bc80f4a5$var$validRequestMethodsArr);
const $af887831bc80f4a5$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $af887831bc80f4a5$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $af887831bc80f4a5$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $af887831bc80f4a5$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $af887831bc80f4a5$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $af887831bc80f4a5$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $af887831bc80f4a5$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $af887831bc80f4a5$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $af887831bc80f4a5$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $af887831bc80f4a5$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $af887831bc80f4a5$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $af887831bc80f4a5$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $af887831bc80f4a5$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $af887831bc80f4a5$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $af887831bc80f4a5$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $af887831bc80f4a5$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $af887831bc80f4a5$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$af887831bc80f4a5$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$af887831bc80f4a5$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $af887831bc80f4a5$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $af887831bc80f4a5$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $af887831bc80f4a5$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $af887831bc80f4a5$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $af887831bc80f4a5$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$af887831bc80f4a5$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($af887831bc80f4a5$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $af887831bc80f4a5$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $af887831bc80f4a5$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $af887831bc80f4a5$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $af887831bc80f4a5$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $af887831bc80f4a5$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $af887831bc80f4a5$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $af887831bc80f4a5$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $af887831bc80f4a5$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $af887831bc80f4a5$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($af887831bc80f4a5$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $af887831bc80f4a5$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $af887831bc80f4a5$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $af887831bc80f4a5$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $af887831bc80f4a5$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $af887831bc80f4a5$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $af887831bc80f4a5$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $af887831bc80f4a5$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $af887831bc80f4a5$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $af887831bc80f4a5$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $af887831bc80f4a5$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $af887831bc80f4a5$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $af887831bc80f4a5$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $af887831bc80f4a5$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $af887831bc80f4a5$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $af887831bc80f4a5$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $af887831bc80f4a5$var$findNearestBoundary(matches).route.id,
            {
                type: $af887831bc80f4a5$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $af887831bc80f4a5$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($af887831bc80f4a5$var$isErrorResult(result) && $af887831bc80f4a5$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $af887831bc80f4a5$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $af887831bc80f4a5$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $af887831bc80f4a5$var$_extends({
            matches: updatedMatches || matches
        }, $af887831bc80f4a5$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $af887831bc80f4a5$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $af887831bc80f4a5$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $af887831bc80f4a5$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $af887831bc80f4a5$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $af887831bc80f4a5$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $af887831bc80f4a5$var$ResultType.error,
            error: $af887831bc80f4a5$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($af887831bc80f4a5$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $af887831bc80f4a5$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($af887831bc80f4a5$var$isDeferredResult(result)) throw $af887831bc80f4a5$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($af887831bc80f4a5$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $af887831bc80f4a5$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $af887831bc80f4a5$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $af887831bc80f4a5$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $af887831bc80f4a5$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($af887831bc80f4a5$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $af887831bc80f4a5$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $af887831bc80f4a5$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $af887831bc80f4a5$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $af887831bc80f4a5$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $af887831bc80f4a5$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $af887831bc80f4a5$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $af887831bc80f4a5$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $af887831bc80f4a5$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $af887831bc80f4a5$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $af887831bc80f4a5$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$af887831bc80f4a5$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $af887831bc80f4a5$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $af887831bc80f4a5$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $af887831bc80f4a5$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $af887831bc80f4a5$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $af887831bc80f4a5$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $af887831bc80f4a5$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $af887831bc80f4a5$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $af887831bc80f4a5$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $af887831bc80f4a5$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $af887831bc80f4a5$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $af887831bc80f4a5$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $af887831bc80f4a5$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($af887831bc80f4a5$var$isRedirectResult(actionResult) || $af887831bc80f4a5$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $af887831bc80f4a5$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($af887831bc80f4a5$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $af887831bc80f4a5$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $af887831bc80f4a5$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($af887831bc80f4a5$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($af887831bc80f4a5$var$isDeferredResult(actionResult)) throw $af887831bc80f4a5$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $af887831bc80f4a5$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $af887831bc80f4a5$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $af887831bc80f4a5$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $af887831bc80f4a5$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $af887831bc80f4a5$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $af887831bc80f4a5$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $af887831bc80f4a5$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $af887831bc80f4a5$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $af887831bc80f4a5$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $af887831bc80f4a5$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $af887831bc80f4a5$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $af887831bc80f4a5$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $af887831bc80f4a5$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $af887831bc80f4a5$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $af887831bc80f4a5$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $af887831bc80f4a5$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($af887831bc80f4a5$var$isDeferredResult(result)) result = await $af887831bc80f4a5$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $af887831bc80f4a5$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($af887831bc80f4a5$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $af887831bc80f4a5$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($af887831bc80f4a5$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $af887831bc80f4a5$export$3e9cee6b33872309(!$af887831bc80f4a5$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $af887831bc80f4a5$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $af887831bc80f4a5$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $af887831bc80f4a5$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $af887831bc80f4a5$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($af887831bc80f4a5$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $af887831bc80f4a5$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $af887831bc80f4a5$export$e19cd5f9376f8cee.Replace : $af887831bc80f4a5$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $af887831bc80f4a5$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($af887831bc80f4a5$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $af887831bc80f4a5$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $af887831bc80f4a5$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $af887831bc80f4a5$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $af887831bc80f4a5$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $af887831bc80f4a5$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($af887831bc80f4a5$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $af887831bc80f4a5$var$ResultType.redirect,
                response: $af887831bc80f4a5$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $af887831bc80f4a5$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $af887831bc80f4a5$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $af887831bc80f4a5$var$ResultType.error,
                    error: $af887831bc80f4a5$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $af887831bc80f4a5$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $af887831bc80f4a5$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $af887831bc80f4a5$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $af887831bc80f4a5$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $af887831bc80f4a5$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $af887831bc80f4a5$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $af887831bc80f4a5$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $af887831bc80f4a5$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $af887831bc80f4a5$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $af887831bc80f4a5$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $af887831bc80f4a5$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $af887831bc80f4a5$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $af887831bc80f4a5$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $af887831bc80f4a5$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$af887831bc80f4a5$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $af887831bc80f4a5$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $af887831bc80f4a5$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $af887831bc80f4a5$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $af887831bc80f4a5$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $af887831bc80f4a5$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $af887831bc80f4a5$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $af887831bc80f4a5$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $af887831bc80f4a5$export$4d0306f8f6a4585b = Symbol("deferred");
function $af887831bc80f4a5$export$3336b097a6fbc59a(routes, opts) {
    $af887831bc80f4a5$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $af887831bc80f4a5$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $af887831bc80f4a5$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $af887831bc80f4a5$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $af887831bc80f4a5$var$createLocation("", $af887831bc80f4a5$export$fe53371bee54353d(url), null, "default");
        let matches = $af887831bc80f4a5$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$af887831bc80f4a5$var$isValidMethod(method) && method !== "HEAD") {
            let error = $af887831bc80f4a5$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $af887831bc80f4a5$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $af887831bc80f4a5$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $af887831bc80f4a5$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($af887831bc80f4a5$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $af887831bc80f4a5$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $af887831bc80f4a5$var$createLocation("", $af887831bc80f4a5$export$fe53371bee54353d(url), null, "default");
        let matches = $af887831bc80f4a5$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$af887831bc80f4a5$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $af887831bc80f4a5$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $af887831bc80f4a5$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $af887831bc80f4a5$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $af887831bc80f4a5$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $af887831bc80f4a5$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($af887831bc80f4a5$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$af887831bc80f4a5$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $af887831bc80f4a5$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($af887831bc80f4a5$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $af887831bc80f4a5$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $af887831bc80f4a5$var$isResponse(result) ? result : $af887831bc80f4a5$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($af887831bc80f4a5$var$isDataStrategyResult(e) && $af887831bc80f4a5$var$isResponse(e.result)) {
                if (e.type === $af887831bc80f4a5$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($af887831bc80f4a5$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $af887831bc80f4a5$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $af887831bc80f4a5$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $af887831bc80f4a5$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($af887831bc80f4a5$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($af887831bc80f4a5$var$isDeferredResult(result)) {
            let error = $af887831bc80f4a5$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $af887831bc80f4a5$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($af887831bc80f4a5$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($af887831bc80f4a5$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $af887831bc80f4a5$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $af887831bc80f4a5$var$_extends({}, context, {
                statusCode: $af887831bc80f4a5$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $af887831bc80f4a5$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $af887831bc80f4a5$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $af887831bc80f4a5$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $af887831bc80f4a5$var$isErrorResult(pendingActionResult[1]) ? $af887831bc80f4a5$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $af887831bc80f4a5$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $af887831bc80f4a5$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $af887831bc80f4a5$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $af887831bc80f4a5$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $af887831bc80f4a5$var$callDataStrategyImpl(dataStrategy || $af887831bc80f4a5$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($af887831bc80f4a5$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $af887831bc80f4a5$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($af887831bc80f4a5$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $af887831bc80f4a5$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $af887831bc80f4a5$export$fec11da027c70692(routes, context, error) {
    let newContext = $af887831bc80f4a5$var$_extends({}, context, {
        statusCode: $af887831bc80f4a5$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $af887831bc80f4a5$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $af887831bc80f4a5$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $af887831bc80f4a5$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $af887831bc80f4a5$export$cae722b0cc860f13(to ? to : ".", $af887831bc80f4a5$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $af887831bc80f4a5$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $af887831bc80f4a5$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $af887831bc80f4a5$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $af887831bc80f4a5$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $af887831bc80f4a5$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$af887831bc80f4a5$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$af887831bc80f4a5$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $af887831bc80f4a5$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $af887831bc80f4a5$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $af887831bc80f4a5$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$af887831bc80f4a5$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$af887831bc80f4a5$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $af887831bc80f4a5$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $af887831bc80f4a5$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $af887831bc80f4a5$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $af887831bc80f4a5$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $af887831bc80f4a5$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($af887831bc80f4a5$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $af887831bc80f4a5$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $af887831bc80f4a5$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $af887831bc80f4a5$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $af887831bc80f4a5$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $af887831bc80f4a5$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $af887831bc80f4a5$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $af887831bc80f4a5$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $af887831bc80f4a5$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $af887831bc80f4a5$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $af887831bc80f4a5$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($af887831bc80f4a5$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $af887831bc80f4a5$var$shouldRevalidateLoader(match, $af887831bc80f4a5$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $af887831bc80f4a5$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $af887831bc80f4a5$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $af887831bc80f4a5$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $af887831bc80f4a5$var$shouldRevalidateLoader(fetcherMatch, $af887831bc80f4a5$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $af887831bc80f4a5$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $af887831bc80f4a5$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $af887831bc80f4a5$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $af887831bc80f4a5$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $af887831bc80f4a5$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $af887831bc80f4a5$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$af887831bc80f4a5$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $af887831bc80f4a5$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $af887831bc80f4a5$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$af887831bc80f4a5$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $af887831bc80f4a5$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $af887831bc80f4a5$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $af887831bc80f4a5$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$af887831bc80f4a5$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $af887831bc80f4a5$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $af887831bc80f4a5$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $af887831bc80f4a5$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $af887831bc80f4a5$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $af887831bc80f4a5$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $af887831bc80f4a5$var$ResultType.data,
                result: undefined
            });
        };
        return $af887831bc80f4a5$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $af887831bc80f4a5$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $af887831bc80f4a5$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $af887831bc80f4a5$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $af887831bc80f4a5$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $af887831bc80f4a5$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $af887831bc80f4a5$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $af887831bc80f4a5$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($af887831bc80f4a5$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $af887831bc80f4a5$var$ResultType.error,
                error: e
            };
        }
        if (type === $af887831bc80f4a5$var$ResultType.error) return {
            type: $af887831bc80f4a5$var$ResultType.error,
            error: new $af887831bc80f4a5$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $af887831bc80f4a5$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $af887831bc80f4a5$var$ResultType.error) {
        if ($af887831bc80f4a5$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $af887831bc80f4a5$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $af887831bc80f4a5$var$ResultType.error,
                error: new $af887831bc80f4a5$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $af887831bc80f4a5$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $af887831bc80f4a5$var$ResultType.error,
            error: result,
            statusCode: $af887831bc80f4a5$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($af887831bc80f4a5$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $af887831bc80f4a5$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($af887831bc80f4a5$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $af887831bc80f4a5$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $af887831bc80f4a5$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $af887831bc80f4a5$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $af887831bc80f4a5$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$af887831bc80f4a5$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $af887831bc80f4a5$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $af887831bc80f4a5$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($af887831bc80f4a5$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $af887831bc80f4a5$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $af887831bc80f4a5$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($af887831bc80f4a5$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $af887831bc80f4a5$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $af887831bc80f4a5$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $af887831bc80f4a5$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $af887831bc80f4a5$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $af887831bc80f4a5$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $af887831bc80f4a5$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $af887831bc80f4a5$export$3e9cee6b33872309(!$af887831bc80f4a5$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($af887831bc80f4a5$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $af887831bc80f4a5$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $af887831bc80f4a5$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($af887831bc80f4a5$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $af887831bc80f4a5$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $af887831bc80f4a5$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $af887831bc80f4a5$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($af887831bc80f4a5$var$isErrorResult(result)) {
            let boundaryMatch = $af887831bc80f4a5$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $af887831bc80f4a5$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($af887831bc80f4a5$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $af887831bc80f4a5$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($af887831bc80f4a5$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $af887831bc80f4a5$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $af887831bc80f4a5$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $af887831bc80f4a5$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $af887831bc80f4a5$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $af887831bc80f4a5$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $af887831bc80f4a5$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $af887831bc80f4a5$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $af887831bc80f4a5$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $af887831bc80f4a5$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $af887831bc80f4a5$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $af887831bc80f4a5$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($af887831bc80f4a5$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $af887831bc80f4a5$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $af887831bc80f4a5$export$8ccf933b0513f8d0(path) : path;
    return $af887831bc80f4a5$export$fe53371bee54353d($af887831bc80f4a5$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $af887831bc80f4a5$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $af887831bc80f4a5$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $af887831bc80f4a5$var$ResultType.data || result.type === $af887831bc80f4a5$var$ResultType.error);
}
function $af887831bc80f4a5$var$isRedirectDataStrategyResultResult(result) {
    return $af887831bc80f4a5$var$isResponse(result.result) && $af887831bc80f4a5$var$redirectStatusCodes.has(result.result.status);
}
function $af887831bc80f4a5$var$isDeferredResult(result) {
    return result.type === $af887831bc80f4a5$var$ResultType.deferred;
}
function $af887831bc80f4a5$var$isErrorResult(result) {
    return result.type === $af887831bc80f4a5$var$ResultType.error;
}
function $af887831bc80f4a5$var$isRedirectResult(result) {
    return (result && result.type) === $af887831bc80f4a5$var$ResultType.redirect;
}
function $af887831bc80f4a5$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $af887831bc80f4a5$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $af887831bc80f4a5$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $af887831bc80f4a5$var$isRedirectResponse(result) {
    if (!$af887831bc80f4a5$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $af887831bc80f4a5$var$isValidMethod(method) {
    return $af887831bc80f4a5$var$validRequestMethods.has(method.toLowerCase());
}
function $af887831bc80f4a5$var$isMutationMethod(method) {
    return $af887831bc80f4a5$var$validMutationMethods.has(method.toLowerCase());
}
async function $af887831bc80f4a5$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$af887831bc80f4a5$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($af887831bc80f4a5$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $af887831bc80f4a5$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $af887831bc80f4a5$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($af887831bc80f4a5$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $af887831bc80f4a5$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $af887831bc80f4a5$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $af887831bc80f4a5$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $af887831bc80f4a5$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $af887831bc80f4a5$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $af887831bc80f4a5$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $af887831bc80f4a5$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $af887831bc80f4a5$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $af887831bc80f4a5$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $af887831bc80f4a5$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $af887831bc80f4a5$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $af887831bc80f4a5$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $af887831bc80f4a5$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $af887831bc80f4a5$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $af887831bc80f4a5$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $af887831bc80f4a5$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $af887831bc80f4a5$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $af887831bc80f4a5$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($af887831bc80f4a5$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $af887831bc80f4a5$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($af887831bc80f4a5$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $af887831bc80f4a5$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}
 //# sourceMappingURL=router.js.map
module.exports["createMemoryHistory"] = $af887831bc80f4a5$export$2b76ad033c6e6d08;
module.exports["createPath"] = $af887831bc80f4a5$export$fe53371bee54353d;
module.exports["parsePath"] = $af887831bc80f4a5$export$8ccf933b0513f8d0;
module.exports["UNSAFE_invariant"] = $af887831bc80f4a5$export$3e9cee6b33872309;
module.exports["matchRoutes"] = $af887831bc80f4a5$export$2708184779ceb39d;
module.exports["stripBasename"] = $af887831bc80f4a5$export$b69e3301ce081aa3;
module.exports["UNSAFE_decodePath"] = $af887831bc80f4a5$export$30d21fd6d7295f52;
module.exports["UNSAFE_convertRouteMatchToUiMatch"] = $af887831bc80f4a5$export$b3fac024fad9e8ff;
module.exports["joinPaths"] = $af887831bc80f4a5$export$86d9a7913e44197e;
module.exports["matchPath"] = $af887831bc80f4a5$export$81336c211d5ff295;
module.exports["UNSAFE_getResolveToMatches"] = $af887831bc80f4a5$export$a5784978eca585fa;
module.exports["resolveTo"] = $af887831bc80f4a5$export$cae722b0cc860f13;
module.exports["AbortedDeferredError"] = $af887831bc80f4a5$export$42a99a7a4bc0e76a;
module.exports["isRouteErrorResponse"] = $af887831bc80f4a5$export$972111febbeef05b;
module.exports["IDLE_BLOCKER"] = $af887831bc80f4a5$export$386d57f03f0b2883;
module.exports["createRouter"] = $af887831bc80f4a5$export$baddd0131ee8c05b;

});

parcelRegister("b4pEE", function(module, exports) {
const $891a15e6e5cc7b79$export$e63a462ee45b57cf = {
    name: 'EDIT_PAGE_EMBED',
    pattern: '/wiki/spaces/:spaceKey/pages/edit-embed/:contentId/:contentSlug?'
};
const $891a15e6e5cc7b79$export$7b1285e36c635f1f = {
    name: 'EDIT_PAGE_V2',
    pattern: '/wiki/spaces/:spaceKey/pages/edit-v2/:contentId/:contentSlug?'
};
const $891a15e6e5cc7b79$export$65b723bb995d4fb6 = {
    name: 'SPACE_OVERVIEW',
    pattern: '/wiki/spaces/:spaceKey/overview'
};
const $891a15e6e5cc7b79$export$9257b5b55c8e2555 = {
    name: 'VIEW_PAGE',
    pattern: '/wiki/spaces/:spaceKey/pages/:contentId/:contentSlug?'
};
const $891a15e6e5cc7b79$export$91f49e7b30a9d34 = {
    name: 'VIEW_BLOG',
    pattern: '/wiki/spaces/:spaceKey/blog/:contentId/:contentSlug?'
};
const $891a15e6e5cc7b79$export$bd2c9bb170b3681d = {
    name: 'VIEW_BLOG_DATE_LEGACY',
    pattern: '/wiki/spaces/:spaceKey/blog/:year/:month/:day/:contentId/:contentSlug?'
};
const $891a15e6e5cc7b79$export$fbefbcc1445e8d74 = {
    name: 'WHITEBOARD',
    pattern: '/wiki/spaces/:spaceKey/whiteboard/:contentId/:contentSlug?'
};
const $891a15e6e5cc7b79$export$d4971375353d0454 = {
    EDIT_PAGE_EMBED: $891a15e6e5cc7b79$export$e63a462ee45b57cf,
    EDIT_PAGE_V2: $891a15e6e5cc7b79$export$7b1285e36c635f1f,
    SPACE_OVERVIEW: $891a15e6e5cc7b79$export$65b723bb995d4fb6,
    VIEW_PAGE: $891a15e6e5cc7b79$export$9257b5b55c8e2555,
    VIEW_BLOG: $891a15e6e5cc7b79$export$91f49e7b30a9d34,
    VIEW_BLOG_DATE_LEGACY: $891a15e6e5cc7b79$export$bd2c9bb170b3681d,
    WHITEBOARD: $891a15e6e5cc7b79$export$fbefbcc1445e8d74
};
const $891a15e6e5cc7b79$export$5c59aa0922e65f1a = {
    JSM_PORTAL: 'JSM-Portal',
    JSM: 'JSM',
    JSW: 'JSW',
    JWM: 'JWM'
};
module.exports["EDIT_PAGE_EMBED"] = $891a15e6e5cc7b79$export$e63a462ee45b57cf;
module.exports["EDIT_PAGE_V2"] = $891a15e6e5cc7b79$export$7b1285e36c635f1f;
module.exports["VIEW_PAGE"] = $891a15e6e5cc7b79$export$9257b5b55c8e2555;
module.exports["VIEW_BLOG"] = $891a15e6e5cc7b79$export$91f49e7b30a9d34;
module.exports["VIEW_BLOG_DATE_LEGACY"] = $891a15e6e5cc7b79$export$bd2c9bb170b3681d;
module.exports["WHITEBOARD"] = $891a15e6e5cc7b79$export$fbefbcc1445e8d74;
module.exports["namedRoutes"] = $891a15e6e5cc7b79$export$d4971375353d0454;
module.exports["EMBEDDED_PARENT_PRODUCTS"] = $891a15e6e5cc7b79$export$5c59aa0922e65f1a;

});

parcelRegister("hcmVI", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $18678131632c0329$export$6d8905296959d5f5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const [isMediaOpen, setIsMediaOpen] = (0, $cozmU.useState)(false);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (messageEvent)=>{
            const { source: source, event: event } = messageEvent.data ?? {};
            if (!source || !event) return;
            if (source === "media") bb15: switch(event){
                case "mediaViewerOpened":
                    setIsMediaOpen(true);
                    break bb15;
                case "mediaViewerClosed":
                    setIsMediaOpen(false);
                    break bb15;
                default:
                    return;
            }
        };
        $[0] = t0;
    } else t0 = $[0];
    const mediaMessageListener = t0;
    let t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            window.addEventListener("message", mediaMessageListener);
            return ()=>window.removeEventListener("message", mediaMessageListener);
        };
        t2 = [
            mediaMessageListener
        ];
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] !== isMediaOpen) {
        t3 = {
            isMediaOpen: isMediaOpen
        };
        $[3] = isMediaOpen;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ()=>{
    const [isMediaOpen, setIsMediaOpen] = (0, $cozmU.useState)(false);
    const mediaMessageListener = (0, $cozmU.useCallback)((messageEvent)=>{
        const { source: source, event: event } = messageEvent.data ?? {};
        if (!source || !event) return;
        if (source === 'media') switch(event){
            case 'mediaViewerOpened':
                setIsMediaOpen(true);
                break;
            case 'mediaViewerClosed':
                setIsMediaOpen(false);
                break;
            default:
                return;
        }
    }, [
        setIsMediaOpen
    ]);
    (0, $cozmU.useEffect)(()=>{
        window.addEventListener('message', mediaMessageListener);
        return ()=>window.removeEventListener('message', mediaMessageListener);
    }, [
        mediaMessageListener
    ]);
    return {
        isMediaOpen: isMediaOpen
    };
};
module.exports["useMediaViewerListener"] = $18678131632c0329$export$6d8905296959d5f5;

});


$parcel$global.rlb("bMNgp")
//# sourceMappingURL=component-lazy.cb521ec1.js.map
